// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Immersive mode: lock viewport, prevent browser scroll chrome on live training */
html.lt-immersive,
html.lt-immersive body {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
}

html.lt-immersive body {
  background: #0f172a;
}

html.lt-immersive.lt-coach-live {
  --lt-coach-bar-reserve: calc(56px + env(safe-area-inset-bottom));
}

html.lt-immersive.lt-coach-live:has(.lt-coach-bar__seq-nav) {
  --lt-coach-bar-reserve: calc(92px + env(safe-area-inset-bottom));
}

html:fullscreen .lt-page,
html:-webkit-full-screen .lt-page {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}

.lt-page {
  position: relative;
  min-height: 100svh;
  min-height: 100dvh;
  height: 100svh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(165deg, #0f172a 0%, #1e293b 45%, #0f172a 100%);
  color: #f8fafc;
  overflow: hidden;
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
  /* Size queries use the visual-viewport-sized page box, not 100vh media. */
  container-type: size;
  container-name: lt-page;
}

/* MUI Dialogs portaled into \`.lt-page\` must sit above the plan sheet (4200). */
.lt-page > .MuiModal-root,
.lt-page > .MuiDialog-root {
  z-index: 5000;
}

.lt-page:has(.lt-coach-bar-wrap) {
  padding-bottom: 0;
}

html.lt-immersive .lt-page {
  position: fixed;
  top: var(--lt-vvt, 0px);
  left: var(--lt-vvl, 0px);
  right: auto;
  bottom: auto;
  width: var(--lt-vvw, 100%);
  max-width: var(--lt-vvw, 100%);
  height: var(--lt-vvh, 100svh);
  min-height: var(--lt-vvh, 100svh);
  max-height: var(--lt-vvh, 100svh);
  box-sizing: border-box;
}

html.lt-immersive.lt-player-live,
html.lt-immersive.lt-player-live body,
html.lt-immersive.lt-coach-live,
html.lt-immersive.lt-coach-live body {
  height: var(--lt-vvh, 100svh);
  width: var(--lt-vvw, 100%);
  max-width: 100%;
  overflow: hidden;
}

html.lt-immersive.lt-player-live .lt-page,
html.lt-immersive.lt-coach-live .lt-page {
  height: var(--lt-vvh, 100svh);
  max-height: var(--lt-vvh, 100svh);
  width: var(--lt-vvw, 100%);
  max-width: var(--lt-vvw, 100%);
  padding-top: env(safe-area-inset-top, 0px);
}

html:fullscreen.lt-player-live .lt-page,
html:-webkit-full-screen.lt-player-live .lt-page,
.lt-page:fullscreen,
.lt-page:-webkit-full-screen {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: none !important;
}

/* iOS Safari and iOS Chrome reject document fullscreen and will not collapse
   the URL bar while html/body are position:fixed and overflow:hidden.
   Keep the document 2px scrollable so a tap can scroll the toolbar away, and
   pin the training UI to the visual viewport. */
html.lt-ios-phone.lt-immersive,
html.lt-ios-phone.lt-immersive body,
html.lt-ios-phone.lt-immersive.lt-player-live,
html.lt-ios-phone.lt-immersive.lt-player-live body {
  position: relative;
  inset: auto;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  height: auto;
  min-height: calc(100lvh + 2px);
  width: var(--lt-vvw, 100%);
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior: none;
}

html.lt-ios-phone.lt-immersive .lt-page {
  position: fixed;
  top: var(--lt-vvt, 0px);
  left: var(--lt-vvl, 0px);
  width: var(--lt-vvw, 100%);
  max-width: var(--lt-vvw, 100%);
  height: var(--lt-vvh, 100dvh);
  min-height: 0;
  max-height: var(--lt-vvh, 100dvh);
}

/* Landscape player: keep body/actions inside the remaining visual viewport. */
html.lt-immersive.lt-player-live .lt-page--landscape {
  overflow: hidden;
}

html.lt-immersive.lt-player-live .lt-page--landscape .lt-page__body {
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
}

html[data-pingflo-tour="1"] .lt-fs-gate {
  display: none !important;
}

.lt-fs-gate {
  position: fixed;
  left: 50%;
  /* Sit near the bottom of the visible viewport (accounts for browser chrome). */
  top: calc(var(--lt-vvt, 0px) + var(--lt-vvh, 100dvh) - 72px);
  bottom: auto;
  z-index: 4000;
  display: inline-flex;
  width: max-content;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #f8fafc;
  cursor: pointer;
  transform: translateX(-50%);
  animation: lt-fs-gate-in 0.35s cubic-bezier(0.25, 1, 0.5, 1);
  max-width: calc(var(--lt-vvw, 100vw) - 24px);
  touch-action: manipulation;
}

@keyframes lt-fs-gate-in {
  from {
    opacity: 0;
    transform: translate(-50%, 10px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.lt-fs-gate__label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 22px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--lt-brand, #0877bc) 0%, #065a8f 100%);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
  font-size: 15px;
  font-weight: 650;
  letter-spacing: 0.01em;
}

.lt-page--loading {
  align-items: center;
  justify-content: center;
}

.lt-page--mobile-only {
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}

.lt-mobile-only {
  width: min(420px, 100%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  padding: 28px 24px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(16px);
}

.lt-mobile-only__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.lt-mobile-only__copy {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.5;
  color: rgba(248, 250, 252, 0.82);
}

.lt-mobile-only__btn {
  margin-top: 6px;
  padding: 11px 18px;
  border: none;
  border-radius: 12px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.lt-mobile-only__btn:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 20px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);
}

.lt-mobile-only__btn:active {
  transform: scale(0.97);
}

.lt-mobile-only__btn:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.lt-page--landscape .lt-page__body {
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
}

.lt-page--landscape .lt-page__main {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.lt-page--landscape .lt-page__actions {
  width: auto;
  border-left: none;
  padding: 0;
  justify-content: flex-end;
}

/* Header */
.lt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  gap: 12px;
  flex-shrink: 0;
}

.lt-header__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.lt-header__icon {
  color: var(--lt-brand, #0877bc);
  font-size: 28px !important;
  width: 28px;
  height: 28px;
}

/* Club logo — shared live training branding */
.lt-club-logo-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lt-club-logo {
  display: block;
  object-fit: contain;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  padding: 2px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.22);
}

.lt-club-logo--sm {
  width: clamp(26px, 5vh, 34px);
  height: clamp(26px, 5vh, 34px);
}

.lt-club-logo--md {
  width: clamp(32px, 6vh, 44px);
  height: clamp(32px, 6vh, 44px);
}

.lt-club-logo--lg {
  width: clamp(44px, 9vh, 64px);
  height: clamp(44px, 9vh, 64px);
  border-radius: 12px;
  padding: 4px;
}

.lt-club-logo-wrap--bar {
  height: 100%;
  align-self: stretch;
}

.lt-club-logo--bar {
  height: 100%;
  width: auto;
  max-height: 52px;
  min-height: 34px;
  aspect-ratio: 1;
  object-fit: contain;
}

.lt-club-logo-wrap__name {
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.82);
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-header__club-logo {
  flex-shrink: 0;
}

.lt-return-fab__icon {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}

.lt-header__titles {
  min-width: 0;
}

.lt-header__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-header__title-num {
  color: var(--lt-brand, var(--brand-primary, #0877bc));
}

.lt-header__sub {
  font-size: 0.75rem;
  color: rgba(248, 250, 252, 0.65);
}

.lt-header__home-btn,
.lt-header__dashboard-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-header__home-btn:active,
.lt-header__dashboard-btn:active {
  transform: scale(0.97);
}

/* Landscape: icon-only home (matches prior isLandscape behavior) */
.lt-page--landscape .lt-header__home-label {
  display: none;
}

.lt-page--landscape .lt-header__home-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  justify-content: center;
  gap: 0;
}

/* Mobile: home icon only — keep session # visible in the title */
@media (max-width: 768px) {
  .lt-header__home-label {
    display: none;
  }

  .lt-header__home-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
    gap: 0;
  }

  .lt-header__title {
    font-size: 0.92rem;
  }

  .lt-header__title-num {
    font-weight: 800;
  }
}

.lt-header__actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lt-header__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-header__icon-btn:disabled {
  opacity: 0.65;
  cursor: wait;
}

.lt-header__icon-btn:active:not(:disabled) {
  transform: scale(0.97);
}

.lt-header__icon-btn--spinning svg {
  animation: lt-refresh-spin 0.8s linear infinite;
}

.lt-hero__type-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  margin: 0 0 6px;
  min-width: 0;
}

.lt-hero__type {
  font-size: clamp(0.9rem, 2.4vh, 1.1rem);
  font-weight: 750;
  letter-spacing: -0.02em;
  color: #f8fafc;
  min-width: 0;
  max-width: min(100%, 14rem);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-hero__assign {
  flex-shrink: 0;
  border: 0;
  border-radius: 999px;
  padding: 5px 10px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
}

.lt-hero__assign:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__type-row {
  margin-bottom: 4px;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__type {
  font-size: clamp(0.86rem, 2.2vh, 1.05rem);
}

/* Progress */
.lt-progress {
  padding: 0 16px 12px;
  flex-shrink: 0;
}

.lt-progress__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  margin-bottom: 6px;
  color: rgba(248, 250, 252, 0.75);
  gap: 8px;
}

.lt-progress__meta-right {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.lt-progress__plan-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  border-radius: 999px;
  padding: 3px 10px 3px 6px;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.lt-progress__plan-btn:active {
  transform: scale(0.97);
}

.lt-progress__track {
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;
}

.lt-progress__fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--lt-brand, #0877bc), #22c55e);
  transition: width 0.4s ease;
}

.lt-progress__segments {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.lt-progress__segments--named {
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.lt-progress__segments--named::-webkit-scrollbar {
  display: none;
}

.lt-progress__seg {
  flex: 1 1;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.1);
}

.lt-progress__seg--named {
  flex: 0 0 auto;
  min-width: 36px;
  max-width: 48px;
  height: auto;
  min-height: 28px;
  padding: 4px 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-progress__seg-label {
  font-size: 0.8rem;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: rgba(248, 250, 252, 0.85);
  white-space: nowrap;
}

.lt-progress__seg--done {
  background: #22c55e;
}

.lt-progress__seg--named.lt-progress__seg--done {
  background: color-mix(in srgb, #22c55e 35%, rgba(15, 23, 42, 0.9));
  border-color: rgba(34, 197, 94, 0.45);
}

.lt-progress__seg--current {
  background: var(--lt-brand, #0877bc);
  box-shadow: 0 0 8px var(--lt-brand, #0877bc);
}

.lt-progress__seg--named.lt-progress__seg--current {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #0f172a);
  border-color: var(--lt-brand, #0877bc);
  box-shadow: 0 0 10px color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);
}

.lt-progress__seg--named.lt-progress__seg--current .lt-progress__seg-label {
  color: #fff;
  font-size: 0.95rem;
}

button.lt-progress__seg {
  appearance: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
}

button.lt-progress__seg.lt-progress__seg--named {
  padding: 4px 0;
  height: auto;
  min-height: 28px;
}

.lt-progress__seg--review {
  cursor: pointer;
  min-height: 8px;
  height: 8px;
  transition: filter 0.18s ease, transform 0.18s ease;
}

.lt-progress__seg--named.lt-progress__seg--review {
  height: auto;
  min-height: 28px;
}

.lt-progress__seg--review:hover {
  filter: brightness(1.25);
  transform: scaleY(1.35);
}

.lt-progress__seg--review:focus-visible {
  outline: 2px solid #22c55e;
  outline-offset: 2px;
}

.lt-progress__seg--select {
  cursor: pointer;
  min-height: 8px;
  height: 8px;
  transition: filter 0.18s ease, transform 0.18s ease;
}

.lt-progress__seg--select:hover {
  filter: brightness(1.2);
  transform: scaleY(1.35);
}

.lt-progress__seg--select:focus-visible {
  outline: 2px solid var(--lt-brand, #0877bc);
  outline-offset: 2px;
}

/* Station tabs — coach switches between training stations */
.lt-station-tabs {
  display: flex;
  gap: 8px;
  padding: 0 16px 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  flex-shrink: 0;
}

.lt-station-tabs::-webkit-scrollbar {
  display: none;
}

.lt-station-tabs__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 7px 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(248, 250, 252, 0.88);
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
}

.lt-station-tabs__btn--selected {
  border-color: var(--lt-station-accent, var(--lt-brand, #0877bc));
  background: color-mix(
    in srgb,
    var(--lt-station-accent, var(--lt-brand, #0877bc)) 28%,
    transparent
  );
  color: #fff;
}

.lt-station-tabs__btn--live {
  box-shadow: 0 0 0 1px color-mix(in srgb, #22c55e 55%, transparent);
}

.lt-station-tabs__btn--done {
  opacity: 0.7;
}

.lt-station-tabs__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--lt-station-accent, var(--lt-brand, #0877bc));
}

.lt-station-tabs__live {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4ade80;
}

.lt-hero__station {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.65);
}

/* Body */
.lt-page__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
}

.lt-page__body--kot-player {
  overflow: hidden;
}

/* KoT arena has its own footer actions — keep FABs out of the way in landscape */
.lt-page--landscape:has(.lt-page__body--kot-player) .lt-page__actions {
  top: auto;
  bottom: calc(6px + env(safe-area-inset-bottom));
  right: 8px;
}

.lt-page--landscape:has(.lt-page__body--kot-player) .lt-page__fab {
  width: 40px;
  height: 40px;
}

.lt-page__main {
  flex: 1 1;
  padding: 8px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.lt-page__main:has(.lt-coach-dash) {
  align-items: stretch;
  min-height: 0;
  padding-bottom: 12px;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero {
  flex-shrink: 1;
}

.lt-page__error {
  color: #fca5a5;
  font-size: 0.875rem;
  text-align: center;
}

/* Session complete overlay */
.lt-session-complete-overlay {
  position: fixed;
  inset: 0;
  z-index: 1150;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)
    env(safe-area-inset-left);
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(6px);
}

.lt-session-complete {
  position: relative;
  width: min(100%, 420px);
  text-align: center;
  padding: 28px 20px 24px;
}

.lt-session-complete__glow {
  position: absolute;
  inset: 10% 5%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(34, 197, 94, 0.22), transparent 70%);
  pointer-events: none;
}

.lt-session-complete__club-logo {
  margin-bottom: 12px;
}

.lt-session-complete__icon {
  font-size: 3rem !important;
  color: #4ade80;
  margin-bottom: 8px;
}

.lt-session-complete__title {
  margin: 0 0 10px;
  font-size: 1.35rem;
  font-weight: 800;
  color: #f8fafc;
}

.lt-session-complete__message {
  margin: 0 0 22px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(248, 250, 252, 0.78);
}

.lt-session-complete__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  padding: 13px 20px;
  border: none;
  border-radius: 999px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.35);
}

.lt-session-complete__btn:hover {
  filter: brightness(1.06);
}

/* Session decision (finalize vs add exercise) */
.lt-session-decision {
  position: relative;
  width: min(100%, 420px);
  text-align: center;
  padding: 28px 20px 24px;
}

.lt-session-decision__glow {
  position: absolute;
  inset: 10% 5%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(8, 119, 188, 0.28), transparent 70%);
  pointer-events: none;
}

.lt-session-decision__club-logo {
  margin-bottom: 12px;
}

.lt-session-decision__icon {
  font-size: 3rem !important;
  color: #38bdf8;
  margin-bottom: 8px;
}

.lt-session-decision__title {
  margin: 0 0 10px;
  font-size: 1.35rem;
  font-weight: 800;
  color: #f8fafc;
}

.lt-session-decision__message {
  margin: 0 0 22px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(248, 250, 252, 0.78);
}

.lt-session-decision__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: stretch;
}

.lt-session-decision__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 13px 20px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  border: none;
  transition: transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;
}

.lt-session-decision__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.lt-session-decision__btn:not(:disabled):hover {
  filter: brightness(1.06);
}

.lt-session-decision__btn:not(:disabled):active {
  transform: scale(0.98);
}

.lt-session-decision__btn--primary {
  background: var(--lt-brand, #0877bc);
  color: #fff;
  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.35);
}

.lt-session-decision__btn--secondary {
  background: rgba(248, 250, 252, 0.08);
  color: #f8fafc;
  border: 1px solid rgba(248, 250, 252, 0.18);
}

/* Add exercise wizard (live) */
.lt-add-ex-dialog__paper {
  background: #0f172a !important;
  color: #f8fafc;
  border-radius: 18px !important;
  border: 1px solid rgba(248, 250, 252, 0.1);
  overflow: hidden;
}

.lt-add-ex-dialog__header {
  padding: 14px 16px 8px;
  border-bottom: 1px solid rgba(248, 250, 252, 0.08);
}

.lt-add-ex-dialog__header-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lt-add-ex-dialog__title {
  flex: 1 1;
  margin: 0;
  font-size: 1.05rem;
  font-weight: 750;
  text-align: center;
  color: #f8fafc;
}

.lt-add-ex-dialog__breadcrumb {
  margin: 6px 0 0;
  font-size: 0.8rem;
  color: rgba(248, 250, 252, 0.55);
  text-align: center;
}

.lt-add-ex-dialog__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: rgba(248, 250, 252, 0.06);
  color: #f8fafc;
  cursor: pointer;
}

.lt-add-ex-dialog__icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-add-ex-dialog__icon-btn-spacer {
  width: 36px;
  height: 36px;
}

.lt-add-ex-dialog__body {
  min-height: 220px;
  max-height: min(60vh, 480px);
  overflow: auto;
  padding: 12px 14px 16px;
}

.lt-add-ex-dialog__loader {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.lt-add-ex-dialog__error {
  margin: 0 0 10px;
  color: #fca5a5;
  font-size: 0.875rem;
  text-align: center;
}

.lt-add-ex-dialog__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-add-ex-dialog__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(248, 250, 252, 0.1);
  background: rgba(248, 250, 252, 0.04);
  color: #f8fafc;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
}

.lt-add-ex-dialog__item:hover {
  background: rgba(8, 119, 188, 0.18);
  border-color: rgba(56, 189, 248, 0.35);
}

.lt-add-ex-dialog__item:active {
  transform: scale(0.99);
}

.lt-add-ex-dialog__item--active {
  background: rgba(8, 119, 188, 0.28);
  border-color: var(--lt-brand, #0877bc);
}

.lt-add-ex-dialog__item-name {
  flex: 1 1;
}

.lt-add-ex-dialog__item-meta {
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(248, 250, 252, 0.55);
  white-space: nowrap;
}

.lt-add-ex-dialog__item-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.lt-add-ex-dialog__item-row--active {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #94a3b8);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, transparent);
}

.lt-add-ex-dialog__item-row .lt-add-ex-dialog__item {
  border: 0;
  border-radius: 0;
  background: transparent;
}

.lt-add-ex-dialog__prefs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 8px 8px;
}

.lt-add-ex-dialog__fav {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #94a3b8;
  background: rgba(148, 163, 184, 0.12);
  cursor: pointer;
}

.lt-add-ex-dialog__fav.is-on {
  color: #f59e0b;
  background: color-mix(in srgb, #f59e0b 18%, transparent);
}

.lt-add-ex-dialog__rating {
  display: inline-flex;
  gap: 2px;
}

.lt-add-ex-dialog__rate {
  min-width: 26px;
  height: 26px;
  border: 0;
  border-radius: 6px;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  background: rgba(148, 163, 184, 0.14);
  cursor: pointer;
}

.lt-add-ex-dialog__rate.is-on {
  color: #fff;
  background: var(--lt-brand, #0877bc);
}

.lt-add-ex-dialog__duration {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(248, 250, 252, 0.05);
}

.lt-add-ex-dialog__duration label {
  font-size: 0.875rem;
  color: rgba(248, 250, 252, 0.8);
}

.lt-add-ex-dialog__duration input {
  width: 88px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(248, 250, 252, 0.16);
  background: #0b1220;
  color: #f8fafc;
  font-weight: 600;
}

.lt-add-ex-dialog__footer {
  padding: 12px 14px 16px;
  border-top: 1px solid rgba(248, 250, 252, 0.08);
}

.lt-add-ex-dialog__add-btn {
  width: 100%;
  padding: 13px 18px;
  border: none;
  border-radius: 12px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.3);
}

.lt-add-ex-dialog__add-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.lt-add-ex-dialog__add-btn:not(:disabled):hover {
  filter: brightness(1.06);
}

/* Waiting room */
.lt-waiting {
  text-align: center;
  padding: 32px 16px;
  position: relative;
}

.lt-waiting__pulse {
  position: absolute;
  inset: 20% 15%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25), transparent 70%);
  animation: lt-pulse 2.5s ease-in-out infinite;
}

@keyframes lt-pulse {
  0%,
  100% {
    transform: scale(0.95);
    opacity: 0.6;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}

.lt-waiting__club-logo {
  margin-bottom: 14px;
}

.lt-waiting__club-logo .lt-club-logo-wrap__name {
  display: block;
  text-align: center;
  max-width: 200px;
  margin-top: 6px;
  font-size: 0.85rem;
}

.lt-waiting__icon {
  font-size: 48px !important;
  color: var(--lt-brand, #0877bc);
  margin-bottom: 12px;
}

.lt-waiting__title {
  font-size: 1.25rem;
  margin: 0 0 8px;
}

.lt-waiting__hint {
  color: rgba(248, 250, 252, 0.7);
  font-size: 0.875rem;
  margin: 0 0 20px;
}

.lt-waiting__countdown {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 24px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-waiting__countdown-value {
  font-size: 1.75rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #fbbf24;
}

.lt-waiting__table-card {
  margin-top: 24px;
  padding: 16px 28px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
}

.lt-waiting__table-num {
  font-size: 1.5rem;
  font-weight: 800;
}

/* Exercise hero */
.lt-hero {
  width: 100%;
  max-width: 360px;
  text-align: center;
}

.lt-hero__ring-wrap {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto 20px;
}

.lt-hero__ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.lt-hero__ring-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.1);
  stroke-width: 8;
}

.lt-hero__ring-progress {
  fill: none;
  stroke: var(--lt-brand, #0877bc);
  stroke-width: 8;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s linear;
}

.lt-hero--urgent .lt-hero__ring-progress {
  stroke: #ef4444;
  animation: lt-ring-urgent 1s ease-in-out infinite;
}

@keyframes lt-ring-urgent {
  50% {
    stroke-opacity: 0.5;
  }
}

.lt-hero__timer {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.lt-hero__timer-value {
  font-size: 2rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.lt-hero__timer-state {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #22c55e;
}

.lt-hero--paused .lt-hero__timer-state {
  color: #fbbf24;
}

.lt-hero__name {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 6px;
  padding: 0 8px;
  line-height: 1.3;
  max-width: 100%;
}

.lt-hero__name--coach-tap {
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  border-radius: 8px;
  touch-action: manipulation;
}

.lt-hero__name--coach-tap:active {
  background: rgba(255, 255, 255, 0.08);
}

.lt-hero__schema {
  margin: 0 0 12px;
  padding: 0 8px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.lt-hero__number {
  margin-right: 0.28em;
  color: #fcd34d;
  font-weight: 900;
}

/* Coach KoT gameplay params (live training) */
.lt-kot-coach-params {
  margin: 0 16px 14px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(251, 191, 36, 0.06);
  border: 1px solid rgba(251, 191, 36, 0.22);
}

.lt-kot-coach-params__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.lt-kot-coach-params__label {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fcd34d;
}

.lt-kot-coach-params__saved {
  font-size: 0.72rem;
  font-weight: 700;
  color: #4ade80;
}

.lt-kot-coach-params__toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 10px;
}

.lt-kot-coach-params__toggle--disabled {
  opacity: 0.65;
}

.lt-kot-coach-params__mode {
  min-height: 44px;
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(15, 23, 42, 0.55);
  color: rgba(248, 250, 252, 0.88);
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.lt-kot-coach-params__mode:disabled {
  cursor: not-allowed;
}

.lt-kot-coach-params__mode--active {
  background: rgba(8, 119, 188, 0.35);
  border-color: rgba(125, 211, 252, 0.55);
  color: #f8fafc;
  box-shadow: inset 0 0 0 1px rgba(125, 211, 252, 0.2);
}

.lt-kot-coach-params__pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.lt-kot-coach-params__pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  white-space: nowrap;
}

.lt-kot-coach-params__pill--round {
  background: rgba(8, 119, 188, 0.2);
  color: #7dd3fc;
  border: 1px solid rgba(8, 119, 188, 0.35);
}

.lt-kot-coach-params__pill--rule {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(248, 250, 252, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-kot-coach-params__error {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: #fca5a5;
}

.lt-hero__sequences {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.lt-hero__seq-pill {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid transparent;
}

.lt-hero__seq-pill--active {
  border-color: var(--lt-brand, #0877bc);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);
}

.lt-hero__seq-pill--done {
  background: #22c55e;
  color: #052e16;
}

.lt-hero__matchup {
  font-size: 0.875rem;
  color: rgba(248, 250, 252, 0.8);
}

.lt-hero__table {
  font-weight: 700;
  color: #fbbf24;
}

/* Between-sequences banner (coach view) */
.lt-hero__seq-banner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.18);
  border: 1px solid rgba(34, 197, 94, 0.45);
  color: #4ade80;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

/* Ring colour: green when between sequences */
.lt-hero--between-seq .lt-hero__ring-progress {
  stroke: #22c55e;
}

/* Ring colour: muted when idle (exercise not started) */
.lt-hero--idle .lt-hero__ring-progress {
  stroke: rgba(255, 255, 255, 0.2);
  stroke-dashoffset: 326.7; /* full empty ring */
}

.lt-hero--kot-round .lt-hero__ring-progress {
  stroke: #38bdf8;
}

.lt-hero__exercise-remaining {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: -8px auto 16px;
  padding: 5px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 0.72rem;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.72);
}

.lt-hero__exercise-remaining-label {
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.lt-hero__exercise-remaining-value {
  font-size: 0.82rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #f8fafc;
}

.lt-hero__exercise-remaining--urgent {
  border-color: rgba(239, 68, 68, 0.45);
  background: rgba(239, 68, 68, 0.12);
}

.lt-hero__exercise-remaining--urgent .lt-hero__exercise-remaining-value {
  color: #fca5a5;
}

/* State label variants */
.lt-hero__timer-state--ex {
  color: #4ade80;
}
.lt-hero__timer-state--idle {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.65rem;
}

/* "Start next sequence" button — full-width, stands out */
.lt-coach-bar__btn--next-seq {
  flex: 1 1 100%;
  font-size: 0.9rem;
  padding: 12px 10px;
  background: #16a34a;
  border-color: transparent;
  box-shadow: 0 4px 16px rgba(22, 163, 74, 0.4);
}
.lt-coach-bar__btn--next-seq:active {
  transform: scale(0.97);
}

.lt-coach-bar__btn--auto-pause {
  flex: 1 1 100%;
  font-size: 0.88rem;
  font-weight: 800;
  padding: 12px 10px;
  text-align: center;
  border-radius: 12px;
  background: rgba(251, 191, 36, 0.18);
  border: 1px solid rgba(251, 191, 36, 0.55);
  color: #fbbf24;
  font-variant-numeric: tabular-nums;
}

/* Actions — camera / settings / Digiping stack.
   Absolute inside .lt-page so the column stays in the visual viewport when the
   browser bar does not hide (e.g. Oppo). Fixed + bottom would climb off-screen. */
.lt-page__actions {
  position: absolute;
  right: max(10px, env(safe-area-inset-right, 0px));
  bottom: max(10px, env(safe-area-inset-bottom, 0px));
  z-index: 1050;
  padding: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  max-height: calc(100% - 12px);
  overflow-x: visible;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.lt-page__actions::-webkit-scrollbar {
  display: none;
}

.lt-page--landscape .lt-page__actions {
  right: max(8px, env(safe-area-inset-right, 0px));
  bottom: max(8px, env(safe-area-inset-bottom, 0px));
}

.lt-page__fab {
  position: relative;
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  padding: 0;
  border-radius: 50%;
  border: none;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
}

/* Short visual viewport (browser chrome still visible): shrink the FAB column
   so camera setup above Digiping stays on screen. */
@container lt-page (max-height: 640px) {
  .lt-page__actions {
    gap: 6px;
  }

  .lt-page__actions .lt-page__fab {
    width: 42px;
    height: 42px;
  }
}

@container lt-page (max-height: 520px) {
  .lt-page__actions {
    gap: 4px;
  }

  .lt-page__actions .lt-page__fab {
    width: 36px;
    height: 36px;
  }

  .lt-page__actions .lt-page__fab svg {
    font-size: 1.1rem;
  }
}

@container lt-page (max-height: 400px) {
  .lt-page__actions {
    gap: 3px;
    /* Horizontal pack when the column cannot fit vertically. */
    flex-direction: row-reverse;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: flex-start;
    max-width: min(100% - 16px, 220px);
  }

  .lt-page__actions .lt-page__fab {
    width: 34px;
    height: 34px;
  }
}

.lt-page__fab:active {
  transform: scale(0.94);
}

.lt-page__fab--digiping {
  border: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #fff);
  background: radial-gradient(
    circle at 30% 25%,
    color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent),
    color-mix(in srgb, var(--lt-brand, #0877bc) 92%, #0b0f19) 55%,
    #065a8f
  );
  box-shadow:
    0 8px 22px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent),
    0 0 16px color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);
}

.lt-page__fab--refresh {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
}

.lt-page__fab--refresh:disabled {
  opacity: 0.65;
  cursor: wait;
}

.lt-page__fab--spinning svg {
  animation: lt-refresh-spin 0.8s linear infinite;
}

@keyframes lt-refresh-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.lt-page__kot-hint {
  margin-top: 20px;
  padding: 12px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.2), rgba(245, 158, 11, 0.1));
  border: 1px solid rgba(251, 191, 36, 0.35);
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 360px;
}

.lt-page__kot-btn {
  padding: 8px 16px;
  border-radius: 999px;
  border: none;
  background: #fbbf24;
  color: #422006;
  font-weight: 700;
  cursor: pointer;
}

/* Coach bar — fixed above table-setting overlays */
.lt-coach-bar-wrap {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 1600;
  pointer-events: none;
}

.lt-coach-bar-wrap > * {
  pointer-events: auto;
}

.lt-coach-bar-chrome {
  display: flex;
  flex-direction: column;
  background: rgba(15, 23, 42, 0.95);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-page--landscape .lt-coach-bar-chrome {
  border-top: none;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  min-height: 0;
}

.lt-coach-bar__seq-nav {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 7px 14px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-page--landscape .lt-coach-bar__seq-nav {
  padding: 8px 12px;
}

.lt-coach-bar__seq-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0;
  min-width: 0;
  font-size: 13px;
  line-height: 1.3;
  color: #f8fafc;
}

.lt-coach-bar__seq-kicker {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(186, 230, 253, 0.92);
}

.lt-coach-bar__seq-value {
  min-width: 0;
  font-weight: 700;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-break: break-word;
}

.lt-coach-bar__seq-row--next {
  color: rgba(248, 250, 252, 0.92);
}

.lt-coach-bar__seq-row--next .lt-coach-bar__seq-kicker {
  color: #7dd3fc;
}

.lt-page:not(.lt-page--landscape) .lt-coach-bar-wrap {
  position: relative;
  flex-shrink: 0;
  left: auto;
  right: auto;
  bottom: auto;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.42);
}

.lt-page--landscape .lt-coach-bar-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 200px;
  justify-content: flex-end;
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.32);
}

.lt-page:not(.lt-page--landscape):has(.lt-coach-bar-wrap) .lt-page__body {
  overflow: hidden;
  padding-bottom: 0;
}

.lt-page:not(.lt-page--landscape):has(.lt-coach-bar-wrap) .lt-page__main {
  overflow: hidden;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero {
  flex: 0 1 auto;
  max-width: min(360px, 100%);
  margin: 0 auto;
  width: 100%;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__ring-wrap {
  width: clamp(96px, 22vh, 148px);
  height: clamp(96px, 22vh, 148px);
  margin: 0 auto 10px;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__timer-value {
  font-size: clamp(1.35rem, 4.2vh, 1.85rem);
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__name {
  font-size: clamp(0.9rem, 2.4vh, 1.1rem);
  margin-bottom: 6px;
}

.lt-page__main:has(.lt-coach-dash) .lt-hero__sequences {
  margin-top: 6px;
  gap: 4px;
}

.lt-page__main:has(.lt-coach-dash) .lt-coach-dash {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.lt-page--landscape:has(.lt-coach-bar-wrap) .lt-page__body {
  padding-right: 200px;
}

.lt-coach-bar__error {
  margin: 0;
  padding: 8px 16px;
  background: rgba(127, 29, 29, 0.85);
  color: #fecaca;
  font-size: 0.8rem;
  text-align: center;
  border-top: 1px solid rgba(239, 68, 68, 0.4);
}

.lt-coach-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 12px;
  background: transparent;
  border-top: none;
  flex-shrink: 0;
}

.lt-page:not(.lt-page--landscape) .lt-coach-bar {
  position: relative;
  bottom: auto;
  padding-bottom: max(10px, env(safe-area-inset-bottom));
}

.lt-page--landscape .lt-coach-bar {
  flex-direction: column;
  border-top: none;
  border-left: none;
  width: 200px;
  justify-content: center;
  padding-bottom: max(10px, env(safe-area-inset-bottom));
}

.lt-coach-bar__btn {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 8px);
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 8px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
  cursor: pointer;
}

.lt-coach-bar__btn svg {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.lt-coach-bar__btn--primary {
  background: var(--lt-brand, #0877bc);
  border-color: transparent;
}

.lt-coach-bar__btn--danger {
  background: rgba(239, 68, 68, 0.25);
  border-color: rgba(239, 68, 68, 0.5);
}

.lt-coach-bar__btn--skip {
  background: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.5);
  color: #fde68a;
}

.lt-coach-bar__btn--skip:active {
  transform: scale(0.97);
}

.lt-coach-bar__btn--kot-stop {
  background: rgba(245, 124, 0, 0.22);
  border-color: rgba(245, 124, 0, 0.55);
  color: #ffedd5;
}

/* Sheets */
.lt-sheet-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1600;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}

.lt-page--landscape .lt-sheet-backdrop {
  align-items: center;
  padding-top: max(8px, env(safe-area-inset-top));
  padding-bottom: max(8px, env(safe-area-inset-bottom));
}

.lt-sheet {
  width: 100%;
  max-width: min(480px, 100%);
  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #1e293b;
  border-radius: 20px 20px 0 0;
  padding: 16px 16px max(16px, env(safe-area-inset-bottom, 0px));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.lt-page--landscape .lt-sheet {
  border-radius: 20px;
  max-height: min(88dvh, calc(100dvh - 24px));
}

.lt-sheet.lt-ae {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
}

.lt-ae__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.lt-ae__footer {
  flex: 0 0 auto;
  padding-top: 8px;
  background: #1e293b;
}

.lt-ae__error {
  margin: 8px 0 0;
  color: #fca5a5;
  font-size: 0.82rem;
}

.lt-sheet__title {
  margin: 0 0 4px;
  font-size: 1.125rem;
}

.lt-sheet__subtitle {
  margin: 0 0 16px;
  color: rgba(248, 250, 252, 0.65);
  font-size: 0.875rem;
}

.lt-sheet__submit {
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  border: none;
  border-radius: 12px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
}

.lt-sheet__submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-sheet__skip {
  width: 100%;
  margin-top: 10px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  background: transparent;
  color: inherit;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  opacity: 0.85;
}

/* Autoeval */
.lt-ae__player {
  margin: 0 0 8px;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(8, 119, 188, 0.22);
  border: 1px solid rgba(8, 119, 188, 0.45);
  color: #e0f2fe;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  text-align: center;
}

.lt-ae__ratings {
  display: flex;
  flex-direction: column;
}

.lt-ae__group {
  margin-bottom: 16px;
}

.lt-ae__label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.lt-ae__row {
  display: flex;
  gap: 6px;
}

.lt-ae__btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 4px;
  border-radius: 12px;
  border: 2px solid;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  cursor: pointer;
  min-height: 48px;
}

.lt-ae__btn--active {
  color: #fff;
}

.lt-ae__emoji {
  font-size: 1.25rem;
}

.lt-ae__num {
  font-size: 0.7rem;
  font-weight: 700;
}

.lt-ae--celebrate .lt-sheet__submit {
  background: #22c55e;
}

.lt-ae-backdrop.lt-ae-backdrop--landscape {
  align-items: center;
  padding-top: max(6px, env(safe-area-inset-top));
  padding-bottom: max(6px, env(safe-area-inset-bottom));
  padding-left: max(8px, env(safe-area-inset-left));
  padding-right: max(8px, env(safe-area-inset-right));
}

.lt-sheet.lt-ae.lt-ae--landscape {
  width: min(780px, calc(100vw - 16px));
  max-width: min(780px, calc(100vw - 16px));
  max-height: calc(
    100dvh - 12px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  );
  border-radius: 16px;
  padding: 10px 12px max(10px, env(safe-area-inset-bottom, 0px));
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(148px, 200px);
  grid-template-rows: minmax(0, 1fr);
  gap: 12px 16px;
  align-items: stretch;
}

.lt-ae--landscape .lt-ae__body {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
}

.lt-ae--landscape .lt-sheet__title {
  font-size: 1rem;
  margin-bottom: 2px;
}

.lt-ae--landscape .lt-ae__player {
  margin-bottom: 6px;
  padding: 4px 8px;
  font-size: 0.88rem;
}

.lt-ae--landscape .lt-sheet__subtitle {
  margin-bottom: 8px;
  font-size: 0.78rem;
}

.lt-ae--landscape .lt-ae__ratings {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
}

.lt-ae--landscape .lt-ae__group {
  margin-bottom: 0;
}

.lt-ae--landscape .lt-ae__label {
  margin-bottom: 4px;
  font-size: 0.78rem;
}

.lt-ae--landscape .lt-ae__btn {
  min-height: 40px;
  padding: 5px 2px;
  border-radius: 10px;
  gap: 1px;
}

.lt-ae--landscape .lt-ae__emoji {
  font-size: 1.05rem;
}

.lt-ae--landscape .lt-ae__num {
  font-size: 0.65rem;
}

.lt-ae--landscape .lt-ae__footer {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 0 0 0 4px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  padding-left: 14px;
  background: transparent;
  min-height: 0;
}

.lt-ae--landscape .lt-sheet__submit,
.lt-ae--landscape .lt-sheet__skip {
  width: 100%;
  margin-top: 0;
  padding: 14px 10px;
  font-size: 0.92rem;
}

.lt-ae--landscape .lt-sheet__skip {
  margin-top: 0;
}

@media (max-height: 560px) {
  .lt-sheet.lt-ae {
    max-height: min(96dvh, 100dvh);
    padding-top: 12px;
  }

  .lt-sheet__title {
    font-size: 1rem;
  }

  .lt-sheet__subtitle {
    margin-bottom: 10px;
    font-size: 0.78rem;
  }

  .lt-ae__player {
    margin-bottom: 6px;
    padding: 4px 8px;
    font-size: 0.85rem;
  }

  .lt-ae__group {
    margin-bottom: 10px;
  }

  .lt-ae__btn {
    min-height: 40px;
    padding: 4px 2px;
  }

  .lt-ae__emoji {
    font-size: 1.05rem;
  }

  .lt-sheet__submit,
  .lt-sheet__skip {
    padding: 10px;
    font-size: 0.92rem;
  }
}

/* Short landscape phones: stack ratings left, actions right */
@media (orientation: landscape) and (max-height: 480px) {
  .lt-sheet.lt-ae.lt-ae--landscape {
    max-height: calc(
      100dvh - 8px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
    );
    padding: 8px 10px;
    gap: 8px 12px;
    grid-template-columns: minmax(0, 1fr) minmax(120px, 160px);
  }

  .lt-ae--landscape .lt-ae__ratings {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .lt-ae--landscape .lt-ae__group {
    margin-bottom: 0;
  }

  .lt-ae--landscape .lt-ae__btn {
    min-height: 32px;
    padding: 2px;
  }

  .lt-ae--landscape .lt-ae__emoji {
    font-size: 0.95rem;
  }

  .lt-ae--landscape .lt-sheet__submit,
  .lt-ae--landscape .lt-sheet__skip {
    padding: 10px 8px;
    font-size: 0.88rem;
  }

  .lt-ae--landscape .lt-ae__footer {
    padding-left: 10px;
    gap: 6px;
  }
}

/* ── Unread badge (shared by player FAB and coach chat button) ────────── */
.lt-fab__badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: #ef4444;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
  box-shadow: 0 0 0 2px #0f172a;
}

/* Player FAB needs position:relative to anchor the badge */
.lt-page__fab {
  position: relative;
}

.lt-page__actions .lt-page__fab {
  position: relative;
}

/* ── Coach chat button ────────────────────────────────────────────────── */
.lt-coach-bar__chat-btn {
  flex: 0 0 auto;
  width: auto;
  min-width: 48px;
  padding: 10px 14px;
  gap: 6px;
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.lt-coach-bar__chat-label {
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
}

.lt-coach-bar__chat-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* KoT leaderboard overlay */
.lt-kot-lb__backdrop {
  position: fixed;
  inset: 0;
  z-index: 4900;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(4px);
}

.lt-kot-lb {
  position: fixed;
  bottom: 24px;
  left: 16px;
  right: 16px;
  max-width: 420px;
  max-height: min(70vh, 520px);
  margin: 0 auto;
  z-index: 4910;
  padding: 16px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.98);
  border: 1px solid rgba(251, 191, 36, 0.4);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  color: #f8fafc;
  display: flex;
  flex-direction: column;
}

.lt-kot-lb__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.lt-kot-lb__title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 1rem;
  color: #fbbf24;
}

.lt-kot-lb__close {
  border: none;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #f8fafc;
  cursor: pointer;
}

.lt-kot-lb__mode {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.lt-kot-lb__mode-btn {
  flex: 1 1;
  border: 1px solid rgba(251, 191, 36, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: #cbd5e1;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
}

.lt-kot-lb__mode-btn--active {
  background: rgba(251, 191, 36, 0.18);
  border-color: rgba(251, 191, 36, 0.75);
  color: #fde68a;
}

.lt-kot-lb__list {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.lt-kot-lb__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.9rem;
  color: #f8fafc;
}

.lt-kot-lb__row--me {
  color: #fcd34d;
  font-weight: 700;
}

.lt-kot-lb__rank {
  width: 28px;
  font-weight: 800;
  color: #fbbf24;
  flex-shrink: 0;
}

.lt-kot-lb__name {
  flex: 1 1;
  min-width: 0;
  color: #f8fafc;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-kot-lb__wins {
  font-variant-numeric: tabular-nums;
  color: rgba(134, 239, 172, 0.95);
  font-weight: 700;
  font-size: 0.82rem;
  flex-shrink: 0;
  white-space: nowrap;
}

.lt-kot-lb__pts {
  font-variant-numeric: tabular-nums;
  color: rgba(248, 250, 252, 0.88);
  font-weight: 700;
  flex-shrink: 0;
}

.lt-kot-lb__stat--primary {
  color: #fbbf24;
}

.lt-kot-lb__dismiss {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
}

/* KoT live training panel */
.lt-page__main--kot-player > .lt-kot--scorekeeper {
  flex: 1 1;
  min-height: 0;
  max-width: none;
  margin-top: 0;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  padding: 14px 72px max(24px, env(safe-area-inset-bottom, 0px)) 14px;
  background: linear-gradient(180deg, #0b1220 0%, #111827 38%, #0f172a 100%);
}

.lt-kot__scorekeeper-hint,
.lt-kot__scorekeeper-progress,
.lt-kot__scorekeeper-wait {
  margin: 0 0 10px;
  font-size: 0.85rem;
  color: rgba(248, 250, 252, 0.78);
}

.lt-kot__scorekeeper-progress {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.lt-kot {
  width: 100%;
  max-width: 480px;
  margin-top: 16px;
  padding: 14px;
  border-radius: 16px;
  background: rgba(251, 191, 36, 0.08);
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.lt-kot__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.lt-kot__header-icon {
  color: #fbbf24 !important;
  font-size: 28px !important;
}

.lt-kot__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 800;
}

.lt-kot__round {
  font-size: 0.75rem;
  color: rgba(248, 250, 252, 0.7);
}

.lt-kot__stop-banner {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: rgba(251, 146, 60, 0.2);
  border: 1px solid rgba(251, 146, 60, 0.45);
  font-size: 0.8rem;
  line-height: 1.35;
}

.lt-kot__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.lt-kot__stop-btn,
.lt-kot__start-btn,
.lt-kot__submit-btn {
  flex: 1 1;
  min-width: 120px;
}

.lt-kot__stop-btn--player,
.lt-kot__submit-btn {
  padding: 12px 16px;
  border-radius: 12px;
  border: none;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
}

.lt-kot__stop-btn--player {
  background: rgba(239, 68, 68, 0.25);
  border: 1px solid rgba(239, 68, 68, 0.55);
  color: #fecaca;
}

.lt-kot__submit-btn {
  background: linear-gradient(135deg, #fbbf24, #d97706);
  color: #422006;
}

.lt-kot__error {
  color: #fca5a5;
  font-size: 0.8rem;
  margin: 0 0 10px;
}

.lt-kot__tables {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.lt-page--landscape .lt-kot__tables {
  grid-template-columns: repeat(2, 1fr);
}

.lt-kot__table-card {
  padding: 12px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-kot__table-card--done {
  border-color: rgba(34, 197, 94, 0.45);
}

.lt-kot__table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 0.85rem;
}

.lt-kot__table-state {
  font-size: 0.7rem;
  color: rgba(248, 250, 252, 0.6);
  text-transform: uppercase;
}

.lt-kot__table-players {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
}

.lt-kot__table-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.lt-kot__table-won {
  margin-top: 6px;
  font-size: 0.75rem;
  color: #86efac;
  display: flex;
  align-items: center;
  gap: 4px;
}

.lt-kot__table-enter {
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  border: none;
  border-radius: 10px;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
}

.lt-kot__my-match {
  padding: 12px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.lt-kot__my-match-label {
  display: block;
  font-size: 0.7rem;
  color: rgba(248, 250, 252, 0.6);
  text-transform: uppercase;
  margin-bottom: 4px;
}

.lt-kot__empty {
  font-size: 0.85rem;
  color: rgba(248, 250, 252, 0.55);
  text-align: center;
  margin: 0;
}

.lt-kot__lb-toggle {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid rgba(251, 191, 36, 0.4);
  background: transparent;
  color: #fbbf24;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}

/* Full-screen KoT player arena */
.lt-page__main--kot-player {
  flex: 1 1;
  min-height: 0;
  padding: 0;
  align-items: stretch;
  overflow: hidden;
}

.lt-kot-arena {
  flex: 1 1;
  width: 100%;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  height: 100%;
  background: linear-gradient(180deg, #0b1220 0%, #111827 38%, #0f172a 100%);
  color: #f8fafc;
  overflow: hidden;
}

.lt-kot-arena__body {
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px 10px;
}

.lt-kot-arena--post-round .lt-kot-arena__body {
  justify-content: center;
  align-items: stretch;
  padding: 10px 12px;
}

.lt-kot-arena__wait-panel {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  overflow: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.lt-kot-arena__wait-panel.lt-kot-arena__waiting-classement {
  align-items: flex-start;
}

.lt-kot-arena--post-round .lt-kot-arena__wait-panel {
  max-height: 100%;
  justify-content: center;
}

.lt-kot-arena__wait-panel--upcoming {
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}

.lt-kot-arena__match--preview {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.lt-kot-arena--empty {
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: rgba(248, 250, 252, 0.65);
}

.lt-kot-arena__top {
  padding: 12px 16px 10px;
  border-bottom: 1px solid rgba(251, 191, 36, 0.22);
  background: rgba(251, 191, 36, 0.06);
}

.lt-kot-arena__exercise-title {
  margin: 0 0 10px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
  line-height: 1.2;
}

.lt-kot-arena__exercise-number {
  flex-shrink: 0;
  font-size: 1.15rem;
  font-weight: 900;
  color: #fcd34d;
}

.lt-kot-arena__exercise-name {
  font-size: clamp(0.95rem, 3.8vw, 1.15rem);
  font-weight: 700;
  color: #f8fafc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-kot-arena__top-main,
.lt-kot-arena__top-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.lt-kot-arena__top-meta {
  margin-top: 8px;
}

.lt-kot-arena__mode-pill,
.lt-kot-arena__round-pill,
.lt-kot-arena__table-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.lt-kot-arena__mode-pill {
  background: rgba(251, 191, 36, 0.18);
  color: #fcd34d;
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.lt-kot-arena__round-pill {
  background: rgba(8, 119, 188, 0.2);
  color: #7dd3fc;
  border: 1px solid rgba(8, 119, 188, 0.35);
}

.lt-kot-arena__table-pill {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.lt-kot-arena__timer {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1.35rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #fbbf24;
}

.lt-kot-arena__set-rule {
  margin: 8px 0 0;
  font-size: 0.82rem;
  color: rgba(248, 250, 252, 0.72);
  font-weight: 600;
}

.lt-kot-arena__stop-banner {
  margin: 6px 10px 0;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(251, 146, 60, 0.18);
  border: 1px solid rgba(251, 146, 60, 0.45);
  font-size: 0.75rem;
  line-height: 1.3;
  flex-shrink: 0;
}

.lt-kot-arena__move-banner {
  margin: 6px 10px 0;
  padding: 10px 12px;
  border-radius: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(34, 197, 94, 0.14);
  border: 2px solid rgba(34, 197, 94, 0.45);
  animation: lt-kot-move-glow 2s ease-in-out infinite;
}

.lt-kot-arena__move-banner--down {
  background: rgba(59, 130, 246, 0.14);
  border-color: rgba(59, 130, 246, 0.45);
}

.lt-kot-arena__move-banner--up {
  background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.45);
}

.lt-kot-arena__move-icon {
  font-size: 2.2rem !important;
  flex-shrink: 0;
  color: #86efac;
}

.lt-kot-arena__move-banner--down .lt-kot-arena__move-icon {
  color: #93c5fd;
}

.lt-kot-arena__move-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.88rem;
  line-height: 1.35;
}

.lt-kot-arena__waiting-classement {
  margin: 6px 10px 0;
  padding: 12px 14px;
  border-radius: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(15, 23, 42, 0.92);
  border: 2px solid rgba(250, 204, 21, 0.45);
  color: #f8fafc;
}

.lt-kot-arena__waiting-classement-copy {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.lt-kot-arena__waiting-classement-copy ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lt-kot-arena__waiting-classement-copy li {
  display: grid;
  grid-template-columns: 1.5rem 1fr auto auto;
  gap: 8px;
  font-size: 0.85rem;
}

.lt-kot-arena__waiting-classement-wins {
  font-variant-numeric: tabular-nums;
  color: #86efac;
  font-weight: 700;
  text-align: right;
}

.lt-kot-arena__waiting-classement-row--me {
  color: #fde047;
  font-weight: 600;
}

.lt-kot-arena__move-copy strong {
  font-size: 1rem;
  color: #f8fafc;
}

.lt-kot-arena__move-wait {
  font-size: 0.78rem;
  color: rgba(248, 250, 252, 0.65);
  margin-top: 2px;
}

.lt-kot-arena__go-table {
  font-size: clamp(1.1rem, 4.5vh, 1.45rem);
  font-weight: 900;
  color: #fde047;
  line-height: 1.15;
}

.lt-kot-arena__waiting-classement-copy .lt-kot-lb__list {
  width: 100%;
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
}

@keyframes lt-kot-move-glow {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.15);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.08);
  }
}

.lt-kot-arena__match {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: stretch;
  gap: 8px;
  padding: 8px 10px 6px;
  overflow: hidden;
}

/* Portrait: stack player A, VS, player B vertically */
.lt-kot-arena--portrait .lt-kot-arena__match {
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) auto minmax(0, 1fr);
  align-content: stretch;
  gap: 6px;
}

.lt-kot-arena--portrait .lt-kot-arena__vs {
  flex-direction: row;
  justify-content: center;
  gap: 12px;
  min-height: auto;
  padding: 2px 0;
}

.lt-kot-arena--portrait .lt-kot-arena__player {
  min-height: 0;
  width: 100%;
}

.lt-kot-arena .lt-kot-bar {
  border-radius: 0;
  margin: 0;
}

.lt-kot-arena--landscape .lt-kot-arena__top--compact {
  padding: 4px 10px 5px;
  flex-shrink: 0;
}

.lt-kot-arena__top-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-kot-arena__top-brand {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 6px;
}

.lt-kot-arena__club-logo {
  flex-shrink: 0;
}

.lt-kot-arena--landscape .lt-kot-arena__club-logo {
  margin-right: 2px;
}

.lt-kot-arena__top-line--title {
  justify-content: space-between;
  gap: 8px;
}

.lt-kot-arena__top-line--title .lt-kot-arena__exercise-title {
  flex: 1 1;
}

.lt-kot-arena__top-line--title .lt-kot-arena__exercise-title {
  margin: 0;
  flex: 1 1;
  min-width: 0;
}

.lt-kot-arena__top-line--meta {
  margin-top: 3px;
  justify-content: space-between;
  gap: 6px;
}

.lt-kot-arena__top-pills {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.lt-kot-arena--landscape .lt-kot-arena__exercise-number {
  font-size: 0.82rem;
}

.lt-kot-arena--landscape .lt-kot-arena__exercise-name {
  font-size: clamp(0.72rem, 2.4vh, 0.9rem);
}

.lt-kot-arena--landscape .lt-kot-arena__mode-pill,
.lt-kot-arena--landscape .lt-kot-arena__round-pill,
.lt-kot-arena--landscape .lt-kot-arena__table-pill {
  padding: 2px 6px;
  font-size: 0.58rem;
  letter-spacing: 0.02em;
}

.lt-kot-arena--landscape .lt-kot-arena__timer {
  font-size: clamp(0.9rem, 3.5vh, 1.1rem);
  flex-shrink: 0;
}

.lt-kot-arena--landscape .lt-kot-arena__set-rule {
  margin: 0;
  font-size: clamp(0.58rem, 1.8vh, 0.68rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  text-align: right;
}

.lt-kot-arena--landscape .lt-kot-arena__stop-banner,
.lt-kot-arena--landscape .lt-kot-arena__move-banner {
  margin: 4px 10px 0;
  padding: 6px 10px;
  font-size: 0.72rem;
}

.lt-kot-arena--landscape .lt-kot-arena__move-icon {
  font-size: 1.4rem !important;
}

.lt-kot-arena--landscape .lt-kot-arena__move-copy strong {
  font-size: 0.82rem;
}

.lt-kot-arena--landscape .lt-kot-arena__match {
  padding: 6px 8px 4px;
  overflow: hidden;
  align-items: stretch;
}

.lt-kot-arena--landscape .lt-kot-arena__player {
  min-height: 0;
  padding: clamp(8px, 1.8vh, 14px) clamp(6px, 1.2vw, 10px);
  gap: clamp(4px, 1.4vh, 10px);
  border-radius: 14px;
  justify-content: center;
}

.lt-kot-arena--landscape .lt-kot-arena__side-badge {
  width: clamp(30px, 5.5vh, 42px);
  height: clamp(30px, 5.5vh, 42px);
  font-size: clamp(0.85rem, 3.8vh, 1.15rem);
}

.lt-kot-arena--landscape .lt-kot-arena__player-name {
  font-size: clamp(0.95rem, 5.2vh, 1.45rem);
  line-height: 1.12;
  max-width: 100%;
}

.lt-kot-arena--landscape .lt-kot-arena__you-pill {
  font-size: clamp(0.62rem, 2.2vh, 0.78rem);
  padding: 2px 8px;
}

.lt-kot-arena--landscape .lt-kot-arena__player-level {
  font-size: clamp(0.78rem, 3.8vh, 1.05rem);
  line-height: 1.2;
}

.lt-kot-arena--landscape .lt-kot-arena__player-kot {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 10px;
  margin-top: clamp(2px, 0.6vh, 6px);
}

.lt-kot-arena--landscape .lt-kot-arena__rank {
  font-size: clamp(0.82rem, 4vh, 1.1rem);
}

.lt-kot-arena--landscape .lt-kot-arena__session-pts {
  font-size: clamp(0.72rem, 3.2vh, 0.95rem);
}

.lt-kot-arena--landscape .lt-kot-arena__live-score {
  font-size: clamp(1.4rem, 8vh, 2.35rem);
  margin-top: clamp(2px, 0.8vh, 8px);
  line-height: 1;
}

.lt-kot-arena--landscape .lt-kot-arena__vs {
  min-width: 40px;
  gap: 4px;
}

.lt-kot-arena--landscape .lt-kot-arena__vs-text {
  width: 34px;
  height: 34px;
  font-size: 0.68rem;
  border-width: 2px;
}

.lt-kot-arena--landscape .lt-kot-arena__vs-target {
  font-size: clamp(0.9rem, 3.5vh, 1.15rem);
}

.lt-kot-arena__footer {
  flex-shrink: 0;
}

.lt-kot-arena--landscape .lt-kot-arena__footer {
  display: flex;
  align-items: stretch;
  gap: 8px;
  padding: 4px 10px calc(6px + env(safe-area-inset-bottom));
}

.lt-kot-arena--landscape .lt-kot-arena__leaderboard-btn {
  margin: 0;
  flex: 0 0 auto;
  min-width: 0;
  padding: 8px 10px;
  font-size: clamp(0.68rem, 2.2vh, 0.78rem);
  border-radius: 10px;
}

.lt-kot-arena--landscape .lt-kot-arena__actions {
  flex: 1 1;
  min-width: 0;
  padding: 0;
  flex-direction: row;
  gap: 8px;
}

.lt-kot-arena--landscape .lt-kot-arena__stop-btn {
  min-height: auto;
}

.lt-kot-arena--landscape .lt-kot-arena__result-btn {
  min-height: 40px;
  font-size: clamp(0.78rem, 2.5vh, 0.92rem);
  border-radius: 12px;
}

.lt-kot-arena__player {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.72);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  text-align: center;
  min-height: 0;
  overflow: hidden;
}

.lt-kot-arena--portrait .lt-kot-arena__player {
  gap: 4px;
  padding: 8px 6px;
  border-radius: 14px;
}

.lt-kot-arena__player--a {
  border-color: rgba(59, 130, 246, 0.45);
  background: linear-gradient(165deg, rgba(30, 58, 138, 0.45), rgba(15, 23, 42, 0.85));
}

.lt-kot-arena__player--b {
  border-color: rgba(236, 72, 153, 0.45);
  background: linear-gradient(165deg, rgba(131, 24, 67, 0.35), rgba(15, 23, 42, 0.85));
}

.lt-kot-arena__player--me {
  box-shadow:
    0 0 0 2px rgba(251, 191, 36, 0.55),
    0 12px 32px rgba(251, 191, 36, 0.18);
}

.lt-kot-arena__side-badge {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.12);
}

.lt-kot-arena__player--a .lt-kot-arena__side-badge {
  color: #93c5fd;
}

.lt-kot-arena__player--b .lt-kot-arena__side-badge {
  color: #f9a8d4;
}

.lt-kot-arena__player-name {
  margin: 0;
  font-size: clamp(1rem, 4vw, 1.35rem);
  font-weight: 800;
  line-height: 1.15;
  word-break: break-word;
}

.lt-kot-arena__you-pill {
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.22);
  color: #fcd34d;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
}

.lt-kot-arena__player-level {
  margin: 0;
  font-size: 0.82rem;
  color: rgba(248, 250, 252, 0.78);
  font-weight: 600;
}

.lt-kot-arena__player-kot {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}

.lt-kot-arena__rank {
  font-size: 0.95rem;
  font-weight: 800;
  color: #fbbf24;
}

.lt-kot-arena__session-pts {
  font-size: 0.78rem;
  color: rgba(248, 250, 252, 0.65);
  font-variant-numeric: tabular-nums;
}

.lt-kot-arena__live-score {
  margin-top: auto;
  font-size: 2rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  color: #86efac;
}

.lt-kot-arena__vs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 56px;
}

.lt-kot-arena__vs-text {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #111827;
  border: 3px solid rgba(251, 191, 36, 0.55);
  color: #fbbf24;
  font-weight: 900;
  font-size: 0.85rem;
}

.lt-kot-arena__vs-target {
  font-size: 1.5rem;
  font-weight: 900;
  color: rgba(248, 250, 252, 0.85);
  font-variant-numeric: tabular-nums;
}

.lt-kot-arena__footer:not(:has(.lt-kot-arena__leaderboard-btn)) .lt-kot-arena__actions {
  width: 100%;
}

.lt-kot-arena--portrait .lt-kot-arena__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-kot-arena--portrait .lt-kot-arena__leaderboard-btn {
  margin: 0 16px 0;
}

.lt-kot-arena__leaderboard-btn {
  margin: 0 16px 8px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid rgba(251, 191, 36, 0.35);
  background: rgba(251, 191, 36, 0.08);
  color: #fcd34d;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.lt-kot-arena__actions {
  padding: 8px 16px calc(12px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lt-kot-arena__stop-btn {
  width: 100%;
  min-height: auto;
  flex: 1 1;
}

.lt-kot-arena__stop-btn:disabled {
  opacity: 0.7;
  cursor: wait;
}

.lt-kot-arena__result-btn {
  width: 100%;
  min-height: 56px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(135deg, #fbbf24, #d97706);
  color: #422006;
  font-size: 1.05rem;
  font-weight: 800;
  cursor: pointer;
}

.lt-kot-arena__error {
  margin: 0 16px 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(239, 68, 68, 0.15);
  color: #fecaca;
  font-size: 0.82rem;
}

/* Return FAB (shared) */
.lt-return-fab {
  position: fixed;
  right: 16px;
  bottom: calc(100px + env(safe-area-inset-bottom));
  z-index: 900;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, var(--brand-primary-light, #0a8cd8), var(--brand-primary, #0877BC));
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  box-shadow: 0 8px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);
  animation: lt-fab-pulse 2s ease-in-out infinite;
}

.lt-return-fab__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  animation: lt-dot-blink 1.2s ease-in-out infinite;
}

@keyframes lt-fab-pulse {
  0%,
  100% {
    box-shadow: 0 8px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);
  }
  50% {
    box-shadow: 0 8px 36px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.7);
  }
}

@keyframes lt-dot-blink {
  50% {
    opacity: 0.3;
  }
}

/* ─── Unified player view (lt-pv) — portrait + landscape, all exercise types ── */

/* Root container fills the available space inside lt-page__main */
.lt-pv {
  width: 100%;
  max-width: 100%;
  flex: 1 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  color: var(--lt-fg, #f8fafc);
  overflow-x: hidden;
  box-sizing: border-box;
}

/* Player chrome: coach header brand (logo + session title) top-left, controls right */
.lt-pv__chrome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  max-width: 100%;
  padding: 2px 0 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  box-sizing: border-box;
}

.lt-pv__chrome .lt-header__brand {
  flex: 1 1 auto;
  overflow: hidden;
}

.lt-pv__chrome .lt-header__sub {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__chrome-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lt-pv__screen-awake-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 999px;
  background: rgba(0, 242, 254, 0.12);
  border: 1px solid rgba(0, 242, 254, 0.4);
  color: #00f2fe;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 0 10px rgba(0, 242, 254, 0.25);
  animation: ltAwakeBreathe 3s infinite ease-in-out;
  flex-shrink: 0;
  max-width: 100%;
}

@keyframes ltAwakeBreathe {
  0%, 100% {
    border-color: rgba(0, 242, 254, 0.35);
    box-shadow: 0 0 8px rgba(0, 242, 254, 0.2);
  }
  50% {
    border-color: rgba(0, 242, 254, 0.65);
    box-shadow: 0 0 16px rgba(0, 242, 254, 0.4);
  }
}

/* Narrow phones: icon-only chip so chrome never needs horizontal scroll */
@media (max-width: 420px) {
  .lt-pv__chip-label {
    display: none;
  }

  .lt-pv__screen-awake-chip {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    gap: 0;
  }

  .lt-pv__chrome,
  .lt-pv__chrome-right {
    gap: 6px;
  }
}

/* Short visual viewport (landscape phones): tighter chrome, same layout. */
@container lt-page (max-height: 520px) {
  .lt-pv__chrome {
    padding: 0 0 4px;
    margin-bottom: 0;
  }

  .lt-pv__chip-label {
    display: none;
  }

  .lt-pv__screen-awake-chip,
  .lt-pv__chrome .lt-header__icon-btn,
  .lt-pv__chrome .lt-header__home-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    gap: 0;
  }
}

.lt-page__fab--duck {
  color: #94a3b8;
}

.lt-page__fab--duck:hover,
.lt-page__fab--duck.lt-page__fab--duck-active {
  background: rgba(0, 242, 254, 0.25);
  border-color: #00f2fe;
  color: #00f2fe;
  box-shadow: 0 0 16px rgba(0, 242, 254, 0.5);
}

.lt-pv__kot-hr-row {
  display: flex;
  justify-content: flex-end;
  padding: 4px 0 8px;
}

.lt-pv__ls-wait-header--exercise {
  justify-content: flex-start;
}

/* Make the main area stretch & remove excess padding when the player view is inside */
.lt-page__main:has(.lt-pv) {
  padding: 8px 10px 12px;
  align-items: stretch;
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

/* HR chip — compact inline BPM badge */
.lt-pv__hr-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 0.9rem;
  white-space: nowrap;
  flex-wrap: nowrap;
  line-height: 1;
}

.lt-pv__hr-icon {
  display: block;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  font-size: 16px !important;
  color: #ef4444;
}

/* Zone-intensity pill while sequence / round is running */
.lt-pv__hr-chip--zone {
  background: var(--lt-zone, rgba(0, 0, 0, 0.3));
  color: var(--lt-zone-fg, #f8fafc);
  border-color: transparent;
  transition: background 0.6s ease, color 0.6s ease;
}

.lt-pv__hr-chip--zone .lt-pv__hr-icon {
  color: #ef4444;
}

.lt-pv__hr-row .lt-pv__hr-icon {
  color: #ef4444;
}

/* ─── WAITING STATE ─────────────────────────────────────────────────────────── */

.lt-pv--waiting {
  align-items: center;
  justify-content: center;
}

.lt-pv__wait-card {
  width: 100%;
  max-width: 600px;
  padding: 20px 22px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-pv__wait-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.lt-pv__player-name {
  margin: 0;
  font-size: clamp(1.5rem, 6vw, 2rem);
  font-weight: 800;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__wait-top-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.lt-pv__table-line {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(248, 250, 252, 0.7);
}

/* Portrait table summary panel */
.lt-pv__table-panel {
  width: 100%;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lt-pv__table-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.lt-pv__table-hero-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 0 1 auto;
}

.lt-pv__table-hero-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.5);
}

.lt-pv__table-hero-number {
  font-size: clamp(1.15rem, 4.5vw, 1.45rem);
  font-weight: 800;
  line-height: 1.1;
  color: #fff;
  letter-spacing: -0.02em;
}

.lt-pv__table-hero-chips {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 auto;
}

.lt-pv__role--hero {
  font-size: 0.68rem;
  padding: 4px 10px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__side-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.85rem;
  font-weight: 800;
  color: #f8fafc;
}

.lt-pv__classement-badge {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(8, 119, 188, 0.15);
  border: 1px solid rgba(8, 119, 188, 0.35);
}

.lt-pv__classement-label {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(248, 250, 252, 0.6);
}

.lt-pv__classement-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #7dd3fc;
}

.lt-pv__table-roster-title {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.45);
  margin-bottom: 6px;
}

.lt-pv__table-roster-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-pv__table-roster-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.lt-pv__table-roster-item--viewer {
  background: rgba(8, 119, 188, 0.12);
  border-color: rgba(8, 119, 188, 0.3);
}

.lt-pv__table-roster-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #f8fafc;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__table-roster-side {
  font-weight: 600;
  color: rgba(248, 250, 252, 0.55);
}

.lt-pv__table-roster-meta {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.55);
  text-align: right;
}

.lt-pv__portrait-top {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.lt-pv__id-bar--portrait {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.lt-pv__personalized-cue {
  display: block;
  margin: 4px 0 0;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.35;
  opacity: 0.88;
  white-space: normal;
}

.lt-add-ex-dialog__slot-lead {
  margin: 0 0 12px;
  line-height: 1.4;
}

.lt-add-ex-dialog__slot-list {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lt-add-ex-dialog__duration {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 600;
}

.lt-add-ex-dialog__duration input {
  max-width: 120px;
  font: inherit;
  padding: 6px 8px;
}

.lt-pv__wait-exercise {
  margin: 4px 0 0;
  font-size: clamp(1rem, 4vw, 1.25rem);
  font-weight: 700;
}

.lt-pv__schema {
  font-size: 0.72em;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7dd3fc;
}

.lt-pv__schema-prep {
  display: inline-block;
  margin-top: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #93c5fd;
}

.lt-pv__wait-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-pv__wait-type {
  font-size: 0.9rem;
  color: rgba(248, 250, 252, 0.8);
}

.lt-pv__wait-subtype {
  font-size: 0.8rem;
  color: rgba(248, 250, 252, 0.6);
}

.lt-pv__wait-message {
  margin: 8px 0 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--lt-brand, #0877bc);
}

/* ─── IDENTITY BAR (shared: active & KoT header) ─────────────────────────── */

.lt-pv__id-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  margin-bottom: 4px;
}

.lt-pv__id-logo,
.lt-pv__header-logo {
  flex-shrink: 0;
}

.lt-pv__wait-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.lt-pv__id-text {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-pv__id-name {
  font-size: clamp(1rem, 4vw, 1.2rem);
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__id-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Role chip */
.lt-pv__role {
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.lt-pv__role--active {
  background: rgba(34, 179, 92, 0.25);
  color: #4ade80;
  border: 1px solid rgba(34, 179, 92, 0.5);
}
.lt-pv__role--sparring {
  background: rgba(243, 140, 41, 0.22);
  color: #fb923c;
  border: 1px solid rgba(243, 140, 41, 0.5);
}

/* KoT compact header */
.lt-pv--kot-header {
  padding: 0;
}

/* ─── TIMER BLOCKS (shared between portrait and landscape) ──────────────────── */

.lt-pv__timer-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.lt-pv__timer-label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.55);
}

.lt-pv__timer-value {
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  line-height: 1.05;
}

.lt-pv__paused-tag {
  align-self: flex-start;
  padding: 3px 12px;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
  font-size: 0.72rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 4px;
}

/* ─── PORTRAIT ACTIVE & GAMIFIED HANDHELD HUD ─────────────────────────────
   Modern gamification sports design optimized for portrait mode when device is
   in-hands or close to player (cockpit layout, stadium telemetry, kinetic timers).
   ────────────────────────────────────────────────────────────────────────── */

.lt-pv--portrait {
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 16px;
  width: 100%;
  max-width: min(540px, 100%);
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.lt-pv__wait-cockpit {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: min(540px, 100%);
  margin: 0 auto;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
}

.lt-pv__standby-radar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  border-radius: 14px;
  background: rgba(251, 191, 36, 0.08);
  border: 1px solid rgba(251, 191, 36, 0.3);
  gap: 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.lt-pv__radar-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fbbf24;
  box-shadow: 0 0 12px #fbbf24;
  animation: ltRadarDot 1.4s infinite alternate;
}

@keyframes ltRadarDot {
  0% {
    transform: scale(0.85);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.3);
    opacity: 1;
    box-shadow: 0 0 16px #fbbf24;
  }
}

.lt-pv__radar-text {
  font-size: 0.78rem;
  font-weight: 850;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fbbf24;
}

/* Gamified Stadium Table Panel */
.lt-pv__table-panel--gamified {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(145deg, rgba(15, 23, 42, 0.92) 0%, rgba(8, 12, 22, 0.96) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  box-sizing: border-box;
}

.lt-pv__table-stadium-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.lt-pv__stadium-badge {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 10px;
  background: rgba(0, 242, 254, 0.12);
  border: 1px solid rgba(0, 242, 254, 0.4);
  box-shadow: 0 0 14px rgba(0, 242, 254, 0.2);
}

.lt-pv__stadium-label {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
}

.lt-pv__stadium-num {
  font-size: 1.25rem;
  font-weight: 900;
  color: #00f2fe;
  letter-spacing: -0.02em;
}

.lt-pv__stadium-status {
  display: flex;
  align-items: center;
}

.lt-pv__stadium-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.lt-pv__stadium-pill--live {
  background: rgba(0, 245, 155, 0.14);
  border: 1px solid rgba(0, 245, 155, 0.4);
  color: #00f59b;
}

.lt-pv__stadium-pill--standby {
  background: rgba(251, 191, 36, 0.14);
  border: 1px solid rgba(251, 191, 36, 0.4);
  color: #fbbf24;
}

.lt-pv__stadium-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.lt-pv__stadium-dot--pulse {
  animation: ltDotPulse 1.2s infinite ease-in-out;
}

@keyframes ltDotPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(0.75);
  }
}

/* Matchup Arena */
.lt-pv__matchup-arena {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.lt-pv__matchup-card {
  flex: 1 1;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}

.lt-pv__matchup-card--you {
  background: linear-gradient(135deg, rgba(0, 242, 254, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%);
  border-color: rgba(0, 242, 254, 0.28);
  box-shadow: 0 0 16px rgba(0, 242, 254, 0.06);
}

.lt-pv__matchup-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-pv__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 900;
  flex-shrink: 0;
}

.lt-pv__avatar--you {
  background: linear-gradient(135deg, #00f2fe 0%, #0877bc 100%);
  color: #080c14;
  box-shadow: 0 0 10px rgba(0, 242, 254, 0.4);
}

.lt-pv__avatar--partner {
  background: linear-gradient(135deg, #64748b 0%, #334155 100%);
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.lt-pv__matchup-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-pv__player-title {
  font-size: 0.82rem;
  font-weight: 800;
  color: #f8fafc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-pv__player-sub {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.lt-pv__side-tag {
  font-size: 0.65rem;
  font-weight: 800;
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}

.lt-pv__stat-tag {
  font-size: 0.65rem;
  font-weight: 700;
  color: rgba(248, 250, 252, 0.65);
}

.lt-pv__stat-tag--pts {
  color: #00f2fe;
  font-weight: 800;
}

.lt-pv__role-crest {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  align-self: flex-start;
}

.lt-pv__role-crest-icon {
  font-size: 0.9rem !important;
}

/* Same palette as the landscape .lt-pv__role--active / --sparring chips */
.lt-pv__role-crest--performance,
.lt-pv__role-crest--attacker {
  background: rgba(34, 179, 92, 0.25);
  border: 1px solid rgba(34, 179, 92, 0.5);
  color: #4ade80;
}

.lt-pv__role-crest--sparring {
  background: rgba(243, 140, 41, 0.22);
  border: 1px solid rgba(243, 140, 41, 0.5);
  color: #fb923c;
}

.lt-pv__matchup-vs-bridge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lt-pv__matchup-vs-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #94a3b8;
  font-size: 0.65rem;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.04em;
}

.lt-pv__roster-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 6px 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.lt-pv__roster-strip-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
}

.lt-pv__roster-strip-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.lt-pv__roster-pill {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  color: #cbd5e1;
}

/* Tactical Mission Card */
.lt-pv__mission-card {
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-pv__mission-header {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex-wrap: wrap;
}

.lt-pv__mission-tennis-icon {
  font-size: 0.95rem !important;
  color: #00f2fe;
}

.lt-pv__mission-lead {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94a3b8;
}

.lt-pv__schema-pill {
  font-size: 0.68rem;
  font-weight: 800;
  padding: 2px 7px;
  border-radius: 4px;
  background: rgba(0, 242, 254, 0.12);
  border: 1px solid rgba(0, 242, 254, 0.35);
  color: #00f2fe;
  margin-left: auto;
}

.lt-pv__mission-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -0.01em;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.lt-pv__coach-cue-box {
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(251, 191, 36, 0.08);
  border-left: 3px solid #fbbf24;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-pv__coach-cue-label {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fbbf24;
}

.lt-pv__coach-cue-text {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.9);
  line-height: 1.35;
}

.lt-pv__prep-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #38bdf8;
  text-decoration: none;
  align-self: flex-start;
  margin-top: 2px;
  transition: opacity 0.2s ease;
}

.lt-pv__prep-link:hover {
  opacity: 0.8;
}

.lt-pv__prep-arrow-icon {
  font-size: 0.75rem !important;
}

/* ─── KINETIC SEQUENCE PROGRESSION & TIMERS ───────────────────────────────── */

.lt-pv__seq-progress-wrap {
  width: 100%;
}

.lt-pv__seq-meter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 4px;
}

.lt-pv__seq-pips {
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
}

.lt-pv__seq-pip {
  flex: 1 1;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.lt-pv__seq-pip--done {
  background: #00f59b;
  box-shadow: 0 0 8px rgba(0, 245, 155, 0.4);
}

.lt-pv__seq-pip--active {
  background: #00f2fe;
  box-shadow: 0 0 12px rgba(0, 242, 254, 0.7);
  animation: ltPipGlow 1.8s infinite ease-in-out;
}

@keyframes ltPipGlow {
  0%, 100% {
    box-shadow: 0 0 8px rgba(0, 242, 254, 0.5);
    opacity: 0.85;
  }
  50% {
    box-shadow: 0 0 16px rgba(0, 242, 254, 1);
    opacity: 1;
  }
}

.lt-pv__seq-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lt-pv__seq-counter-tag {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.lt-pv__timer-card {
  width: 100%;
  padding: 18px 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.92) 0%, rgba(8, 12, 22, 0.96) 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.lt-pv__timer-card-head {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: center;
}

.lt-pv__timer-head-icon {
  font-size: 1rem !important;
  color: #00f2fe;
}

.lt-pv__timer-card-title {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94a3b8;
}

.lt-pv__timer-value--seq {
  font-size: clamp(3.8rem, 19vw, 5.5rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  color: #ffffff;
  text-shadow: 0 0 24px rgba(0, 242, 254, 0.35);
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.lt-pv__timer-paused-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-left: 8px;
}

.lt-pv__timer-card--rest {
  background: linear-gradient(180deg, rgba(251, 191, 36, 0.15) 0%, rgba(15, 23, 42, 0.96) 100%);
  border-color: rgba(251, 191, 36, 0.5);
  box-shadow: 0 0 28px rgba(251, 191, 36, 0.25);
  animation: ltRestPulse 2s infinite ease-in-out;
}

@keyframes ltRestPulse {
  0%, 100% {
    border-color: rgba(251, 191, 36, 0.4);
    box-shadow: 0 0 16px rgba(251, 191, 36, 0.2);
  }
  50% {
    border-color: rgba(251, 191, 36, 0.8);
    box-shadow: 0 0 32px rgba(251, 191, 36, 0.45);
  }
}

.lt-pv__timer-rest-icon {
  font-size: 1.1rem !important;
  color: #fbbf24;
}

.lt-pv__timer-value--rest {
  color: #fbbf24;
  text-shadow: 0 0 24px rgba(251, 191, 36, 0.5);
  font-size: clamp(3.8rem, 19vw, 5.5rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.lt-pv__timer-rest-sub {
  font-size: 0.75rem;
  font-weight: 700;
  color: #fde68a;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.lt-pv__drill-odometer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.32);
  border: 1px solid rgba(255, 255, 255, 0.07);
  width: 100%;
}

.lt-pv__odometer-label {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
}

.lt-pv__odometer-value {
  font-size: 1.3rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  color: #38bdf8;
  letter-spacing: -0.02em;
}

/* ─── GAMIFIED HR BIOMETRICS POWER CARD ──────────────────────────────────── */

.lt-pv__hr-power-card {
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(8, 12, 22, 0.96) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  transition: all 0.3s ease;
}

.lt-pv__hr-power-card--neutral {
  border-color: rgba(255, 255, 255, 0.08);
}

.lt-pv__hr-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lt-pv__hr-metric {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.lt-pv__hr-heart-icon {
  font-size: 1.3rem !important;
  color: #f43f5e;
  align-self: center;
}

.lt-pv__hr-heart-icon--beating {
  animation: ltHeartBeat 1.1s infinite cubic-bezier(0.2, 0.8, 0.2, 1);
}

@keyframes ltHeartBeat {
  0%, 100% {
    transform: scale(1);
  }
  15% {
    transform: scale(1.25);
  }
  30% {
    transform: scale(1);
  }
  45% {
    transform: scale(1.15);
  }
  60% {
    transform: scale(1);
  }
}

.lt-pv__hr-live-number {
  font-size: 1.8rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  color: #fff;
  letter-spacing: -0.02em;
}

.lt-pv__hr-live-unit {
  font-size: 0.8rem;
  font-weight: 700;
  color: #94a3b8;
}

.lt-pv__hr-right-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lt-pv__hr-peak-pill {
  font-size: 0.75rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  color: #cbd5e1;
}

.lt-pv__hr-zones-bar {
  display: flex;
  gap: 4px;
  width: 100%;
  height: 8px;
  margin-top: 2px;
}

.lt-pv__hr-zone-segment {
  flex: 1 1;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  position: relative;
  transition: all 0.3s ease;
}

.lt-pv__hr-zone-segment--past {
  background: var(--segment-color);
  opacity: 0.4;
}

.lt-pv__hr-zone-segment--active {
  background: var(--segment-color);
  opacity: 1;
  box-shadow: 0 0 10px var(--segment-color);
  transform: scaleY(1.3);
}

.lt-pv__hr-zone-pip {
  display: none;
}

.lt-pv__hr-zone-legend {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.lt-pv__hr-zone-tag {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--lt-zone, #38bdf8);
}

/* Fallback for legacy timer blocks / landscape components */
.lt-pv__timer-block--portrait {
  width: 100%;
  padding: 12px 16px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.07);
}

.lt-pv__timer-value--portrait-seq {
  font-size: clamp(3.5rem, 18vw, 5rem);
  color: #fff;
}

.lt-pv__timer-value--portrait-ex {
  font-size: clamp(2.25rem, 11vw, 3rem);
  color: var(--lt-brand, #0877bc);
}

.lt-pv__hr-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 14px;
  background: var(--lt-zone, rgba(255, 255, 255, 0.06));
  color: var(--lt-zone-fg, #f8fafc);
  font-variant-numeric: tabular-nums;
  transition: background 0.6s ease;
}

.lt-pv__hr-row-value {
  font-size: 1.25rem;
  font-weight: 800;
  flex: 1 1;
}

.lt-pv__hr-row-max {
  font-size: 0.85rem;
  font-weight: 600;
  opacity: 0.8;
}

.lt-pv__hr-row--neutral {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #f8fafc;
}

/* ─── LANDSCAPE ACTIVE ─────────────────────────────────────────────────────── */

.lt-pv--active-landscape {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-self: stretch;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  padding: 0;
}

.lt-page__main:has(.lt-pv--active-landscape) {
  padding: 0;
}

.lt-pv--active-landscape .lt-pv__table-center--active {
  justify-content: space-evenly;
  gap: clamp(4px, 1.2vh, 10px);
  width: clamp(118px, 24vw, 220px);
  overflow: hidden;
  align-self: stretch;
  min-height: 0;
  padding: 4px 6px max(6px, env(safe-area-inset-bottom, 0px));
}

.lt-pv__table-center-pin {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto;
  min-height: 0;
  width: 100%;
  padding-bottom: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-pv__table-center-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 1.2vh, 10px);
  width: 100%;
  min-height: 0;
}

.lt-pv__table-center-table {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.lt-pv__table-center-logo .lt-club-logo {
  width: clamp(36px, 8vh, 64px);
  height: clamp(36px, 8vh, 64px);
  padding: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  object-fit: contain;
}

.lt-pv--waiting-landscape .lt-pv__chrome,
.lt-pv--active-landscape .lt-pv__chrome {
  min-height: 0;
  padding: 0 8px 4px;
  margin-bottom: 0;
  z-index: 2;
}

.lt-pv__table-center--active .lt-pv__table-center-number {
  font-size: clamp(1.35rem, 6.5vh, 2.35rem);
  line-height: 1;
}

.lt-pv__ls-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  padding-bottom: 2px;
}

.lt-pv__timer-value--ls-seq {
  font-size: clamp(1.25rem, 5.8vh, 2.1rem);
  line-height: 1;
  color: #fff;
}

.lt-pv__timer-value--ls-ex {
  font-size: clamp(1.1rem, 5vh, 1.55rem);
  line-height: 1;
  color: var(--lt-brand, #0877bc);
}

.lt-pv__paused-tag--center {
  align-self: center;
}

.lt-pv--landscape {
  flex-direction: row;
  flex: 1 1;
}

/* Active landscape uses a column layout (title bar on top, 3-panel split below) */
.lt-pv--active-landscape.lt-pv--landscape,
.lt-pv--active-landscape {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.lt-pv__split {
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: stretch;
  flex: 1 1;
}

.lt-pv__panel {
  flex: 1 1;
  min-width: 0;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.lt-pv__panel--timers {
  background: rgba(0, 0, 0, 0.3);
}

/* Landscape timer sizes */
.lt-pv__timer-value--seq {
  font-size: clamp(2.75rem, 12vh, 4rem);
  color: #fff;
}
.lt-pv__timer-value--ex {
  font-size: clamp(1.75rem, 7vh, 2.5rem);
  color: var(--lt-brand, #0877bc);
}

.lt-pv--active-landscape .lt-pv__timer-value--ls-seq {
  font-size: clamp(1.2rem, 5.4vh, 2rem);
}

.lt-pv--active-landscape .lt-pv__timer-value--ls-ex {
  font-size: clamp(1.05rem, 4.6vh, 1.45rem);
}

.lt-pv--active-landscape .lt-pv__ls-timer .lt-pv__timer-label {
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  text-align: center;
  line-height: 1.1;
}

@media (orientation: landscape) and (max-height: 430px) {
  .lt-pv__table-center-logo .lt-club-logo {
    width: clamp(28px, 6.5vh, 44px);
    height: clamp(28px, 6.5vh, 44px);
  }

  .lt-pv--active-landscape .lt-pv__table-center--active .lt-pv__table-center-number,
  .lt-pv--waiting-landscape .lt-pv__table-center-number {
    font-size: clamp(1.15rem, 5.2vh, 1.7rem);
  }

  .lt-pv--active-landscape .lt-pv__timer-value--ls-seq {
    font-size: clamp(1.05rem, 4.8vh, 1.45rem);
  }

  .lt-pv--active-landscape .lt-pv__timer-value--ls-ex {
    font-size: clamp(0.95rem, 4.2vh, 1.25rem);
  }
}

.lt-pv--paused .lt-pv__timer-value--seq,
.lt-pv--paused .lt-pv__timer-value--portrait-seq {
  opacity: 0.6;
}

.lt-pv__timer-value--transition {
  color: #fbbf24 !important;
  opacity: 1 !important;
}

.lt-pv__timer-block--transition .lt-pv__timer-label,
.lt-pv__ls-timer--transition .lt-pv__timer-label {
  color: #fbbf24;
}

/* HR zone panel (landscape) */
.lt-pv__panel--hr {
  background: var(--lt-zone, rgba(255, 255, 255, 0.06));
  color: var(--lt-zone-fg, #f8fafc);
  align-items: center;
  justify-content: center;
  transition: background 0.6s ease;
}

.lt-pv__hr-big {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.lt-pv__hr-icon-lg {
  font-size: 28px !important;
  color: currentColor;
  opacity: 0.85;
  align-self: center;
}

.lt-pv__hr-big-value {
  font-size: clamp(3rem, 14vh, 5rem);
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.lt-pv__hr-big-unit {
  font-size: 1rem;
  font-weight: 700;
  opacity: 0.75;
}

.lt-pv__hr-max {
  font-size: 0.95rem;
  font-weight: 700;
  opacity: 0.8;
  font-variant-numeric: tabular-nums;
}

/* ─── LANDSCAPE WAITING — iOS 3-panel table view ─────────────────────────── */

/* Remove default centering and let children fill the space */
.lt-pv--waiting-landscape,
.lt-pv--active-landscape {
  overflow: hidden;
}

.lt-pv--waiting-landscape {
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-self: stretch;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  padding: 0;
}

/* Counteract parent padding so the view fills edge-to-edge */
.lt-page__main:has(.lt-pv--waiting-landscape) {
  padding: 0;
}

/* Exercise title strip at top */
.lt-pv__ls-wait-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 96px 8px 52px;
  background: rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  flex-shrink: 0;
}

.lt-pv__ls-wait-header .lt-pv__header-logo {
  position: absolute;
  left: max(10px, env(safe-area-inset-left));
  top: 50%;
  transform: translateY(-50%);
}

.lt-pv__ls-wait-header--exit-only {
  justify-content: flex-end;
  padding: 8px 16px;
}

.lt-pv__ls-wait-header-title {
  font-size: clamp(0.8rem, 2.4vh, 1rem);
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Exit button positioned absolute inside the header */
.lt-pv__ls-wait-exit {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

/* 3-column split filling the remaining vertical space */
.lt-pv__table-split {
  display: flex;
  flex: 1 1;
  align-items: stretch;
  min-height: 0;
}

/* Player side panels (A and B) — same tint on both sides */
.lt-pv__table-side {
  position: relative;
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  padding: clamp(10px, 2.5vh, 16px) clamp(8px, 2vw, 14px);
  background: rgba(8, 119, 188, 0.07);
  gap: 10px;
  overflow: hidden;
}

.lt-pv__side-body {
  position: relative;
  z-index: 1;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.lt-pv__side-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.lt-pv__table-side--a {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.lt-pv__table-side--b {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}

/* Viewer's own side gets a subtle brand tint */
.lt-pv__table-side--viewer {
  background: rgba(8, 119, 188, 0.07);
}

/* Court-side A / B marker — pinned to the top, never covers the name */
.lt-pv__side-letter {
  position: absolute;
  top: max(6px, env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
  font-size: clamp(1.2rem, 4.2vh, 1.85rem);
  font-weight: 900;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1;
  pointer-events: none;
  letter-spacing: 0.04em;
}

/* Classement + ranking points under player name */
.lt-pv__side-stats {
  font-size: clamp(0.7rem, 2.2vh, 0.85rem);
  font-weight: 700;
  color: #7dd3fc;
  text-align: center;
  line-height: 1.3;
  max-width: 100%;
  word-break: break-word;
}

/* Player name */
.lt-pv__side-name {
  margin: 0;
  width: 100%;
  font-size: clamp(0.95rem, 3.5vh, 1.35rem);
  font-weight: 800;
  text-align: center;
  line-height: 1.25;
  word-break: break-word;
  overflow-wrap: anywhere;
  color: #f8fafc;
}

/* Role badge on landscape table sides — prominent, never overlaps name */
.lt-pv__role--side {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: auto;
  max-width: 100%;
  padding: 8px 18px;
  font-size: clamp(0.78rem, 2.6vh, 1rem);
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}

.lt-pv__table-side .lt-pv__hr-chip {
  position: relative;
  z-index: 1;
  align-self: center;
  flex-shrink: 0;
}

.lt-pv__table-side > .lt-pv__side-letter {
  margin-bottom: 0;
}

/* Center column: table number + waiting message */
.lt-pv__table-center {
  flex: 0 0 auto;
  width: clamp(110px, 22vw, 200px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding: 12px 8px;
  gap: 4px;
  border-left: 1px solid rgba(255, 255, 255, 0.07);
  border-right: 1px solid rgba(255, 255, 255, 0.07);
}

.lt-pv--waiting-landscape .lt-pv__table-center {
  justify-content: center;
  gap: clamp(8px, 1.6vh, 12px);
  min-height: 0;
  overflow: hidden;
}

.lt-pv--waiting-landscape .lt-pv__table-center-number {
  font-size: clamp(1.5rem, 7vh, 2.6rem);
}

/* Waiting + active landscape: vertically center player info in A/B columns */
.lt-pv--waiting-landscape .lt-pv__table-side,
.lt-pv--active-landscape .lt-pv__table-side {
  justify-content: center;
  gap: clamp(8px, 2vh, 14px);
}

/* Landscape A/B marker stays a compact top label so names remain readable */
.lt-pv--waiting-landscape .lt-pv__side-letter,
.lt-pv--active-landscape .lt-pv__side-letter {
  font-size: clamp(1.25rem, 4.6vh, 2rem);
}

.lt-pv--waiting-landscape .lt-pv__side-name,
.lt-pv--active-landscape .lt-pv__side-name {
  font-size: clamp(1.05rem, 5.5vh, 1.65rem);
  line-height: 1.15;
}

.lt-pv--waiting-landscape .lt-pv__side-stats,
.lt-pv--active-landscape .lt-pv__side-stats {
  font-size: clamp(0.82rem, 4vh, 1.1rem);
  line-height: 1.25;
}

.lt-pv--waiting-landscape .lt-pv__role--side,
.lt-pv--active-landscape .lt-pv__role--side {
  font-size: clamp(0.85rem, 3.5vh, 1.15rem);
  padding: clamp(6px, 1.5vh, 10px) clamp(14px, 3vw, 20px);
}

.lt-pv--waiting-landscape .lt-pv__side-body,
.lt-pv--active-landscape .lt-pv__side-body {
  flex: 1 1 auto;
  justify-content: center;
  padding-top: clamp(1.6rem, 6.5vh, 2.6rem);
  padding-bottom: clamp(0.4rem, 1.5vh, 0.8rem);
}

.lt-pv__table-center-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1;
}

.lt-pv__table-center-number {
  font-size: clamp(2rem, 10vh, 3.5rem);
  font-weight: 900;
  color: #fff;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.lt-pv__wait-message-ls {
  margin: 6px 0 0;
  font-size: clamp(0.6rem, 1.6vh, 0.75rem);
  font-weight: 500;
  color: rgba(248, 250, 252, 0.6);
  text-align: center;
  line-height: 1.35;
}

/* ─── Legacy lt-lsp aliases (kept so old CSS class references don't crash) ── */
/* Landscape player replica (iOS parity, TE_SEQUENCES) */
.lt-lsp {
  width: 100%;
  flex: 1 1;
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.lt-page--landscape .lt-page__main:has(.lt-lsp) {
  padding: 8px 12px 12px;
  align-items: stretch;
}

/* Heart-rate chip (shared) */
.lt-lsp__hr-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  white-space: nowrap;
  line-height: 1;
}

.lt-lsp__hr-icon {
  display: block;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  font-size: 18px !important;
  color: #ef4444;
}

/* Waiting state */
.lt-lsp--waiting {
  align-items: center;
}

.lt-lsp__wait-card {
  width: 100%;
  max-width: 560px;
  margin: auto;
  padding: 20px 24px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-lsp__wait-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.lt-lsp__player-name {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 800;
  text-align: left;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-lsp__table-line {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(248, 250, 252, 0.75);
  text-align: left;
}

.lt-lsp__wait-exercise {
  margin: 8px 0 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.lt-lsp__wait-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-lsp__wait-type {
  font-size: 0.95rem;
  color: rgba(248, 250, 252, 0.85);
}

.lt-lsp__wait-subtype {
  font-size: 0.85rem;
  color: rgba(248, 250, 252, 0.65);
}

.lt-lsp__wait-message {
  margin: 12px 0 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--lt-brand, #0877bc);
}

/* Active state */
.lt-lsp__split {
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: stretch;
}

.lt-lsp__panel {
  flex: 1 1;
  min-width: 0;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
}

.lt-lsp__panel--timers {
  background: rgba(0, 0, 0, 0.3);
  gap: 10px;
}

.lt-lsp__id-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.lt-lsp__id-text {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.lt-lsp__id-name {
  font-size: 1.1rem;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lt-lsp__role {
  flex-shrink: 0;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.lt-lsp__role--active {
  background: rgba(34, 179, 92, 0.25);
  color: #4ade80;
  border: 1px solid rgba(34, 179, 92, 0.5);
}

.lt-lsp__role--sparring {
  background: rgba(243, 140, 41, 0.22);
  color: #fb923c;
  border: 1px solid rgba(243, 140, 41, 0.5);
}

.lt-lsp__id-hr {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.lt-lsp__timer-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.lt-lsp__timer-block--seq {
  margin-top: 4px;
}

.lt-lsp__timer-label {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.6);
}

.lt-lsp__timer-value {
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  line-height: 1.05;
}

.lt-lsp__timer-value--seq {
  font-size: clamp(2.75rem, 12vh, 4rem);
  color: #fff;
}

.lt-lsp__timer-value--ex {
  font-size: clamp(1.75rem, 7vh, 2.5rem);
  color: var(--lt-brand, #0877bc);
}

.lt-lsp--paused .lt-lsp__timer-value--seq {
  opacity: 0.6;
}

.lt-lsp__paused-tag {
  margin-top: auto;
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* HR zone panel */
.lt-lsp__panel--hr {
  background: var(--lt-zone, rgba(255, 255, 255, 0.06));
  color: var(--lt-zone-fg, #f8fafc);
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.6s ease;
}

.lt-lsp__hr-big {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.lt-lsp__hr-icon-lg {
  font-size: 28px !important;
  color: currentColor;
  opacity: 0.85;
  align-self: center;
}

.lt-lsp__hr-big-value {
  font-size: clamp(3rem, 14vh, 5rem);
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.lt-lsp__hr-big-unit {
  font-size: 1rem;
  font-weight: 700;
  opacity: 0.75;
}

.lt-lsp__hr-max {
  font-size: 0.95rem;
  font-weight: 700;
  opacity: 0.8;
  font-variant-numeric: tabular-nums;
}

/* ── Live HR trend panel mode ───────────────────────────────────────────── */
.lt-panel-mode-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.35);
  color: #f8fafc;
  cursor: pointer;
  flex-shrink: 0;
}

.lt-panel-mode-toggle:hover:not(:disabled) {
  background: rgba(8, 119, 188, 0.25);
  border-color: rgba(125, 211, 252, 0.35);
}

.lt-panel-mode-toggle:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.lt-pv__side-toggle-row {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.lt-pv__side--hr-trend {
  justify-content: flex-start;
  gap: 6px;
}

.lt-pv__hr-trend-block {
  width: 100%;
  box-sizing: border-box;
  margin: 0 clamp(8px, 2vw, 14px) clamp(10px, 2vh, 16px);
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.lt-pv__hr-trend-block .lt-hr-trend-panel {
  flex: none;
  min-height: 0;
}

.lt-pv__hr-row--with-toggle {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 8px;
}

.lt-pv__panel-mode-toggle--inline {
  min-width: 40px;
  min-height: 40px;
  margin-left: auto;
}

.lt-hr-trend-panel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  min-height: 0;
  flex: 1 1;
}

.lt-hr-trend-panel__top {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  overflow: visible;
}

.lt-hr-trend-panel__bpm-chip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(0.9rem, 2.8vh, 1.1rem);
  font-weight: 800;
  color: #f8fafc;
  font-variant-numeric: tabular-nums;
}

.lt-hr-trend-panel__bpm-icon {
  color: #ef4444;
  font-size: 1rem !important;
}

.lt-hr-trend-panel__meta {
  margin: 0;
  font-size: clamp(0.68rem, 2vh, 0.8rem);
  font-weight: 600;
  color: rgba(248, 250, 252, 0.55);
  line-height: 1.3;
  text-align: center;
  word-break: break-word;
}

.lt-hr-trend-panel__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: clamp(0.65rem, 1.8vh, 0.75rem);
  color: rgba(248, 250, 252, 0.55);
}

.lt-hr-trend-panel__window {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 700;
}

.lt-hr-trend-panel__trend {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-weight: 800;
}

.lt-hr-trend-panel__trend--rising {
  color: #86efac;
}

.lt-hr-trend-panel__trend--steady {
  color: #7dd3fc;
}

.lt-hr-trend-panel__trend--easing {
  color: #fde047;
}

.lt-hr-trend-panel__status {
  font-weight: 700;
}

.lt-hr-trend-panel__status--stale {
  color: #94a3b8;
}

.lt-hr-trend-panel__zone {
  margin: 0;
  font-size: clamp(0.65rem, 1.8vh, 0.75rem);
  font-weight: 700;
  color: #7dd3fc;
  text-align: center;
}

.lt-hr-trend-panel--panel .lt-hr-trend-chart {
  flex: 0 0 auto;
  min-height: 120px;
}

.lt-hr-trend-panel--compact {
  gap: 4px;
}

.lt-hr-trend-panel--compact .lt-hr-trend-panel__meta {
  font-size: 0.68rem;
  text-align: left;
}

.lt-hr-trend-panel--compact .lt-hr-trend-panel__top {
  justify-content: flex-start;
}

.lt-hr-trend-panel--compact .lt-hr-trend-panel__footer {
  font-size: 0.62rem;
}

.lt-hr-trend-chart {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);
}

.lt-kot-arena__player-toggle {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.lt-kot-arena__player--hr-trend {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 4px 6px 6px;
  gap: 0;
  justify-content: stretch;
  overflow: hidden;
}

.lt-kot-arena--landscape .lt-kot-arena__player--hr-trend {
  padding: 4px 6px;
  justify-content: stretch;
}

.lt-hr-trend-panel--arena {
  flex: 1 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.lt-hr-trend-panel__arena-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  flex-shrink: 0;
  min-height: 0;
}

.lt-hr-trend-panel__arena-meta {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: clamp(0.58rem, 1.8vh, 0.68rem);
  font-weight: 600;
  line-height: 1.2;
  color: rgba(248, 250, 252, 0.52);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-hr-trend-panel__arena-tools {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.lt-hr-trend-panel__bpm-chip--arena {
  font-size: clamp(0.72rem, 2.2vh, 0.85rem);
  padding: 2px 6px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.28);
}

.lt-pv__panel-mode-toggle--arena {
  min-width: 36px;
  min-height: 36px;
  padding: 6px;
}

.lt-hr-trend-panel__chart-grow {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.lt-hr-trend-chart--fill {
  flex: 1 1;
  min-height: 0;
  height: 100% !important;
  border-radius: 8px;
}

.lt-hr-trend-chart--arena {
  background: rgba(0, 0, 0, 0.32);
}

.lt-hr-trend-panel__arena-foot {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  font-size: clamp(0.56rem, 1.6vh, 0.64rem);
  font-weight: 700;
  color: rgba(248, 250, 252, 0.5);
  line-height: 1.2;
}

.lt-hr-trend-panel__arena-foot .lt-hr-trend-panel__window {
  font-size: inherit;
}

.lt-hr-trend-panel__arena-foot .lt-hr-trend-panel__trend {
  font-size: inherit;
}

.lt-hr-trend-panel__arena-zone {
  margin-left: auto;
  color: #7dd3fc;
  font-weight: 700;
  white-space: nowrap;
}

.lt-kot-arena--landscape .lt-kot-arena__player--hr-trend .lt-hr-trend-panel__chart-grow {
  min-height: 0;
}

.lt-kot-arena--portrait .lt-kot-arena__player--hr-trend {
  min-height: 0;
}

.lt-kot-arena--portrait .lt-kot-arena__player--hr-trend .lt-hr-trend-panel__chart-grow {
  min-height: 120px;
}

.lt-kot-arena__player--hr-trend .lt-kot-arena__live-score {
  display: none;
}

@media (max-height: 740px) {
  .lt-header {
    padding: 6px 12px;
  }

  .lt-progress {
    padding: 0 12px 6px;
  }

  .lt-progress__segments {
    margin-top: 4px;
  }

  .lt-page__main {
    padding: 4px 12px 8px;
  }

  .lt-hero__ring-wrap {
    width: 120px;
    height: 120px;
    margin-bottom: 8px;
  }

  .lt-hero__timer-value {
    font-size: 1.5rem;
  }

  .lt-hero__name {
    font-size: 1rem;
    margin-bottom: 6px;
  }

  .lt-hero__sequences {
    margin-bottom: 6px;
    gap: 4px;
  }

  .lt-hero__seq-pill {
    width: 22px;
    height: 22px;
    font-size: 0.68rem;
  }

  .lt-hero__exercise-remaining {
    margin: 0 auto 8px;
    padding: 3px 10px;
  }

  .lt-hero__seq-banner {
    margin-bottom: 6px;
    padding: 3px 10px;
  }

  .lt-coach-bar {
    padding: 8px 10px;
    gap: 6px;
  }

  .lt-page:not(.lt-page--landscape) .lt-coach-bar {
    padding-bottom: max(8px, env(safe-area-inset-bottom));
  }

  .lt-coach-bar__btn {
    padding: 8px 6px;
    font-size: 0.74rem;
    border-radius: 10px;
  }

  .lt-coach-bar__seq-nav {
    padding: 5px 12px 5px;
  }
}

@media (max-height: 620px) {
  .lt-progress__meta {
    margin-bottom: 3px;
  }

  .lt-progress__segments {
    display: none;
  }

  .lt-hero__ring-wrap {
    width: 96px;
    height: 96px;
    margin-bottom: 4px;
  }

  .lt-hero__timer-value {
    font-size: 1.25rem;
  }

  .lt-hero__timer-state {
    font-size: 0.58rem;
  }

  .lt-hero__name {
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .lt-hero__seq-pill {
    width: 18px;
    height: 18px;
    font-size: 0.6rem;
  }

  .lt-club-logo-wrap--bar {
    max-height: 40px;
  }
}

@media (min-width: 769px) {
  .lt-return-fab {
    display: none;
  }
}

.lt-page__chrono-review {
  display: flex;
  justify-content: center;
  padding: 8px 12px 16px;
}

.lt-player-chrono-review {
  min-height: 40px;
  padding: 8px 14px;
}

.lt-hero__pending {
  margin: 6px 0 0;
  font-size: 0.78rem;
  font-weight: 650;
  letter-spacing: 0.02em;
  color: #fbbf24;
}

.lt-hero__listen {
  margin-top: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: rgba(248, 250, 252, 0.85);
  border-radius: 999px;
  padding: 6px 12px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 650;
  cursor: pointer;
}

.lt-hero__listen.is-on {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
  color: #fff;
}

`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingPage.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;;EAEE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,gEAAgE;AAClE;;AAEA;;EAEE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,cAAc;EACd,gBAAgB;EAChB;yDACuD;EACvD,0EAA0E;EAC1E,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;;EAIE,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;EAC1B,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAiBA;;;;EAIE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;;gDAGgD;AAChD;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,+EAA+E;EAC/E,4DAA4D;EAC5D,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,4DAA4D;EAC5D,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,8EAA8E;EAC9E,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf;iDAC+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,qCAAqC;EACrC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,MAAM;AACR;;AAEA,iEAAiE;AACjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,MAAM;EACR;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,qEAAqE;EACrE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,qEAAqE;EACrE,sCAAsC;EACtC,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE;;;;GAIC;EACD,WAAW;AACb;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,SAAS;EACT,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;6BAC2B;EAC3B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,6EAA6E;EAC7E,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,6EAA6E;EAC7E,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uEAAuE;AACzE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;EAC9B,cAAc;EACd,8BAA8B;EAC9B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;EACvE,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uGAAuG;EACvG,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,gCAAgC;EAChC,wBAAwB,EAAE,oBAAoB;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,kCAAkC;AACpC;;AAEA;;kFAEkF;AAClF;EACE,kBAAkB;EAClB,iDAAiD;EACjD,mDAAmD;EACnD,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,0CAA0C;AAC5C;;AAEA;oDACoD;AACpD;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,2DAA2D;IAC3D,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;IACrB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;EACxE;;;;;GAKC;EACD;;0EAEwE;AAC1E;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uCAAuC;EACvC,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,uGAAuG;EACvG,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;EAC5B,8DAA8D;EAC9D,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA,aAAa;AACb;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;EACrD,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC;;GAEC;EACD,mBAAmB;EACnB,8DAA8D;EAC9D,aAAa;EACb,0DAA0D;EAC1D,kCAAkC;EAClC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE;;KAEC;IACD,iBAAiB;IACjB,aAAa;IACb,0DAA0D;EAC5D;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,0CAA0C;EAC1C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kDAAkD;EAClD,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,aAAa;EACb,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mEAAmE;EACnE,0EAA0E;AAC5E;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,4CAA4C;EAC5C,YAAY;EACZ,0EAA0E;EAC1E,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;;IAEE,2CAA2C;EAC7C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,oBAAoB;EACpB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,0BAA0B;EAC1B,sDAAsD;EACtD,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oFAAoF;AACtF;;AAEA;EACE,sCAAsC;EACtC,oFAAoF;AACtF;;AAEA;EACE;;wCAEsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,WAAW;EACX,iDAAiD;EACjD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,uGAAuG;EACvG,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE;;IAEE,wEAAwE;EAC1E;EACA;IACE,uEAAuE;EACzE;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA,kFAAkF;;AAElF,kEAAkE;AAClE;EACE,WAAW;EACX,eAAe;EACf,SAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,iDAAiD;EACjD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;IACrC,0CAA0C;EAC5C;EACA;IACE,qCAAqC;IACrC,2CAA2C;EAC7C;AACF;;AAEA,0EAA0E;AAC1E;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;EACR;;EAEA;;IAEE,QAAQ;EACV;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,MAAM;EACR;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sFAAsF;AACtF;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,0CAA0C;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kFAAkF;;AAElF;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;+EAG+E;;AAE/E;EACE,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;EACzC,SAAS;EACT,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0FAA0F;EAC1F,0CAA0C;EAC1C,oFAAoF;EACpF,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,+FAA+F;EAC/F,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,0EAA0E;AAC1E;;EAEE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gFAAgF;;AAEhF;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE;IACE,0CAA0C;IAC1C,aAAa;EACf;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0FAA0F;EAC1F,2CAA2C;EAC3C,kFAAkF;EAClF,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,6CAA6C;EAC7C,yFAAyF;AAC3F;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6FAA6F;EAC7F,qCAAqC;EACrC,6CAA6C;EAC7C,8CAA8C;AAChD;;AAEA;EACE;IACE,qCAAqC;IACrC,4CAA4C;EAC9C;EACA;IACE,qCAAqC;IACrC,6CAA6C;EAC/C;AACF;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,yFAAyF;AAC3F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,uBAAuB;AACzB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yFAAyF;EACzF,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,iFAAiF;;AAEjF;EACE,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAO;AACT;;AAEA,kFAAkF;AAClF;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;EACrD,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;AACpC;;AAEA,+EAA+E;;AAE/E,6DAA6D;AAC7D;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA,6DAA6D;AAC7D;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,8BAA8B;EAC9B,kDAAkD;EAClD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,SAAO;EACP,oBAAoB;EACpB,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,uDAAuD;EACvD,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,+CAA+C;AAC/C;EACE,mCAAmC;AACrC;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,kDAAkD;AAClD;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6EAA6E;AAC7E;;EAEE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;;EAEE,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF,wDAAwD;AACxD;EACE,WAAW;EACX,SAAO;EACP,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,2CAA2C;EAC3C,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;AACpC;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,sDAAsD;EACtD,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,MAAM;EACN,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;EACzE,WAAW;AACb","sourcesContent":["/* Immersive mode: lock viewport, prevent browser scroll chrome on live training */\nhtml.lt-immersive,\nhtml.lt-immersive body {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: touch;\n  touch-action: manipulation;\n}\n\nhtml.lt-immersive body {\n  background: #0f172a;\n}\n\nhtml.lt-immersive.lt-coach-live {\n  --lt-coach-bar-reserve: calc(56px + env(safe-area-inset-bottom));\n}\n\nhtml.lt-immersive.lt-coach-live:has(.lt-coach-bar__seq-nav) {\n  --lt-coach-bar-reserve: calc(92px + env(safe-area-inset-bottom));\n}\n\nhtml:fullscreen .lt-page,\nhtml:-webkit-full-screen .lt-page {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n  max-height: 100%;\n}\n\n.lt-page {\n  position: relative;\n  min-height: 100svh;\n  min-height: 100dvh;\n  height: 100svh;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(165deg, #0f172a 0%, #1e293b 45%, #0f172a 100%);\n  color: #f8fafc;\n  overflow: hidden;\n  padding: env(safe-area-inset-top) env(safe-area-inset-right)\n    env(safe-area-inset-bottom) env(safe-area-inset-left);\n  /* Size queries use the visual-viewport-sized page box, not 100vh media. */\n  container-type: size;\n  container-name: lt-page;\n}\n\n/* MUI Dialogs portaled into `.lt-page` must sit above the plan sheet (4200). */\n.lt-page > .MuiModal-root,\n.lt-page > .MuiDialog-root {\n  z-index: 5000;\n}\n\n.lt-page:has(.lt-coach-bar-wrap) {\n  padding-bottom: 0;\n}\n\nhtml.lt-immersive .lt-page {\n  position: fixed;\n  top: var(--lt-vvt, 0px);\n  left: var(--lt-vvl, 0px);\n  right: auto;\n  bottom: auto;\n  width: var(--lt-vvw, 100%);\n  max-width: var(--lt-vvw, 100%);\n  height: var(--lt-vvh, 100svh);\n  min-height: var(--lt-vvh, 100svh);\n  max-height: var(--lt-vvh, 100svh);\n  box-sizing: border-box;\n}\n\nhtml.lt-immersive.lt-player-live,\nhtml.lt-immersive.lt-player-live body,\nhtml.lt-immersive.lt-coach-live,\nhtml.lt-immersive.lt-coach-live body {\n  height: var(--lt-vvh, 100svh);\n  width: var(--lt-vvw, 100%);\n  max-width: 100%;\n  overflow: hidden;\n}\n\nhtml.lt-immersive.lt-player-live .lt-page,\nhtml.lt-immersive.lt-coach-live .lt-page {\n  height: var(--lt-vvh, 100svh);\n  max-height: var(--lt-vvh, 100svh);\n  width: var(--lt-vvw, 100%);\n  max-width: var(--lt-vvw, 100%);\n  padding-top: env(safe-area-inset-top, 0px);\n}\n\nhtml.lt-immersive.lt-player-live:fullscreen,\nhtml.lt-immersive.lt-player-live:-webkit-full-screen,\nhtml.lt-player-live:fullscreen,\nhtml.lt-player-live:-webkit-full-screen {\n  position: fixed !important;\n  inset: 0 !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  max-height: none !important;\n  margin: 0 !important;\n  overflow: hidden !important;\n}\n\nhtml:fullscreen.lt-player-live .lt-page,\nhtml:-webkit-full-screen.lt-player-live .lt-page,\n.lt-page:fullscreen,\n.lt-page:-webkit-full-screen {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 100% !important;\n  max-height: none !important;\n}\n\n/* iOS Safari and iOS Chrome reject document fullscreen and will not collapse\n   the URL bar while html/body are position:fixed and overflow:hidden.\n   Keep the document 2px scrollable so a tap can scroll the toolbar away, and\n   pin the training UI to the visual viewport. */\nhtml.lt-ios-phone.lt-immersive,\nhtml.lt-ios-phone.lt-immersive body,\nhtml.lt-ios-phone.lt-immersive.lt-player-live,\nhtml.lt-ios-phone.lt-immersive.lt-player-live body {\n  position: relative;\n  inset: auto;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  height: auto;\n  min-height: calc(100lvh + 2px);\n  width: var(--lt-vvw, 100%);\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  overscroll-behavior: none;\n}\n\nhtml.lt-ios-phone.lt-immersive .lt-page {\n  position: fixed;\n  top: var(--lt-vvt, 0px);\n  left: var(--lt-vvl, 0px);\n  width: var(--lt-vvw, 100%);\n  max-width: var(--lt-vvw, 100%);\n  height: var(--lt-vvh, 100dvh);\n  min-height: 0;\n  max-height: var(--lt-vvh, 100dvh);\n}\n\n/* Landscape player: keep body/actions inside the remaining visual viewport. */\nhtml.lt-immersive.lt-player-live .lt-page--landscape {\n  overflow: hidden;\n}\n\nhtml.lt-immersive.lt-player-live .lt-page--landscape .lt-page__body {\n  min-height: 0;\n  max-height: 100%;\n  overflow: hidden;\n}\n\nhtml[data-pingflo-tour=\"1\"] .lt-fs-gate {\n  display: none !important;\n}\n\n.lt-fs-gate {\n  position: fixed;\n  left: 50%;\n  /* Sit near the bottom of the visible viewport (accounts for browser chrome). */\n  top: calc(var(--lt-vvt, 0px) + var(--lt-vvh, 100dvh) - 72px);\n  bottom: auto;\n  z-index: 4000;\n  display: inline-flex;\n  width: max-content;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #f8fafc;\n  cursor: pointer;\n  transform: translateX(-50%);\n  animation: lt-fs-gate-in 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n  max-width: calc(var(--lt-vvw, 100vw) - 24px);\n  touch-action: manipulation;\n}\n\n@keyframes lt-fs-gate-in {\n  from {\n    opacity: 0;\n    transform: translate(-50%, 10px);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n}\n\n.lt-fs-gate__label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 12px 22px;\n  border-radius: 999px;\n  background: linear-gradient(135deg, var(--lt-brand, #0877bc) 0%, #065a8f 100%);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: 0.01em;\n}\n\n.lt-page--loading {\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-page--mobile-only {\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n}\n\n.lt-mobile-only {\n  width: min(420px, 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 28px 24px;\n  border-radius: 20px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);\n  backdrop-filter: blur(16px);\n}\n\n.lt-mobile-only__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.lt-mobile-only__copy {\n  margin: 0;\n  font-size: 0.98rem;\n  line-height: 1.5;\n  color: rgba(248, 250, 252, 0.82);\n}\n\n.lt-mobile-only__btn {\n  margin-top: 6px;\n  padding: 11px 18px;\n  border: none;\n  border-radius: 12px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.lt-mobile-only__btn:hover {\n  transform: scale(1.02);\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent);\n}\n\n.lt-mobile-only__btn:active {\n  transform: scale(0.97);\n}\n\n.lt-mobile-only__btn:focus-visible {\n  outline: 2px solid #38bdf8;\n  outline-offset: 2px;\n}\n\n.lt-page--landscape .lt-page__body {\n  flex-direction: row;\n  align-items: stretch;\n  overflow: hidden;\n}\n\n.lt-page--landscape .lt-page__main {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lt-page--landscape .lt-page__actions {\n  width: auto;\n  border-left: none;\n  padding: 0;\n  justify-content: flex-end;\n}\n\n/* Header */\n.lt-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.lt-header__brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.lt-header__icon {\n  color: var(--lt-brand, #0877bc);\n  font-size: 28px !important;\n  width: 28px;\n  height: 28px;\n}\n\n/* Club logo — shared live training branding */\n.lt-club-logo-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-club-logo {\n  display: block;\n  object-fit: contain;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.94);\n  padding: 2px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.22);\n}\n\n.lt-club-logo--sm {\n  width: clamp(26px, 5vh, 34px);\n  height: clamp(26px, 5vh, 34px);\n}\n\n.lt-club-logo--md {\n  width: clamp(32px, 6vh, 44px);\n  height: clamp(32px, 6vh, 44px);\n}\n\n.lt-club-logo--lg {\n  width: clamp(44px, 9vh, 64px);\n  height: clamp(44px, 9vh, 64px);\n  border-radius: 12px;\n  padding: 4px;\n}\n\n.lt-club-logo-wrap--bar {\n  height: 100%;\n  align-self: stretch;\n}\n\n.lt-club-logo--bar {\n  height: 100%;\n  width: auto;\n  max-height: 52px;\n  min-height: 34px;\n  aspect-ratio: 1;\n  object-fit: contain;\n}\n\n.lt-club-logo-wrap__name {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.82);\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-header__club-logo {\n  flex-shrink: 0;\n}\n\n.lt-return-fab__icon {\n  font-size: 1rem;\n  width: 1rem;\n  height: 1rem;\n}\n\n.lt-header__titles {\n  min-width: 0;\n}\n\n.lt-header__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-header__title-num {\n  color: var(--lt-brand, var(--brand-primary, #0877bc));\n}\n\n.lt-header__sub {\n  font-size: 0.75rem;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-header__home-btn,\n.lt-header__dashboard-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-header__home-btn:active,\n.lt-header__dashboard-btn:active {\n  transform: scale(0.97);\n}\n\n/* Landscape: icon-only home (matches prior isLandscape behavior) */\n.lt-page--landscape .lt-header__home-label {\n  display: none;\n}\n\n.lt-page--landscape .lt-header__home-btn {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  justify-content: center;\n  gap: 0;\n}\n\n/* Mobile: home icon only — keep session # visible in the title */\n@media (max-width: 768px) {\n  .lt-header__home-label {\n    display: none;\n  }\n\n  .lt-header__home-btn {\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    justify-content: center;\n    gap: 0;\n  }\n\n  .lt-header__title {\n    font-size: 0.92rem;\n  }\n\n  .lt-header__title-num {\n    font-weight: 800;\n  }\n}\n\n.lt-header__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-header__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-header__icon-btn:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.lt-header__icon-btn:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.lt-header__icon-btn--spinning svg {\n  animation: lt-refresh-spin 0.8s linear infinite;\n}\n\n.lt-hero__type-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6px 8px;\n  margin: 0 0 6px;\n  min-width: 0;\n}\n\n.lt-hero__type {\n  font-size: clamp(0.9rem, 2.4vh, 1.1rem);\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n  min-width: 0;\n  max-width: min(100%, 14rem);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-hero__assign {\n  flex-shrink: 0;\n  border: 0;\n  border-radius: 999px;\n  padding: 5px 10px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  line-height: 1.2;\n  cursor: pointer;\n}\n\n.lt-hero__assign:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__type-row {\n  margin-bottom: 4px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__type {\n  font-size: clamp(0.86rem, 2.2vh, 1.05rem);\n}\n\n/* Progress */\n.lt-progress {\n  padding: 0 16px 12px;\n  flex-shrink: 0;\n}\n\n.lt-progress__meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.75rem;\n  margin-bottom: 6px;\n  color: rgba(248, 250, 252, 0.75);\n  gap: 8px;\n}\n\n.lt-progress__meta-right {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lt-progress__plan-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  border-radius: 999px;\n  padding: 3px 10px 3px 6px;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.lt-progress__plan-btn:active {\n  transform: scale(0.97);\n}\n\n.lt-progress__track {\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  overflow: hidden;\n}\n\n.lt-progress__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--lt-brand, #0877bc), #22c55e);\n  transition: width 0.4s ease;\n}\n\n.lt-progress__segments {\n  display: flex;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.lt-progress__segments--named {\n  gap: 6px;\n  overflow-x: auto;\n  padding-bottom: 2px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.lt-progress__segments--named::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-progress__seg {\n  flex: 1;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.lt-progress__seg--named {\n  flex: 0 0 auto;\n  min-width: 36px;\n  max-width: 48px;\n  height: auto;\n  min-height: 28px;\n  padding: 4px 0;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-progress__seg-label {\n  font-size: 0.8rem;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n  color: rgba(248, 250, 252, 0.85);\n  white-space: nowrap;\n}\n\n.lt-progress__seg--done {\n  background: #22c55e;\n}\n\n.lt-progress__seg--named.lt-progress__seg--done {\n  background: color-mix(in srgb, #22c55e 35%, rgba(15, 23, 42, 0.9));\n  border-color: rgba(34, 197, 94, 0.45);\n}\n\n.lt-progress__seg--current {\n  background: var(--lt-brand, #0877bc);\n  box-shadow: 0 0 8px var(--lt-brand, #0877bc);\n}\n\n.lt-progress__seg--named.lt-progress__seg--current {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #0f172a);\n  border-color: var(--lt-brand, #0877bc);\n  box-shadow: 0 0 10px color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent);\n}\n\n.lt-progress__seg--named.lt-progress__seg--current .lt-progress__seg-label {\n  color: #fff;\n  font-size: 0.95rem;\n}\n\nbutton.lt-progress__seg {\n  appearance: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n}\n\nbutton.lt-progress__seg.lt-progress__seg--named {\n  padding: 4px 0;\n  height: auto;\n  min-height: 28px;\n}\n\n.lt-progress__seg--review {\n  cursor: pointer;\n  min-height: 8px;\n  height: 8px;\n  transition: filter 0.18s ease, transform 0.18s ease;\n}\n\n.lt-progress__seg--named.lt-progress__seg--review {\n  height: auto;\n  min-height: 28px;\n}\n\n.lt-progress__seg--review:hover {\n  filter: brightness(1.25);\n  transform: scaleY(1.35);\n}\n\n.lt-progress__seg--review:focus-visible {\n  outline: 2px solid #22c55e;\n  outline-offset: 2px;\n}\n\n.lt-progress__seg--select {\n  cursor: pointer;\n  min-height: 8px;\n  height: 8px;\n  transition: filter 0.18s ease, transform 0.18s ease;\n}\n\n.lt-progress__seg--select:hover {\n  filter: brightness(1.2);\n  transform: scaleY(1.35);\n}\n\n.lt-progress__seg--select:focus-visible {\n  outline: 2px solid var(--lt-brand, #0877bc);\n  outline-offset: 2px;\n}\n\n/* Station tabs — coach switches between training stations */\n.lt-station-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 0 16px 10px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  flex-shrink: 0;\n}\n\n.lt-station-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-station-tabs__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding: 7px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(248, 250, 252, 0.88);\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.lt-station-tabs__btn--selected {\n  border-color: var(--lt-station-accent, var(--lt-brand, #0877bc));\n  background: color-mix(\n    in srgb,\n    var(--lt-station-accent, var(--lt-brand, #0877bc)) 28%,\n    transparent\n  );\n  color: #fff;\n}\n\n.lt-station-tabs__btn--live {\n  box-shadow: 0 0 0 1px color-mix(in srgb, #22c55e 55%, transparent);\n}\n\n.lt-station-tabs__btn--done {\n  opacity: 0.7;\n}\n\n.lt-station-tabs__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--lt-station-accent, var(--lt-brand, #0877bc));\n}\n\n.lt-station-tabs__live {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #4ade80;\n}\n\n.lt-hero__station {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n/* Body */\n.lt-page__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.lt-page__body--kot-player {\n  overflow: hidden;\n}\n\n/* KoT arena has its own footer actions — keep FABs out of the way in landscape */\n.lt-page--landscape:has(.lt-page__body--kot-player) .lt-page__actions {\n  top: auto;\n  bottom: calc(6px + env(safe-area-inset-bottom));\n  right: 8px;\n}\n\n.lt-page--landscape:has(.lt-page__body--kot-player) .lt-page__fab {\n  width: 40px;\n  height: 40px;\n}\n\n.lt-page__main {\n  flex: 1;\n  padding: 8px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.lt-page__main:has(.lt-coach-dash) {\n  align-items: stretch;\n  min-height: 0;\n  padding-bottom: 12px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero {\n  flex-shrink: 1;\n}\n\n.lt-page__error {\n  color: #fca5a5;\n  font-size: 0.875rem;\n  text-align: center;\n}\n\n/* Session complete overlay */\n.lt-session-complete-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1150;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)\n    env(safe-area-inset-left);\n  background: rgba(15, 23, 42, 0.92);\n  backdrop-filter: blur(6px);\n}\n\n.lt-session-complete {\n  position: relative;\n  width: min(100%, 420px);\n  text-align: center;\n  padding: 28px 20px 24px;\n}\n\n.lt-session-complete__glow {\n  position: absolute;\n  inset: 10% 5%;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(34, 197, 94, 0.22), transparent 70%);\n  pointer-events: none;\n}\n\n.lt-session-complete__club-logo {\n  margin-bottom: 12px;\n}\n\n.lt-session-complete__icon {\n  font-size: 3rem !important;\n  color: #4ade80;\n  margin-bottom: 8px;\n}\n\n.lt-session-complete__title {\n  margin: 0 0 10px;\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.lt-session-complete__message {\n  margin: 0 0 22px;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.lt-session-complete__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-width: 200px;\n  padding: 13px 20px;\n  border: none;\n  border-radius: 999px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.35);\n}\n\n.lt-session-complete__btn:hover {\n  filter: brightness(1.06);\n}\n\n/* Session decision (finalize vs add exercise) */\n.lt-session-decision {\n  position: relative;\n  width: min(100%, 420px);\n  text-align: center;\n  padding: 28px 20px 24px;\n}\n\n.lt-session-decision__glow {\n  position: absolute;\n  inset: 10% 5%;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(8, 119, 188, 0.28), transparent 70%);\n  pointer-events: none;\n}\n\n.lt-session-decision__club-logo {\n  margin-bottom: 12px;\n}\n\n.lt-session-decision__icon {\n  font-size: 3rem !important;\n  color: #38bdf8;\n  margin-bottom: 8px;\n}\n\n.lt-session-decision__title {\n  margin: 0 0 10px;\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.lt-session-decision__message {\n  margin: 0 0 22px;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.lt-session-decision__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.lt-session-decision__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 13px 20px;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  border: none;\n  transition: transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;\n}\n\n.lt-session-decision__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.lt-session-decision__btn:not(:disabled):hover {\n  filter: brightness(1.06);\n}\n\n.lt-session-decision__btn:not(:disabled):active {\n  transform: scale(0.98);\n}\n\n.lt-session-decision__btn--primary {\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.35);\n}\n\n.lt-session-decision__btn--secondary {\n  background: rgba(248, 250, 252, 0.08);\n  color: #f8fafc;\n  border: 1px solid rgba(248, 250, 252, 0.18);\n}\n\n/* Add exercise wizard (live) */\n.lt-add-ex-dialog__paper {\n  background: #0f172a !important;\n  color: #f8fafc;\n  border-radius: 18px !important;\n  border: 1px solid rgba(248, 250, 252, 0.1);\n  overflow: hidden;\n}\n\n.lt-add-ex-dialog__header {\n  padding: 14px 16px 8px;\n  border-bottom: 1px solid rgba(248, 250, 252, 0.08);\n}\n\n.lt-add-ex-dialog__header-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lt-add-ex-dialog__title {\n  flex: 1;\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 750;\n  text-align: center;\n  color: #f8fafc;\n}\n\n.lt-add-ex-dialog__breadcrumb {\n  margin: 6px 0 0;\n  font-size: 0.8rem;\n  color: rgba(248, 250, 252, 0.55);\n  text-align: center;\n}\n\n.lt-add-ex-dialog__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(248, 250, 252, 0.06);\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-add-ex-dialog__icon-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-add-ex-dialog__icon-btn-spacer {\n  width: 36px;\n  height: 36px;\n}\n\n.lt-add-ex-dialog__body {\n  min-height: 220px;\n  max-height: min(60vh, 480px);\n  overflow: auto;\n  padding: 12px 14px 16px;\n}\n\n.lt-add-ex-dialog__loader {\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n}\n\n.lt-add-ex-dialog__error {\n  margin: 0 0 10px;\n  color: #fca5a5;\n  font-size: 0.875rem;\n  text-align: center;\n}\n\n.lt-add-ex-dialog__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-add-ex-dialog__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(248, 250, 252, 0.1);\n  background: rgba(248, 250, 252, 0.04);\n  color: #f8fafc;\n  font-size: 0.95rem;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;\n}\n\n.lt-add-ex-dialog__item:hover {\n  background: rgba(8, 119, 188, 0.18);\n  border-color: rgba(56, 189, 248, 0.35);\n}\n\n.lt-add-ex-dialog__item:active {\n  transform: scale(0.99);\n}\n\n.lt-add-ex-dialog__item--active {\n  background: rgba(8, 119, 188, 0.28);\n  border-color: var(--lt-brand, #0877bc);\n}\n\n.lt-add-ex-dialog__item-name {\n  flex: 1;\n}\n\n.lt-add-ex-dialog__item-meta {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: rgba(248, 250, 252, 0.55);\n  white-space: nowrap;\n}\n\n.lt-add-ex-dialog__item-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n}\n\n.lt-add-ex-dialog__item-row--active {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #94a3b8);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, transparent);\n}\n\n.lt-add-ex-dialog__item-row .lt-add-ex-dialog__item {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\n.lt-add-ex-dialog__prefs {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 8px 8px;\n}\n\n.lt-add-ex-dialog__fav {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  color: #94a3b8;\n  background: rgba(148, 163, 184, 0.12);\n  cursor: pointer;\n}\n\n.lt-add-ex-dialog__fav.is-on {\n  color: #f59e0b;\n  background: color-mix(in srgb, #f59e0b 18%, transparent);\n}\n\n.lt-add-ex-dialog__rating {\n  display: inline-flex;\n  gap: 2px;\n}\n\n.lt-add-ex-dialog__rate {\n  min-width: 26px;\n  height: 26px;\n  border: 0;\n  border-radius: 6px;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #64748b;\n  background: rgba(148, 163, 184, 0.14);\n  cursor: pointer;\n}\n\n.lt-add-ex-dialog__rate.is-on {\n  color: #fff;\n  background: var(--lt-brand, #0877bc);\n}\n\n.lt-add-ex-dialog__duration {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 14px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(248, 250, 252, 0.05);\n}\n\n.lt-add-ex-dialog__duration label {\n  font-size: 0.875rem;\n  color: rgba(248, 250, 252, 0.8);\n}\n\n.lt-add-ex-dialog__duration input {\n  width: 88px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(248, 250, 252, 0.16);\n  background: #0b1220;\n  color: #f8fafc;\n  font-weight: 600;\n}\n\n.lt-add-ex-dialog__footer {\n  padding: 12px 14px 16px;\n  border-top: 1px solid rgba(248, 250, 252, 0.08);\n}\n\n.lt-add-ex-dialog__add-btn {\n  width: 100%;\n  padding: 13px 18px;\n  border: none;\n  border-radius: 12px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.95rem;\n  cursor: pointer;\n  box-shadow: 0 10px 28px rgba(8, 119, 188, 0.3);\n}\n\n.lt-add-ex-dialog__add-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.lt-add-ex-dialog__add-btn:not(:disabled):hover {\n  filter: brightness(1.06);\n}\n\n/* Waiting room */\n.lt-waiting {\n  text-align: center;\n  padding: 32px 16px;\n  position: relative;\n}\n\n.lt-waiting__pulse {\n  position: absolute;\n  inset: 20% 15%;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(var(--brand-primary-rgb, 8, 119, 188), 0.25), transparent 70%);\n  animation: lt-pulse 2.5s ease-in-out infinite;\n}\n\n@keyframes lt-pulse {\n  0%,\n  100% {\n    transform: scale(0.95);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 1;\n  }\n}\n\n.lt-waiting__club-logo {\n  margin-bottom: 14px;\n}\n\n.lt-waiting__club-logo .lt-club-logo-wrap__name {\n  display: block;\n  text-align: center;\n  max-width: 200px;\n  margin-top: 6px;\n  font-size: 0.85rem;\n}\n\n.lt-waiting__icon {\n  font-size: 48px !important;\n  color: var(--lt-brand, #0877bc);\n  margin-bottom: 12px;\n}\n\n.lt-waiting__title {\n  font-size: 1.25rem;\n  margin: 0 0 8px;\n}\n\n.lt-waiting__hint {\n  color: rgba(248, 250, 252, 0.7);\n  font-size: 0.875rem;\n  margin: 0 0 20px;\n}\n\n.lt-waiting__countdown {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 24px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-waiting__countdown-value {\n  font-size: 1.75rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #fbbf24;\n}\n\n.lt-waiting__table-card {\n  margin-top: 24px;\n  padding: 16px 28px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  display: inline-flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lt-waiting__table-num {\n  font-size: 1.5rem;\n  font-weight: 800;\n}\n\n/* Exercise hero */\n.lt-hero {\n  width: 100%;\n  max-width: 360px;\n  text-align: center;\n}\n\n.lt-hero__ring-wrap {\n  position: relative;\n  width: 160px;\n  height: 160px;\n  margin: 0 auto 20px;\n}\n\n.lt-hero__ring {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.lt-hero__ring-bg {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.1);\n  stroke-width: 8;\n}\n\n.lt-hero__ring-progress {\n  fill: none;\n  stroke: var(--lt-brand, #0877bc);\n  stroke-width: 8;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.5s linear;\n}\n\n.lt-hero--urgent .lt-hero__ring-progress {\n  stroke: #ef4444;\n  animation: lt-ring-urgent 1s ease-in-out infinite;\n}\n\n@keyframes lt-ring-urgent {\n  50% {\n    stroke-opacity: 0.5;\n  }\n}\n\n.lt-hero__timer {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-hero__timer-value {\n  font-size: 2rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-hero__timer-state {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #22c55e;\n}\n\n.lt-hero--paused .lt-hero__timer-state {\n  color: #fbbf24;\n}\n\n.lt-hero__name {\n  font-size: 1.125rem;\n  font-weight: 700;\n  margin: 0 0 6px;\n  padding: 0 8px;\n  line-height: 1.3;\n  max-width: 100%;\n}\n\n.lt-hero__name--coach-tap {\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  border-radius: 8px;\n  touch-action: manipulation;\n}\n\n.lt-hero__name--coach-tap:active {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.lt-hero__schema {\n  margin: 0 0 12px;\n  padding: 0 8px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.lt-hero__number {\n  margin-right: 0.28em;\n  color: #fcd34d;\n  font-weight: 900;\n}\n\n/* Coach KoT gameplay params (live training) */\n.lt-kot-coach-params {\n  margin: 0 16px 14px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: rgba(251, 191, 36, 0.06);\n  border: 1px solid rgba(251, 191, 36, 0.22);\n}\n\n.lt-kot-coach-params__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.lt-kot-coach-params__label {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #fcd34d;\n}\n\n.lt-kot-coach-params__saved {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #4ade80;\n}\n\n.lt-kot-coach-params__toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.lt-kot-coach-params__toggle--disabled {\n  opacity: 0.65;\n}\n\n.lt-kot-coach-params__mode {\n  min-height: 44px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(15, 23, 42, 0.55);\n  color: rgba(248, 250, 252, 0.88);\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.25;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.lt-kot-coach-params__mode:disabled {\n  cursor: not-allowed;\n}\n\n.lt-kot-coach-params__mode--active {\n  background: rgba(8, 119, 188, 0.35);\n  border-color: rgba(125, 211, 252, 0.55);\n  color: #f8fafc;\n  box-shadow: inset 0 0 0 1px rgba(125, 211, 252, 0.2);\n}\n\n.lt-kot-coach-params__pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.lt-kot-coach-params__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.lt-kot-coach-params__pill--round {\n  background: rgba(8, 119, 188, 0.2);\n  color: #7dd3fc;\n  border: 1px solid rgba(8, 119, 188, 0.35);\n}\n\n.lt-kot-coach-params__pill--rule {\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(248, 250, 252, 0.82);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-kot-coach-params__error {\n  margin: 8px 0 0;\n  font-size: 0.78rem;\n  color: #fca5a5;\n}\n\n.lt-hero__sequences {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.lt-hero__seq-pill {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid transparent;\n}\n\n.lt-hero__seq-pill--active {\n  border-color: var(--lt-brand, #0877bc);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3);\n}\n\n.lt-hero__seq-pill--done {\n  background: #22c55e;\n  color: #052e16;\n}\n\n.lt-hero__matchup {\n  font-size: 0.875rem;\n  color: rgba(248, 250, 252, 0.8);\n}\n\n.lt-hero__table {\n  font-weight: 700;\n  color: #fbbf24;\n}\n\n/* Between-sequences banner (coach view) */\n.lt-hero__seq-banner {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 14px;\n  border-radius: 999px;\n  background: rgba(34, 197, 94, 0.18);\n  border: 1px solid rgba(34, 197, 94, 0.45);\n  color: #4ade80;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n\n/* Ring colour: green when between sequences */\n.lt-hero--between-seq .lt-hero__ring-progress {\n  stroke: #22c55e;\n}\n\n/* Ring colour: muted when idle (exercise not started) */\n.lt-hero--idle .lt-hero__ring-progress {\n  stroke: rgba(255, 255, 255, 0.2);\n  stroke-dashoffset: 326.7; /* full empty ring */\n}\n\n.lt-hero--kot-round .lt-hero__ring-progress {\n  stroke: #38bdf8;\n}\n\n.lt-hero__exercise-remaining {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: -8px auto 16px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.lt-hero__exercise-remaining-label {\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.lt-hero__exercise-remaining-value {\n  font-size: 0.82rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #f8fafc;\n}\n\n.lt-hero__exercise-remaining--urgent {\n  border-color: rgba(239, 68, 68, 0.45);\n  background: rgba(239, 68, 68, 0.12);\n}\n\n.lt-hero__exercise-remaining--urgent .lt-hero__exercise-remaining-value {\n  color: #fca5a5;\n}\n\n/* State label variants */\n.lt-hero__timer-state--ex {\n  color: #4ade80;\n}\n.lt-hero__timer-state--idle {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 0.65rem;\n}\n\n/* \"Start next sequence\" button — full-width, stands out */\n.lt-coach-bar__btn--next-seq {\n  flex: 1 1 100%;\n  font-size: 0.9rem;\n  padding: 12px 10px;\n  background: #16a34a;\n  border-color: transparent;\n  box-shadow: 0 4px 16px rgba(22, 163, 74, 0.4);\n}\n.lt-coach-bar__btn--next-seq:active {\n  transform: scale(0.97);\n}\n\n.lt-coach-bar__btn--auto-pause {\n  flex: 1 1 100%;\n  font-size: 0.88rem;\n  font-weight: 800;\n  padding: 12px 10px;\n  text-align: center;\n  border-radius: 12px;\n  background: rgba(251, 191, 36, 0.18);\n  border: 1px solid rgba(251, 191, 36, 0.55);\n  color: #fbbf24;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Actions — camera / settings / Digiping stack.\n   Absolute inside .lt-page so the column stays in the visual viewport when the\n   browser bar does not hide (e.g. Oppo). Fixed + bottom would climb off-screen. */\n.lt-page__actions {\n  position: absolute;\n  right: max(10px, env(safe-area-inset-right, 0px));\n  bottom: max(10px, env(safe-area-inset-bottom, 0px));\n  z-index: 1050;\n  padding: 0;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 10px;\n  max-height: calc(100% - 12px);\n  overflow-x: visible;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.lt-page__actions::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-page--landscape .lt-page__actions {\n  right: max(8px, env(safe-area-inset-right, 0px));\n  bottom: max(8px, env(safe-area-inset-bottom, 0px));\n}\n\n.lt-page__fab {\n  position: relative;\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  border-radius: 50%;\n  border: none;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);\n}\n\n/* Short visual viewport (browser chrome still visible): shrink the FAB column\n   so camera setup above Digiping stays on screen. */\n@container lt-page (max-height: 640px) {\n  .lt-page__actions {\n    gap: 6px;\n  }\n\n  .lt-page__actions .lt-page__fab {\n    width: 42px;\n    height: 42px;\n  }\n}\n\n@container lt-page (max-height: 520px) {\n  .lt-page__actions {\n    gap: 4px;\n  }\n\n  .lt-page__actions .lt-page__fab {\n    width: 36px;\n    height: 36px;\n  }\n\n  .lt-page__actions .lt-page__fab svg {\n    font-size: 1.1rem;\n  }\n}\n\n@container lt-page (max-height: 400px) {\n  .lt-page__actions {\n    gap: 3px;\n    /* Horizontal pack when the column cannot fit vertically. */\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    justify-content: flex-start;\n    max-width: min(100% - 16px, 220px);\n  }\n\n  .lt-page__actions .lt-page__fab {\n    width: 34px;\n    height: 34px;\n  }\n}\n\n.lt-page__fab:active {\n  transform: scale(0.94);\n}\n\n.lt-page__fab--digiping {\n  border: 2px solid color-mix(in srgb, var(--lt-brand, #0877bc) 55%, #fff);\n  background: radial-gradient(\n    circle at 30% 25%,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 45%, transparent),\n    color-mix(in srgb, var(--lt-brand, #0877bc) 92%, #0b0f19) 55%,\n    #065a8f\n  );\n  box-shadow:\n    0 8px 22px color-mix(in srgb, var(--lt-brand, #0877bc) 40%, transparent),\n    0 0 16px color-mix(in srgb, var(--lt-brand, #0877bc) 18%, transparent);\n}\n\n.lt-page__fab--refresh {\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n}\n\n.lt-page__fab--refresh:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.lt-page__fab--spinning svg {\n  animation: lt-refresh-spin 0.8s linear infinite;\n}\n\n@keyframes lt-refresh-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.lt-page__kot-hint {\n  margin-top: 20px;\n  padding: 12px 16px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, rgba(251, 191, 36, 0.2), rgba(245, 158, 11, 0.1));\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n  max-width: 360px;\n}\n\n.lt-page__kot-btn {\n  padding: 8px 16px;\n  border-radius: 999px;\n  border: none;\n  background: #fbbf24;\n  color: #422006;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n/* Coach bar — fixed above table-setting overlays */\n.lt-coach-bar-wrap {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  z-index: 1600;\n  pointer-events: none;\n}\n\n.lt-coach-bar-wrap > * {\n  pointer-events: auto;\n}\n\n.lt-coach-bar-chrome {\n  display: flex;\n  flex-direction: column;\n  background: rgba(15, 23, 42, 0.95);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-page--landscape .lt-coach-bar-chrome {\n  border-top: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.08);\n  min-height: 0;\n}\n\n.lt-coach-bar__seq-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 7px 14px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-page--landscape .lt-coach-bar__seq-nav {\n  padding: 8px 12px;\n}\n\n.lt-coach-bar__seq-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin: 0;\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.3;\n  color: #f8fafc;\n}\n\n.lt-coach-bar__seq-kicker {\n  flex-shrink: 0;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(186, 230, 253, 0.92);\n}\n\n.lt-coach-bar__seq-value {\n  min-width: 0;\n  font-weight: 700;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.lt-coach-bar__seq-row--next {\n  color: rgba(248, 250, 252, 0.92);\n}\n\n.lt-coach-bar__seq-row--next .lt-coach-bar__seq-kicker {\n  color: #7dd3fc;\n}\n\n.lt-page:not(.lt-page--landscape) .lt-coach-bar-wrap {\n  position: relative;\n  flex-shrink: 0;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.42);\n}\n\n.lt-page--landscape .lt-coach-bar-wrap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 200px;\n  justify-content: flex-end;\n  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.32);\n}\n\n.lt-page:not(.lt-page--landscape):has(.lt-coach-bar-wrap) .lt-page__body {\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.lt-page:not(.lt-page--landscape):has(.lt-coach-bar-wrap) .lt-page__main {\n  overflow: hidden;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero {\n  flex: 0 1 auto;\n  max-width: min(360px, 100%);\n  margin: 0 auto;\n  width: 100%;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__ring-wrap {\n  width: clamp(96px, 22vh, 148px);\n  height: clamp(96px, 22vh, 148px);\n  margin: 0 auto 10px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__timer-value {\n  font-size: clamp(1.35rem, 4.2vh, 1.85rem);\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__name {\n  font-size: clamp(0.9rem, 2.4vh, 1.1rem);\n  margin-bottom: 6px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-hero__sequences {\n  margin-top: 6px;\n  gap: 4px;\n}\n\n.lt-page__main:has(.lt-coach-dash) .lt-coach-dash {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lt-page--landscape:has(.lt-coach-bar-wrap) .lt-page__body {\n  padding-right: 200px;\n}\n\n.lt-coach-bar__error {\n  margin: 0;\n  padding: 8px 16px;\n  background: rgba(127, 29, 29, 0.85);\n  color: #fecaca;\n  font-size: 0.8rem;\n  text-align: center;\n  border-top: 1px solid rgba(239, 68, 68, 0.4);\n}\n\n.lt-coach-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px 12px;\n  background: transparent;\n  border-top: none;\n  flex-shrink: 0;\n}\n\n.lt-page:not(.lt-page--landscape) .lt-coach-bar {\n  position: relative;\n  bottom: auto;\n  padding-bottom: max(10px, env(safe-area-inset-bottom));\n}\n\n.lt-page--landscape .lt-coach-bar {\n  flex-direction: column;\n  border-top: none;\n  border-left: none;\n  width: 200px;\n  justify-content: center;\n  padding-bottom: max(10px, env(safe-area-inset-bottom));\n}\n\n.lt-coach-bar__btn {\n  flex: 1 1 calc(33.333% - 8px);\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 10px 8px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.8rem;\n  line-height: 1.15;\n  text-align: center;\n  white-space: normal;\n  cursor: pointer;\n}\n\n.lt-coach-bar__btn svg {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n}\n\n.lt-coach-bar__btn--primary {\n  background: var(--lt-brand, #0877bc);\n  border-color: transparent;\n}\n\n.lt-coach-bar__btn--danger {\n  background: rgba(239, 68, 68, 0.25);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.lt-coach-bar__btn--skip {\n  background: rgba(245, 158, 11, 0.18);\n  border-color: rgba(245, 158, 11, 0.5);\n  color: #fde68a;\n}\n\n.lt-coach-bar__btn--skip:active {\n  transform: scale(0.97);\n}\n\n.lt-coach-bar__btn--kot-stop {\n  background: rgba(245, 124, 0, 0.22);\n  border-color: rgba(245, 124, 0, 0.55);\n  color: #ffedd5;\n}\n\n/* Sheets */\n.lt-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 1600;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  box-sizing: border-box;\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n\n.lt-page--landscape .lt-sheet-backdrop {\n  align-items: center;\n  padding-top: max(8px, env(safe-area-inset-top));\n  padding-bottom: max(8px, env(safe-area-inset-bottom));\n}\n\n.lt-sheet {\n  width: 100%;\n  max-width: min(480px, 100%);\n  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)));\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  background: #1e293b;\n  border-radius: 20px 20px 0 0;\n  padding: 16px 16px max(16px, env(safe-area-inset-bottom, 0px));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-sizing: border-box;\n}\n\n.lt-page--landscape .lt-sheet {\n  border-radius: 20px;\n  max-height: min(88dvh, calc(100dvh - 24px));\n}\n\n.lt-sheet.lt-ae {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n}\n\n.lt-ae__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lt-ae__footer {\n  flex: 0 0 auto;\n  padding-top: 8px;\n  background: #1e293b;\n}\n\n.lt-ae__error {\n  margin: 8px 0 0;\n  color: #fca5a5;\n  font-size: 0.82rem;\n}\n\n.lt-sheet__title {\n  margin: 0 0 4px;\n  font-size: 1.125rem;\n}\n\n.lt-sheet__subtitle {\n  margin: 0 0 16px;\n  color: rgba(248, 250, 252, 0.65);\n  font-size: 0.875rem;\n}\n\n.lt-sheet__submit {\n  width: 100%;\n  margin-top: 8px;\n  padding: 14px;\n  border: none;\n  border-radius: 12px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.lt-sheet__submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-sheet__skip {\n  width: 100%;\n  margin-top: 10px;\n  padding: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  background: transparent;\n  color: inherit;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  opacity: 0.85;\n}\n\n/* Autoeval */\n.lt-ae__player {\n  margin: 0 0 8px;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: rgba(8, 119, 188, 0.22);\n  border: 1px solid rgba(8, 119, 188, 0.45);\n  color: #e0f2fe;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  text-align: center;\n}\n\n.lt-ae__ratings {\n  display: flex;\n  flex-direction: column;\n}\n\n.lt-ae__group {\n  margin-bottom: 16px;\n}\n\n.lt-ae__label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.lt-ae__row {\n  display: flex;\n  gap: 6px;\n}\n\n.lt-ae__btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 4px;\n  border-radius: 12px;\n  border: 2px solid;\n  background: rgba(255, 255, 255, 0.05);\n  color: #fff;\n  cursor: pointer;\n  min-height: 48px;\n}\n\n.lt-ae__btn--active {\n  color: #fff;\n}\n\n.lt-ae__emoji {\n  font-size: 1.25rem;\n}\n\n.lt-ae__num {\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.lt-ae--celebrate .lt-sheet__submit {\n  background: #22c55e;\n}\n\n.lt-ae-backdrop.lt-ae-backdrop--landscape {\n  align-items: center;\n  padding-top: max(6px, env(safe-area-inset-top));\n  padding-bottom: max(6px, env(safe-area-inset-bottom));\n  padding-left: max(8px, env(safe-area-inset-left));\n  padding-right: max(8px, env(safe-area-inset-right));\n}\n\n.lt-sheet.lt-ae.lt-ae--landscape {\n  width: min(780px, calc(100vw - 16px));\n  max-width: min(780px, calc(100vw - 16px));\n  max-height: calc(\n    100dvh - 12px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  );\n  border-radius: 16px;\n  padding: 10px 12px max(10px, env(safe-area-inset-bottom, 0px));\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(148px, 200px);\n  grid-template-rows: minmax(0, 1fr);\n  gap: 12px 16px;\n  align-items: stretch;\n}\n\n.lt-ae--landscape .lt-ae__body {\n  grid-column: 1;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.lt-ae--landscape .lt-sheet__title {\n  font-size: 1rem;\n  margin-bottom: 2px;\n}\n\n.lt-ae--landscape .lt-ae__player {\n  margin-bottom: 6px;\n  padding: 4px 8px;\n  font-size: 0.88rem;\n}\n\n.lt-ae--landscape .lt-sheet__subtitle {\n  margin-bottom: 8px;\n  font-size: 0.78rem;\n}\n\n.lt-ae--landscape .lt-ae__ratings {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1 1 auto;\n}\n\n.lt-ae--landscape .lt-ae__group {\n  margin-bottom: 0;\n}\n\n.lt-ae--landscape .lt-ae__label {\n  margin-bottom: 4px;\n  font-size: 0.78rem;\n}\n\n.lt-ae--landscape .lt-ae__btn {\n  min-height: 40px;\n  padding: 5px 2px;\n  border-radius: 10px;\n  gap: 1px;\n}\n\n.lt-ae--landscape .lt-ae__emoji {\n  font-size: 1.05rem;\n}\n\n.lt-ae--landscape .lt-ae__num {\n  font-size: 0.65rem;\n}\n\n.lt-ae--landscape .lt-ae__footer {\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 0 0 4px;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  padding-left: 14px;\n  background: transparent;\n  min-height: 0;\n}\n\n.lt-ae--landscape .lt-sheet__submit,\n.lt-ae--landscape .lt-sheet__skip {\n  width: 100%;\n  margin-top: 0;\n  padding: 14px 10px;\n  font-size: 0.92rem;\n}\n\n.lt-ae--landscape .lt-sheet__skip {\n  margin-top: 0;\n}\n\n@media (max-height: 560px) {\n  .lt-sheet.lt-ae {\n    max-height: min(96dvh, 100dvh);\n    padding-top: 12px;\n  }\n\n  .lt-sheet__title {\n    font-size: 1rem;\n  }\n\n  .lt-sheet__subtitle {\n    margin-bottom: 10px;\n    font-size: 0.78rem;\n  }\n\n  .lt-ae__player {\n    margin-bottom: 6px;\n    padding: 4px 8px;\n    font-size: 0.85rem;\n  }\n\n  .lt-ae__group {\n    margin-bottom: 10px;\n  }\n\n  .lt-ae__btn {\n    min-height: 40px;\n    padding: 4px 2px;\n  }\n\n  .lt-ae__emoji {\n    font-size: 1.05rem;\n  }\n\n  .lt-sheet__submit,\n  .lt-sheet__skip {\n    padding: 10px;\n    font-size: 0.92rem;\n  }\n}\n\n/* Short landscape phones: stack ratings left, actions right */\n@media (orientation: landscape) and (max-height: 480px) {\n  .lt-sheet.lt-ae.lt-ae--landscape {\n    max-height: calc(\n      100dvh - 8px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n    );\n    padding: 8px 10px;\n    gap: 8px 12px;\n    grid-template-columns: minmax(0, 1fr) minmax(120px, 160px);\n  }\n\n  .lt-ae--landscape .lt-ae__ratings {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .lt-ae--landscape .lt-ae__group {\n    margin-bottom: 0;\n  }\n\n  .lt-ae--landscape .lt-ae__btn {\n    min-height: 32px;\n    padding: 2px;\n  }\n\n  .lt-ae--landscape .lt-ae__emoji {\n    font-size: 0.95rem;\n  }\n\n  .lt-ae--landscape .lt-sheet__submit,\n  .lt-ae--landscape .lt-sheet__skip {\n    padding: 10px 8px;\n    font-size: 0.88rem;\n  }\n\n  .lt-ae--landscape .lt-ae__footer {\n    padding-left: 10px;\n    gap: 6px;\n  }\n}\n\n/* ── Unread badge (shared by player FAB and coach chat button) ────────── */\n.lt-fab__badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 4px;\n  border-radius: 9px;\n  background: #ef4444;\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  line-height: 18px;\n  text-align: center;\n  pointer-events: none;\n  box-shadow: 0 0 0 2px #0f172a;\n}\n\n/* Player FAB needs position:relative to anchor the badge */\n.lt-page__fab {\n  position: relative;\n}\n\n.lt-page__actions .lt-page__fab {\n  position: relative;\n}\n\n/* ── Coach chat button ────────────────────────────────────────────────── */\n.lt-coach-bar__chat-btn {\n  flex: 0 0 auto;\n  width: auto;\n  min-width: 48px;\n  padding: 10px 14px;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.lt-coach-bar__chat-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.lt-coach-bar__chat-icon-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* KoT leaderboard overlay */\n.lt-kot-lb__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 4900;\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(4px);\n}\n\n.lt-kot-lb {\n  position: fixed;\n  bottom: 24px;\n  left: 16px;\n  right: 16px;\n  max-width: 420px;\n  max-height: min(70vh, 520px);\n  margin: 0 auto;\n  z-index: 4910;\n  padding: 16px;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.98);\n  border: 1px solid rgba(251, 191, 36, 0.4);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n  color: #f8fafc;\n  display: flex;\n  flex-direction: column;\n}\n\n.lt-kot-lb__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.lt-kot-lb__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 1rem;\n  color: #fbbf24;\n}\n\n.lt-kot-lb__close {\n  border: none;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-kot-lb__mode {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.lt-kot-lb__mode-btn {\n  flex: 1;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #cbd5e1;\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.lt-kot-lb__mode-btn--active {\n  background: rgba(251, 191, 36, 0.18);\n  border-color: rgba(251, 191, 36, 0.75);\n  color: #fde68a;\n}\n\n.lt-kot-lb__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.lt-kot-lb__row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.9rem;\n  color: #f8fafc;\n}\n\n.lt-kot-lb__row--me {\n  color: #fcd34d;\n  font-weight: 700;\n}\n\n.lt-kot-lb__rank {\n  width: 28px;\n  font-weight: 800;\n  color: #fbbf24;\n  flex-shrink: 0;\n}\n\n.lt-kot-lb__name {\n  flex: 1;\n  min-width: 0;\n  color: #f8fafc;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-kot-lb__wins {\n  font-variant-numeric: tabular-nums;\n  color: rgba(134, 239, 172, 0.95);\n  font-weight: 700;\n  font-size: 0.82rem;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.lt-kot-lb__pts {\n  font-variant-numeric: tabular-nums;\n  color: rgba(248, 250, 252, 0.88);\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.lt-kot-lb__stat--primary {\n  color: #fbbf24;\n}\n\n.lt-kot-lb__dismiss {\n  width: 100%;\n  margin-top: 12px;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n}\n\n/* KoT live training panel */\n.lt-page__main--kot-player > .lt-kot--scorekeeper {\n  flex: 1;\n  min-height: 0;\n  max-width: none;\n  margin-top: 0;\n  height: 100%;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border: none;\n  border-radius: 0;\n  box-sizing: border-box;\n  padding: 14px 72px max(24px, env(safe-area-inset-bottom, 0px)) 14px;\n  background: linear-gradient(180deg, #0b1220 0%, #111827 38%, #0f172a 100%);\n}\n\n.lt-kot__scorekeeper-hint,\n.lt-kot__scorekeeper-progress,\n.lt-kot__scorekeeper-wait {\n  margin: 0 0 10px;\n  font-size: 0.85rem;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.lt-kot__scorekeeper-progress {\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n}\n\n.lt-kot {\n  width: 100%;\n  max-width: 480px;\n  margin-top: 16px;\n  padding: 14px;\n  border-radius: 16px;\n  background: rgba(251, 191, 36, 0.08);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.lt-kot__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.lt-kot__header-icon {\n  color: #fbbf24 !important;\n  font-size: 28px !important;\n}\n\n.lt-kot__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.lt-kot__round {\n  font-size: 0.75rem;\n  color: rgba(248, 250, 252, 0.7);\n}\n\n.lt-kot__stop-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  border-radius: 10px;\n  background: rgba(251, 146, 60, 0.2);\n  border: 1px solid rgba(251, 146, 60, 0.45);\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.lt-kot__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.lt-kot__stop-btn,\n.lt-kot__start-btn,\n.lt-kot__submit-btn {\n  flex: 1;\n  min-width: 120px;\n}\n\n.lt-kot__stop-btn--player,\n.lt-kot__submit-btn {\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: none;\n  font-weight: 700;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.lt-kot__stop-btn--player {\n  background: rgba(239, 68, 68, 0.25);\n  border: 1px solid rgba(239, 68, 68, 0.55);\n  color: #fecaca;\n}\n\n.lt-kot__submit-btn {\n  background: linear-gradient(135deg, #fbbf24, #d97706);\n  color: #422006;\n}\n\n.lt-kot__error {\n  color: #fca5a5;\n  font-size: 0.8rem;\n  margin: 0 0 10px;\n}\n\n.lt-kot__tables {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.lt-page--landscape .lt-kot__tables {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.lt-kot__table-card {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-kot__table-card--done {\n  border-color: rgba(34, 197, 94, 0.45);\n}\n\n.lt-kot__table-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  font-size: 0.85rem;\n}\n\n.lt-kot__table-state {\n  font-size: 0.7rem;\n  color: rgba(248, 250, 252, 0.6);\n  text-transform: uppercase;\n}\n\n.lt-kot__table-players {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.85rem;\n}\n\n.lt-kot__table-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.lt-kot__table-won {\n  margin-top: 6px;\n  font-size: 0.75rem;\n  color: #86efac;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.lt-kot__table-enter {\n  width: 100%;\n  margin-top: 10px;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.lt-kot__my-match {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.lt-kot__my-match-label {\n  display: block;\n  font-size: 0.7rem;\n  color: rgba(248, 250, 252, 0.6);\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.lt-kot__empty {\n  font-size: 0.85rem;\n  color: rgba(248, 250, 252, 0.55);\n  text-align: center;\n  margin: 0;\n}\n\n.lt-kot__lb-toggle {\n  width: 100%;\n  margin-top: 12px;\n  padding: 10px;\n  border-radius: 10px;\n  border: 1px solid rgba(251, 191, 36, 0.4);\n  background: transparent;\n  color: #fbbf24;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n/* Full-screen KoT player arena */\n.lt-page__main--kot-player {\n  flex: 1;\n  min-height: 0;\n  padding: 0;\n  align-items: stretch;\n  overflow: hidden;\n}\n\n.lt-kot-arena {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  height: 100%;\n  background: linear-gradient(180deg, #0b1220 0%, #111827 38%, #0f172a 100%);\n  color: #f8fafc;\n  overflow: hidden;\n}\n\n.lt-kot-arena__body {\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 6px 10px;\n}\n\n.lt-kot-arena--post-round .lt-kot-arena__body {\n  justify-content: center;\n  align-items: stretch;\n  padding: 10px 12px;\n}\n\n.lt-kot-arena__wait-panel {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  overflow: auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.lt-kot-arena__wait-panel.lt-kot-arena__waiting-classement {\n  align-items: flex-start;\n}\n\n.lt-kot-arena--post-round .lt-kot-arena__wait-panel {\n  max-height: 100%;\n  justify-content: center;\n}\n\n.lt-kot-arena__wait-panel--upcoming {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n}\n\n.lt-kot-arena__match--preview {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.lt-kot-arena--empty {\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-kot-arena__top {\n  padding: 12px 16px 10px;\n  border-bottom: 1px solid rgba(251, 191, 36, 0.22);\n  background: rgba(251, 191, 36, 0.06);\n}\n\n.lt-kot-arena__exercise-title {\n  margin: 0 0 10px;\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.lt-kot-arena__exercise-number {\n  flex-shrink: 0;\n  font-size: 1.15rem;\n  font-weight: 900;\n  color: #fcd34d;\n}\n\n.lt-kot-arena__exercise-name {\n  font-size: clamp(0.95rem, 3.8vw, 1.15rem);\n  font-weight: 700;\n  color: #f8fafc;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-kot-arena__top-main,\n.lt-kot-arena__top-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.lt-kot-arena__top-meta {\n  margin-top: 8px;\n}\n\n.lt-kot-arena__mode-pill,\n.lt-kot-arena__round-pill,\n.lt-kot-arena__table-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.lt-kot-arena__mode-pill {\n  background: rgba(251, 191, 36, 0.18);\n  color: #fcd34d;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.lt-kot-arena__round-pill {\n  background: rgba(8, 119, 188, 0.2);\n  color: #7dd3fc;\n  border: 1px solid rgba(8, 119, 188, 0.35);\n}\n\n.lt-kot-arena__table-pill {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.lt-kot-arena__timer {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 1.35rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #fbbf24;\n}\n\n.lt-kot-arena__set-rule {\n  margin: 8px 0 0;\n  font-size: 0.82rem;\n  color: rgba(248, 250, 252, 0.72);\n  font-weight: 600;\n}\n\n.lt-kot-arena__stop-banner {\n  margin: 6px 10px 0;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: rgba(251, 146, 60, 0.18);\n  border: 1px solid rgba(251, 146, 60, 0.45);\n  font-size: 0.75rem;\n  line-height: 1.3;\n  flex-shrink: 0;\n}\n\n.lt-kot-arena__move-banner {\n  margin: 6px 10px 0;\n  padding: 10px 12px;\n  border-radius: 16px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: rgba(34, 197, 94, 0.14);\n  border: 2px solid rgba(34, 197, 94, 0.45);\n  animation: lt-kot-move-glow 2s ease-in-out infinite;\n}\n\n.lt-kot-arena__move-banner--down {\n  background: rgba(59, 130, 246, 0.14);\n  border-color: rgba(59, 130, 246, 0.45);\n}\n\n.lt-kot-arena__move-banner--up {\n  background: rgba(34, 197, 94, 0.14);\n  border-color: rgba(34, 197, 94, 0.45);\n}\n\n.lt-kot-arena__move-icon {\n  font-size: 2.2rem !important;\n  flex-shrink: 0;\n  color: #86efac;\n}\n\n.lt-kot-arena__move-banner--down .lt-kot-arena__move-icon {\n  color: #93c5fd;\n}\n\n.lt-kot-arena__move-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.88rem;\n  line-height: 1.35;\n}\n\n.lt-kot-arena__waiting-classement {\n  margin: 6px 10px 0;\n  padding: 12px 14px;\n  border-radius: 16px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: rgba(15, 23, 42, 0.92);\n  border: 2px solid rgba(250, 204, 21, 0.45);\n  color: #f8fafc;\n}\n\n.lt-kot-arena__waiting-classement-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-kot-arena__waiting-classement-copy ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lt-kot-arena__waiting-classement-copy li {\n  display: grid;\n  grid-template-columns: 1.5rem 1fr auto auto;\n  gap: 8px;\n  font-size: 0.85rem;\n}\n\n.lt-kot-arena__waiting-classement-wins {\n  font-variant-numeric: tabular-nums;\n  color: #86efac;\n  font-weight: 700;\n  text-align: right;\n}\n\n.lt-kot-arena__waiting-classement-row--me {\n  color: #fde047;\n  font-weight: 600;\n}\n\n.lt-kot-arena__move-copy strong {\n  font-size: 1rem;\n  color: #f8fafc;\n}\n\n.lt-kot-arena__move-wait {\n  font-size: 0.78rem;\n  color: rgba(248, 250, 252, 0.65);\n  margin-top: 2px;\n}\n\n.lt-kot-arena__go-table {\n  font-size: clamp(1.1rem, 4.5vh, 1.45rem);\n  font-weight: 900;\n  color: #fde047;\n  line-height: 1.15;\n}\n\n.lt-kot-arena__waiting-classement-copy .lt-kot-lb__list {\n  width: 100%;\n  margin: 6px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n@keyframes lt-kot-move-glow {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.15);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.08);\n  }\n}\n\n.lt-kot-arena__match {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: stretch;\n  gap: 8px;\n  padding: 8px 10px 6px;\n  overflow: hidden;\n}\n\n/* Portrait: stack player A, VS, player B vertically */\n.lt-kot-arena--portrait .lt-kot-arena__match {\n  grid-template-columns: 1fr;\n  grid-template-rows: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-content: stretch;\n  gap: 6px;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__vs {\n  flex-direction: row;\n  justify-content: center;\n  gap: 12px;\n  min-height: auto;\n  padding: 2px 0;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__player {\n  min-height: 0;\n  width: 100%;\n}\n\n.lt-kot-arena .lt-kot-bar {\n  border-radius: 0;\n  margin: 0;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__top--compact {\n  padding: 4px 10px 5px;\n  flex-shrink: 0;\n}\n\n.lt-kot-arena__top-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-kot-arena__top-brand {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 6px;\n}\n\n.lt-kot-arena__club-logo {\n  flex-shrink: 0;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__club-logo {\n  margin-right: 2px;\n}\n\n.lt-kot-arena__top-line--title {\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.lt-kot-arena__top-line--title .lt-kot-arena__exercise-title {\n  flex: 1;\n}\n\n.lt-kot-arena__top-line--title .lt-kot-arena__exercise-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-kot-arena__top-line--meta {\n  margin-top: 3px;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.lt-kot-arena__top-pills {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__exercise-number {\n  font-size: 0.82rem;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__exercise-name {\n  font-size: clamp(0.72rem, 2.4vh, 0.9rem);\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__mode-pill,\n.lt-kot-arena--landscape .lt-kot-arena__round-pill,\n.lt-kot-arena--landscape .lt-kot-arena__table-pill {\n  padding: 2px 6px;\n  font-size: 0.58rem;\n  letter-spacing: 0.02em;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__timer {\n  font-size: clamp(0.9rem, 3.5vh, 1.1rem);\n  flex-shrink: 0;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__set-rule {\n  margin: 0;\n  font-size: clamp(0.58rem, 1.8vh, 0.68rem);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  text-align: right;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__stop-banner,\n.lt-kot-arena--landscape .lt-kot-arena__move-banner {\n  margin: 4px 10px 0;\n  padding: 6px 10px;\n  font-size: 0.72rem;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__move-icon {\n  font-size: 1.4rem !important;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__move-copy strong {\n  font-size: 0.82rem;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__match {\n  padding: 6px 8px 4px;\n  overflow: hidden;\n  align-items: stretch;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player {\n  min-height: 0;\n  padding: clamp(8px, 1.8vh, 14px) clamp(6px, 1.2vw, 10px);\n  gap: clamp(4px, 1.4vh, 10px);\n  border-radius: 14px;\n  justify-content: center;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__side-badge {\n  width: clamp(30px, 5.5vh, 42px);\n  height: clamp(30px, 5.5vh, 42px);\n  font-size: clamp(0.85rem, 3.8vh, 1.15rem);\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player-name {\n  font-size: clamp(0.95rem, 5.2vh, 1.45rem);\n  line-height: 1.12;\n  max-width: 100%;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__you-pill {\n  font-size: clamp(0.62rem, 2.2vh, 0.78rem);\n  padding: 2px 8px;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player-level {\n  font-size: clamp(0.78rem, 3.8vh, 1.05rem);\n  line-height: 1.2;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player-kot {\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 4px 10px;\n  margin-top: clamp(2px, 0.6vh, 6px);\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__rank {\n  font-size: clamp(0.82rem, 4vh, 1.1rem);\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__session-pts {\n  font-size: clamp(0.72rem, 3.2vh, 0.95rem);\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__live-score {\n  font-size: clamp(1.4rem, 8vh, 2.35rem);\n  margin-top: clamp(2px, 0.8vh, 8px);\n  line-height: 1;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__vs {\n  min-width: 40px;\n  gap: 4px;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__vs-text {\n  width: 34px;\n  height: 34px;\n  font-size: 0.68rem;\n  border-width: 2px;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__vs-target {\n  font-size: clamp(0.9rem, 3.5vh, 1.15rem);\n}\n\n.lt-kot-arena__footer {\n  flex-shrink: 0;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__footer {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  padding: 4px 10px calc(6px + env(safe-area-inset-bottom));\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__leaderboard-btn {\n  margin: 0;\n  flex: 0 0 auto;\n  min-width: 0;\n  padding: 8px 10px;\n  font-size: clamp(0.68rem, 2.2vh, 0.78rem);\n  border-radius: 10px;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__actions {\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__stop-btn {\n  min-height: auto;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__result-btn {\n  min-height: 40px;\n  font-size: clamp(0.78rem, 2.5vh, 0.92rem);\n  border-radius: 12px;\n}\n\n.lt-kot-arena__player {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 8px;\n  border-radius: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.72);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n  text-align: center;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__player {\n  gap: 4px;\n  padding: 8px 6px;\n  border-radius: 14px;\n}\n\n.lt-kot-arena__player--a {\n  border-color: rgba(59, 130, 246, 0.45);\n  background: linear-gradient(165deg, rgba(30, 58, 138, 0.45), rgba(15, 23, 42, 0.85));\n}\n\n.lt-kot-arena__player--b {\n  border-color: rgba(236, 72, 153, 0.45);\n  background: linear-gradient(165deg, rgba(131, 24, 67, 0.35), rgba(15, 23, 42, 0.85));\n}\n\n.lt-kot-arena__player--me {\n  box-shadow:\n    0 0 0 2px rgba(251, 191, 36, 0.55),\n    0 12px 32px rgba(251, 191, 36, 0.18);\n}\n\n.lt-kot-arena__side-badge {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  font-weight: 900;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.lt-kot-arena__player--a .lt-kot-arena__side-badge {\n  color: #93c5fd;\n}\n\n.lt-kot-arena__player--b .lt-kot-arena__side-badge {\n  color: #f9a8d4;\n}\n\n.lt-kot-arena__player-name {\n  margin: 0;\n  font-size: clamp(1rem, 4vw, 1.35rem);\n  font-weight: 800;\n  line-height: 1.15;\n  word-break: break-word;\n}\n\n.lt-kot-arena__you-pill {\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: rgba(251, 191, 36, 0.22);\n  color: #fcd34d;\n  font-size: 0.68rem;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.lt-kot-arena__player-level {\n  margin: 0;\n  font-size: 0.82rem;\n  color: rgba(248, 250, 252, 0.78);\n  font-weight: 600;\n}\n\n.lt-kot-arena__player-kot {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 4px;\n}\n\n.lt-kot-arena__rank {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: #fbbf24;\n}\n\n.lt-kot-arena__session-pts {\n  font-size: 0.78rem;\n  color: rgba(248, 250, 252, 0.65);\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-kot-arena__live-score {\n  margin-top: auto;\n  font-size: 2rem;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  color: #86efac;\n}\n\n.lt-kot-arena__vs {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 56px;\n}\n\n.lt-kot-arena__vs-text {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #111827;\n  border: 3px solid rgba(251, 191, 36, 0.55);\n  color: #fbbf24;\n  font-weight: 900;\n  font-size: 0.85rem;\n}\n\n.lt-kot-arena__vs-target {\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: rgba(248, 250, 252, 0.85);\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-kot-arena__footer:not(:has(.lt-kot-arena__leaderboard-btn)) .lt-kot-arena__actions {\n  width: 100%;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__footer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__leaderboard-btn {\n  margin: 0 16px 0;\n}\n\n.lt-kot-arena__leaderboard-btn {\n  margin: 0 16px 8px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  background: rgba(251, 191, 36, 0.08);\n  color: #fcd34d;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.lt-kot-arena__actions {\n  padding: 8px 16px calc(12px + env(safe-area-inset-bottom));\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lt-kot-arena__stop-btn {\n  width: 100%;\n  min-height: auto;\n  flex: 1;\n}\n\n.lt-kot-arena__stop-btn:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.lt-kot-arena__result-btn {\n  width: 100%;\n  min-height: 56px;\n  border: none;\n  border-radius: 16px;\n  background: linear-gradient(135deg, #fbbf24, #d97706);\n  color: #422006;\n  font-size: 1.05rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.lt-kot-arena__error {\n  margin: 0 16px 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(239, 68, 68, 0.15);\n  color: #fecaca;\n  font-size: 0.82rem;\n}\n\n/* Return FAB (shared) */\n.lt-return-fab {\n  position: fixed;\n  right: 16px;\n  bottom: calc(100px + env(safe-area-inset-bottom));\n  z-index: 900;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 18px;\n  border-radius: 999px;\n  border: none;\n  background: linear-gradient(135deg, var(--brand-primary-light, #0a8cd8), var(--brand-primary, #0877BC));\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.85rem;\n  cursor: pointer;\n  box-shadow: 0 8px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);\n  animation: lt-fab-pulse 2s ease-in-out infinite;\n}\n\n.lt-return-fab__dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #fff;\n  animation: lt-dot-blink 1.2s ease-in-out infinite;\n}\n\n@keyframes lt-fab-pulse {\n  0%,\n  100% {\n    box-shadow: 0 8px 28px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45);\n  }\n  50% {\n    box-shadow: 0 8px 36px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.7);\n  }\n}\n\n@keyframes lt-dot-blink {\n  50% {\n    opacity: 0.3;\n  }\n}\n\n/* ─── Unified player view (lt-pv) — portrait + landscape, all exercise types ── */\n\n/* Root container fills the available space inside lt-page__main */\n.lt-pv {\n  width: 100%;\n  max-width: 100%;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  color: var(--lt-fg, #f8fafc);\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* Player chrome: coach header brand (logo + session title) top-left, controls right */\n.lt-pv__chrome {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n  max-width: 100%;\n  padding: 2px 0 8px;\n  margin-bottom: 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.lt-pv__chrome .lt-header__brand {\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.lt-pv__chrome .lt-header__sub {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__chrome-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-pv__screen-awake-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  background: rgba(0, 242, 254, 0.12);\n  border: 1px solid rgba(0, 242, 254, 0.4);\n  color: #00f2fe;\n  font-size: 0.68rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: 0 0 10px rgba(0, 242, 254, 0.25);\n  animation: ltAwakeBreathe 3s infinite ease-in-out;\n  flex-shrink: 0;\n  max-width: 100%;\n}\n\n@keyframes ltAwakeBreathe {\n  0%, 100% {\n    border-color: rgba(0, 242, 254, 0.35);\n    box-shadow: 0 0 8px rgba(0, 242, 254, 0.2);\n  }\n  50% {\n    border-color: rgba(0, 242, 254, 0.65);\n    box-shadow: 0 0 16px rgba(0, 242, 254, 0.4);\n  }\n}\n\n/* Narrow phones: icon-only chip so chrome never needs horizontal scroll */\n@media (max-width: 420px) {\n  .lt-pv__chip-label {\n    display: none;\n  }\n\n  .lt-pv__screen-awake-chip {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border-radius: 50%;\n    gap: 0;\n  }\n\n  .lt-pv__chrome,\n  .lt-pv__chrome-right {\n    gap: 6px;\n  }\n}\n\n/* Short visual viewport (landscape phones): tighter chrome, same layout. */\n@container lt-page (max-height: 520px) {\n  .lt-pv__chrome {\n    padding: 0 0 4px;\n    margin-bottom: 0;\n  }\n\n  .lt-pv__chip-label {\n    display: none;\n  }\n\n  .lt-pv__screen-awake-chip,\n  .lt-pv__chrome .lt-header__icon-btn,\n  .lt-pv__chrome .lt-header__home-btn {\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border-radius: 50%;\n    gap: 0;\n  }\n}\n\n.lt-page__fab--duck {\n  color: #94a3b8;\n}\n\n.lt-page__fab--duck:hover,\n.lt-page__fab--duck.lt-page__fab--duck-active {\n  background: rgba(0, 242, 254, 0.25);\n  border-color: #00f2fe;\n  color: #00f2fe;\n  box-shadow: 0 0 16px rgba(0, 242, 254, 0.5);\n}\n\n.lt-pv__kot-hr-row {\n  display: flex;\n  justify-content: flex-end;\n  padding: 4px 0 8px;\n}\n\n.lt-pv__ls-wait-header--exercise {\n  justify-content: flex-start;\n}\n\n/* Make the main area stretch & remove excess padding when the player view is inside */\n.lt-page__main:has(.lt-pv) {\n  padding: 8px 10px 12px;\n  align-items: stretch;\n  overflow-x: hidden;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n/* HR chip — compact inline BPM badge */\n.lt-pv__hr-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  line-height: 1;\n}\n\n.lt-pv__hr-icon {\n  display: block;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  font-size: 16px !important;\n  color: #ef4444;\n}\n\n/* Zone-intensity pill while sequence / round is running */\n.lt-pv__hr-chip--zone {\n  background: var(--lt-zone, rgba(0, 0, 0, 0.3));\n  color: var(--lt-zone-fg, #f8fafc);\n  border-color: transparent;\n  transition: background 0.6s ease, color 0.6s ease;\n}\n\n.lt-pv__hr-chip--zone .lt-pv__hr-icon {\n  color: #ef4444;\n}\n\n.lt-pv__hr-row .lt-pv__hr-icon {\n  color: #ef4444;\n}\n\n/* ─── WAITING STATE ─────────────────────────────────────────────────────────── */\n\n.lt-pv--waiting {\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-pv__wait-card {\n  width: 100%;\n  max-width: 600px;\n  padding: 20px 22px;\n  border-radius: 18px;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-pv__wait-top-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lt-pv__player-name {\n  margin: 0;\n  font-size: clamp(1.5rem, 6vw, 2rem);\n  font-weight: 800;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__wait-top-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.lt-pv__table-line {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgba(248, 250, 252, 0.7);\n}\n\n/* Portrait table summary panel */\n.lt-pv__table-panel {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.lt-pv__table-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.lt-pv__table-hero-block {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n.lt-pv__table-hero-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.5);\n}\n\n.lt-pv__table-hero-number {\n  font-size: clamp(1.15rem, 4.5vw, 1.45rem);\n  font-weight: 800;\n  line-height: 1.1;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.lt-pv__table-hero-chips {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  max-width: 100%;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.lt-pv__role--hero {\n  font-size: 0.68rem;\n  padding: 4px 10px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__side-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 0.85rem;\n  font-weight: 800;\n  color: #f8fafc;\n}\n\n.lt-pv__classement-badge {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: rgba(8, 119, 188, 0.15);\n  border: 1px solid rgba(8, 119, 188, 0.35);\n}\n\n.lt-pv__classement-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(248, 250, 252, 0.6);\n}\n\n.lt-pv__classement-value {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #7dd3fc;\n}\n\n.lt-pv__table-roster-title {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.45);\n  margin-bottom: 6px;\n}\n\n.lt-pv__table-roster-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-pv__table-roster-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.lt-pv__table-roster-item--viewer {\n  background: rgba(8, 119, 188, 0.12);\n  border-color: rgba(8, 119, 188, 0.3);\n}\n\n.lt-pv__table-roster-name {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #f8fafc;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__table-roster-side {\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.lt-pv__table-roster-meta {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.55);\n  text-align: right;\n}\n\n.lt-pv__portrait-top {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.lt-pv__id-bar--portrait {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.lt-pv__personalized-cue {\n  display: block;\n  margin: 4px 0 0;\n  font-size: 0.82rem;\n  font-weight: 500;\n  line-height: 1.35;\n  opacity: 0.88;\n  white-space: normal;\n}\n\n.lt-add-ex-dialog__slot-lead {\n  margin: 0 0 12px;\n  line-height: 1.4;\n}\n\n.lt-add-ex-dialog__slot-list {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lt-add-ex-dialog__duration {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.lt-add-ex-dialog__duration input {\n  max-width: 120px;\n  font: inherit;\n  padding: 6px 8px;\n}\n\n.lt-pv__wait-exercise {\n  margin: 4px 0 0;\n  font-size: clamp(1rem, 4vw, 1.25rem);\n  font-weight: 700;\n}\n\n.lt-pv__schema {\n  font-size: 0.72em;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #7dd3fc;\n}\n\n.lt-pv__schema-prep {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #93c5fd;\n}\n\n.lt-pv__wait-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-pv__wait-type {\n  font-size: 0.9rem;\n  color: rgba(248, 250, 252, 0.8);\n}\n\n.lt-pv__wait-subtype {\n  font-size: 0.8rem;\n  color: rgba(248, 250, 252, 0.6);\n}\n\n.lt-pv__wait-message {\n  margin: 8px 0 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--lt-brand, #0877bc);\n}\n\n/* ─── IDENTITY BAR (shared: active & KoT header) ─────────────────────────── */\n\n.lt-pv__id-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  margin-bottom: 4px;\n}\n\n.lt-pv__id-logo,\n.lt-pv__header-logo {\n  flex-shrink: 0;\n}\n\n.lt-pv__wait-brand {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.lt-pv__id-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-pv__id-name {\n  font-size: clamp(1rem, 4vw, 1.2rem);\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__id-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n/* Role chip */\n.lt-pv__role {\n  flex-shrink: 0;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.lt-pv__role--active {\n  background: rgba(34, 179, 92, 0.25);\n  color: #4ade80;\n  border: 1px solid rgba(34, 179, 92, 0.5);\n}\n.lt-pv__role--sparring {\n  background: rgba(243, 140, 41, 0.22);\n  color: #fb923c;\n  border: 1px solid rgba(243, 140, 41, 0.5);\n}\n\n/* KoT compact header */\n.lt-pv--kot-header {\n  padding: 0;\n}\n\n/* ─── TIMER BLOCKS (shared between portrait and landscape) ──────────────────── */\n\n.lt-pv__timer-block {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.lt-pv__timer-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.lt-pv__timer-value {\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  line-height: 1.05;\n}\n\n.lt-pv__paused-tag {\n  align-self: flex-start;\n  padding: 3px 12px;\n  border-radius: 999px;\n  background: rgba(251, 191, 36, 0.18);\n  color: #fbbf24;\n  font-size: 0.72rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-top: 4px;\n}\n\n/* ─── PORTRAIT ACTIVE & GAMIFIED HANDHELD HUD ─────────────────────────────\n   Modern gamification sports design optimized for portrait mode when device is\n   in-hands or close to player (cockpit layout, stadium telemetry, kinetic timers).\n   ────────────────────────────────────────────────────────────────────────── */\n\n.lt-pv--portrait {\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 0 16px;\n  width: 100%;\n  max-width: min(540px, 100%);\n  margin: 0 auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.lt-pv__wait-cockpit {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: min(540px, 100%);\n  margin: 0 auto;\n  min-width: 0;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n.lt-pv__standby-radar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 18px;\n  border-radius: 14px;\n  background: rgba(251, 191, 36, 0.08);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n  gap: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\n.lt-pv__radar-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: #fbbf24;\n  box-shadow: 0 0 12px #fbbf24;\n  animation: ltRadarDot 1.4s infinite alternate;\n}\n\n@keyframes ltRadarDot {\n  0% {\n    transform: scale(0.85);\n    opacity: 0.6;\n  }\n  100% {\n    transform: scale(1.3);\n    opacity: 1;\n    box-shadow: 0 0 16px #fbbf24;\n  }\n}\n\n.lt-pv__radar-text {\n  font-size: 0.78rem;\n  font-weight: 850;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fbbf24;\n}\n\n/* Gamified Stadium Table Panel */\n.lt-pv__table-panel--gamified {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 14px 16px;\n  border-radius: 18px;\n  background: linear-gradient(145deg, rgba(15, 23, 42, 0.92) 0%, rgba(8, 12, 22, 0.96) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.lt-pv__table-stadium-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.lt-pv__stadium-badge {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 10px;\n  background: rgba(0, 242, 254, 0.12);\n  border: 1px solid rgba(0, 242, 254, 0.4);\n  box-shadow: 0 0 14px rgba(0, 242, 254, 0.2);\n}\n\n.lt-pv__stadium-label {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.lt-pv__stadium-num {\n  font-size: 1.25rem;\n  font-weight: 900;\n  color: #00f2fe;\n  letter-spacing: -0.02em;\n}\n\n.lt-pv__stadium-status {\n  display: flex;\n  align-items: center;\n}\n\n.lt-pv__stadium-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.lt-pv__stadium-pill--live {\n  background: rgba(0, 245, 155, 0.14);\n  border: 1px solid rgba(0, 245, 155, 0.4);\n  color: #00f59b;\n}\n\n.lt-pv__stadium-pill--standby {\n  background: rgba(251, 191, 36, 0.14);\n  border: 1px solid rgba(251, 191, 36, 0.4);\n  color: #fbbf24;\n}\n\n.lt-pv__stadium-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.lt-pv__stadium-dot--pulse {\n  animation: ltDotPulse 1.2s infinite ease-in-out;\n}\n\n@keyframes ltDotPulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.35;\n    transform: scale(0.75);\n  }\n}\n\n/* Matchup Arena */\n.lt-pv__matchup-arena {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.lt-pv__matchup-card {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.035);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.lt-pv__matchup-card--you {\n  background: linear-gradient(135deg, rgba(0, 242, 254, 0.08) 0%, rgba(255, 255, 255, 0.03) 100%);\n  border-color: rgba(0, 242, 254, 0.28);\n  box-shadow: 0 0 16px rgba(0, 242, 254, 0.06);\n}\n\n.lt-pv__matchup-card-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-pv__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 900;\n  flex-shrink: 0;\n}\n\n.lt-pv__avatar--you {\n  background: linear-gradient(135deg, #00f2fe 0%, #0877bc 100%);\n  color: #080c14;\n  box-shadow: 0 0 10px rgba(0, 242, 254, 0.4);\n}\n\n.lt-pv__avatar--partner {\n  background: linear-gradient(135deg, #64748b 0%, #334155 100%);\n  color: #f8fafc;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.lt-pv__matchup-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-pv__player-title {\n  font-size: 0.82rem;\n  font-weight: 800;\n  color: #f8fafc;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-pv__player-sub {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.lt-pv__side-tag {\n  font-size: 0.65rem;\n  font-weight: 800;\n  padding: 1px 5px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #cbd5e1;\n}\n\n.lt-pv__stat-tag {\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-pv__stat-tag--pts {\n  color: #00f2fe;\n  font-weight: 800;\n}\n\n.lt-pv__role-crest {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  align-self: flex-start;\n}\n\n.lt-pv__role-crest-icon {\n  font-size: 0.9rem !important;\n}\n\n/* Same palette as the landscape .lt-pv__role--active / --sparring chips */\n.lt-pv__role-crest--performance,\n.lt-pv__role-crest--attacker {\n  background: rgba(34, 179, 92, 0.25);\n  border: 1px solid rgba(34, 179, 92, 0.5);\n  color: #4ade80;\n}\n\n.lt-pv__role-crest--sparring {\n  background: rgba(243, 140, 41, 0.22);\n  border: 1px solid rgba(243, 140, 41, 0.5);\n  color: #fb923c;\n}\n\n.lt-pv__matchup-vs-bridge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lt-pv__matchup-vs-badge {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #94a3b8;\n  font-size: 0.65rem;\n  font-weight: 900;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 0.04em;\n}\n\n.lt-pv__roster-strip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 6px 0 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.lt-pv__roster-strip-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n}\n\n.lt-pv__roster-strip-chips {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.lt-pv__roster-pill {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #cbd5e1;\n}\n\n/* Tactical Mission Card */\n.lt-pv__mission-card {\n  padding: 12px 14px;\n  border-radius: 14px;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-pv__mission-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.lt-pv__mission-tennis-icon {\n  font-size: 0.95rem !important;\n  color: #00f2fe;\n}\n\n.lt-pv__mission-lead {\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.lt-pv__schema-pill {\n  font-size: 0.68rem;\n  font-weight: 800;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: rgba(0, 242, 254, 0.12);\n  border: 1px solid rgba(0, 242, 254, 0.35);\n  color: #00f2fe;\n  margin-left: auto;\n}\n\n.lt-pv__mission-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: #ffffff;\n  letter-spacing: -0.01em;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.lt-pv__coach-cue-box {\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: rgba(251, 191, 36, 0.08);\n  border-left: 3px solid #fbbf24;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-pv__coach-cue-label {\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fbbf24;\n}\n\n.lt-pv__coach-cue-text {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.9);\n  line-height: 1.35;\n}\n\n.lt-pv__prep-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #38bdf8;\n  text-decoration: none;\n  align-self: flex-start;\n  margin-top: 2px;\n  transition: opacity 0.2s ease;\n}\n\n.lt-pv__prep-link:hover {\n  opacity: 0.8;\n}\n\n.lt-pv__prep-arrow-icon {\n  font-size: 0.75rem !important;\n}\n\n/* ─── KINETIC SEQUENCE PROGRESSION & TIMERS ───────────────────────────────── */\n\n.lt-pv__seq-progress-wrap {\n  width: 100%;\n}\n\n.lt-pv__seq-meter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 2px 4px;\n}\n\n.lt-pv__seq-pips {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  width: 100%;\n}\n\n.lt-pv__seq-pip {\n  flex: 1;\n  height: 6px;\n  border-radius: 3px;\n  background: rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.lt-pv__seq-pip--done {\n  background: #00f59b;\n  box-shadow: 0 0 8px rgba(0, 245, 155, 0.4);\n}\n\n.lt-pv__seq-pip--active {\n  background: #00f2fe;\n  box-shadow: 0 0 12px rgba(0, 242, 254, 0.7);\n  animation: ltPipGlow 1.8s infinite ease-in-out;\n}\n\n@keyframes ltPipGlow {\n  0%, 100% {\n    box-shadow: 0 0 8px rgba(0, 242, 254, 0.5);\n    opacity: 0.85;\n  }\n  50% {\n    box-shadow: 0 0 16px rgba(0, 242, 254, 1);\n    opacity: 1;\n  }\n}\n\n.lt-pv__seq-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.lt-pv__seq-counter-tag {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.lt-pv__timer-card {\n  width: 100%;\n  padding: 18px 20px;\n  border-radius: 18px;\n  background: linear-gradient(180deg, rgba(15, 23, 42, 0.92) 0%, rgba(8, 12, 22, 0.96) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n}\n\n.lt-pv__timer-card-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  justify-content: center;\n}\n\n.lt-pv__timer-head-icon {\n  font-size: 1rem !important;\n  color: #00f2fe;\n}\n\n.lt-pv__timer-card-title {\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.lt-pv__timer-value--seq {\n  font-size: clamp(3.8rem, 19vw, 5.5rem);\n  font-weight: 900;\n  line-height: 1;\n  letter-spacing: -0.04em;\n  font-variant-numeric: tabular-nums;\n  color: #ffffff;\n  text-shadow: 0 0 24px rgba(0, 242, 254, 0.35);\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.lt-pv__timer-paused-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(251, 191, 36, 0.18);\n  color: #fbbf24;\n  font-size: 0.68rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-left: 8px;\n}\n\n.lt-pv__timer-card--rest {\n  background: linear-gradient(180deg, rgba(251, 191, 36, 0.15) 0%, rgba(15, 23, 42, 0.96) 100%);\n  border-color: rgba(251, 191, 36, 0.5);\n  box-shadow: 0 0 28px rgba(251, 191, 36, 0.25);\n  animation: ltRestPulse 2s infinite ease-in-out;\n}\n\n@keyframes ltRestPulse {\n  0%, 100% {\n    border-color: rgba(251, 191, 36, 0.4);\n    box-shadow: 0 0 16px rgba(251, 191, 36, 0.2);\n  }\n  50% {\n    border-color: rgba(251, 191, 36, 0.8);\n    box-shadow: 0 0 32px rgba(251, 191, 36, 0.45);\n  }\n}\n\n.lt-pv__timer-rest-icon {\n  font-size: 1.1rem !important;\n  color: #fbbf24;\n}\n\n.lt-pv__timer-value--rest {\n  color: #fbbf24;\n  text-shadow: 0 0 24px rgba(251, 191, 36, 0.5);\n  font-size: clamp(3.8rem, 19vw, 5.5rem);\n  font-weight: 900;\n  line-height: 1;\n  letter-spacing: -0.04em;\n  font-variant-numeric: tabular-nums;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.lt-pv__timer-rest-sub {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #fde68a;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.lt-pv__drill-odometer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.32);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  width: 100%;\n}\n\n.lt-pv__odometer-label {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.lt-pv__odometer-value {\n  font-size: 1.3rem;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  color: #38bdf8;\n  letter-spacing: -0.02em;\n}\n\n/* ─── GAMIFIED HR BIOMETRICS POWER CARD ──────────────────────────────────── */\n\n.lt-pv__hr-power-card {\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(8, 12, 22, 0.96) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.lt-pv__hr-power-card--neutral {\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n.lt-pv__hr-top-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.lt-pv__hr-metric {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.lt-pv__hr-heart-icon {\n  font-size: 1.3rem !important;\n  color: #f43f5e;\n  align-self: center;\n}\n\n.lt-pv__hr-heart-icon--beating {\n  animation: ltHeartBeat 1.1s infinite cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n@keyframes ltHeartBeat {\n  0%, 100% {\n    transform: scale(1);\n  }\n  15% {\n    transform: scale(1.25);\n  }\n  30% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(1.15);\n  }\n  60% {\n    transform: scale(1);\n  }\n}\n\n.lt-pv__hr-live-number {\n  font-size: 1.8rem;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.lt-pv__hr-live-unit {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #94a3b8;\n}\n\n.lt-pv__hr-right-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lt-pv__hr-peak-pill {\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  color: #cbd5e1;\n}\n\n.lt-pv__hr-zones-bar {\n  display: flex;\n  gap: 4px;\n  width: 100%;\n  height: 8px;\n  margin-top: 2px;\n}\n\n.lt-pv__hr-zone-segment {\n  flex: 1;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.lt-pv__hr-zone-segment--past {\n  background: var(--segment-color);\n  opacity: 0.4;\n}\n\n.lt-pv__hr-zone-segment--active {\n  background: var(--segment-color);\n  opacity: 1;\n  box-shadow: 0 0 10px var(--segment-color);\n  transform: scaleY(1.3);\n}\n\n.lt-pv__hr-zone-pip {\n  display: none;\n}\n\n.lt-pv__hr-zone-legend {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.lt-pv__hr-zone-tag {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--lt-zone, #38bdf8);\n}\n\n/* Fallback for legacy timer blocks / landscape components */\n.lt-pv__timer-block--portrait {\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: 14px;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.lt-pv__timer-value--portrait-seq {\n  font-size: clamp(3.5rem, 18vw, 5rem);\n  color: #fff;\n}\n\n.lt-pv__timer-value--portrait-ex {\n  font-size: clamp(2.25rem, 11vw, 3rem);\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-pv__hr-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-radius: 14px;\n  background: var(--lt-zone, rgba(255, 255, 255, 0.06));\n  color: var(--lt-zone-fg, #f8fafc);\n  font-variant-numeric: tabular-nums;\n  transition: background 0.6s ease;\n}\n\n.lt-pv__hr-row-value {\n  font-size: 1.25rem;\n  font-weight: 800;\n  flex: 1;\n}\n\n.lt-pv__hr-row-max {\n  font-size: 0.85rem;\n  font-weight: 600;\n  opacity: 0.8;\n}\n\n.lt-pv__hr-row--neutral {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #f8fafc;\n}\n\n/* ─── LANDSCAPE ACTIVE ─────────────────────────────────────────────────────── */\n\n.lt-pv--active-landscape {\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  align-self: stretch;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  padding: 0;\n}\n\n.lt-page__main:has(.lt-pv--active-landscape) {\n  padding: 0;\n}\n\n.lt-pv--active-landscape .lt-pv__table-center--active {\n  justify-content: space-evenly;\n  gap: clamp(4px, 1.2vh, 10px);\n  width: clamp(118px, 24vw, 220px);\n  overflow: hidden;\n  align-self: stretch;\n  min-height: 0;\n  padding: 4px 6px max(6px, env(safe-area-inset-bottom, 0px));\n}\n\n.lt-pv__table-center-pin {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 0 1 auto;\n  min-height: 0;\n  width: 100%;\n  padding-bottom: 2px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-pv__table-center-brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(4px, 1.2vh, 10px);\n  width: 100%;\n  min-height: 0;\n}\n\n.lt-pv__table-center-table {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.lt-pv__table-center-logo .lt-club-logo {\n  width: clamp(36px, 8vh, 64px);\n  height: clamp(36px, 8vh, 64px);\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  object-fit: contain;\n}\n\n.lt-pv--waiting-landscape .lt-pv__chrome,\n.lt-pv--active-landscape .lt-pv__chrome {\n  min-height: 0;\n  padding: 0 8px 4px;\n  margin-bottom: 0;\n  z-index: 2;\n}\n\n.lt-pv__table-center--active .lt-pv__table-center-number {\n  font-size: clamp(1.35rem, 6.5vh, 2.35rem);\n  line-height: 1;\n}\n\n.lt-pv__ls-timer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-shrink: 0;\n  width: 100%;\n  padding-bottom: 2px;\n}\n\n.lt-pv__timer-value--ls-seq {\n  font-size: clamp(1.25rem, 5.8vh, 2.1rem);\n  line-height: 1;\n  color: #fff;\n}\n\n.lt-pv__timer-value--ls-ex {\n  font-size: clamp(1.1rem, 5vh, 1.55rem);\n  line-height: 1;\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-pv__paused-tag--center {\n  align-self: center;\n}\n\n.lt-pv--landscape {\n  flex-direction: row;\n  flex: 1;\n}\n\n/* Active landscape uses a column layout (title bar on top, 3-panel split below) */\n.lt-pv--active-landscape.lt-pv--landscape,\n.lt-pv--active-landscape {\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n}\n\n.lt-pv__split {\n  display: flex;\n  width: 100%;\n  gap: 12px;\n  align-items: stretch;\n  flex: 1;\n}\n\n.lt-pv__panel {\n  flex: 1;\n  min-width: 0;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.lt-pv__panel--timers {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* Landscape timer sizes */\n.lt-pv__timer-value--seq {\n  font-size: clamp(2.75rem, 12vh, 4rem);\n  color: #fff;\n}\n.lt-pv__timer-value--ex {\n  font-size: clamp(1.75rem, 7vh, 2.5rem);\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-pv--active-landscape .lt-pv__timer-value--ls-seq {\n  font-size: clamp(1.2rem, 5.4vh, 2rem);\n}\n\n.lt-pv--active-landscape .lt-pv__timer-value--ls-ex {\n  font-size: clamp(1.05rem, 4.6vh, 1.45rem);\n}\n\n.lt-pv--active-landscape .lt-pv__ls-timer .lt-pv__timer-label {\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  text-align: center;\n  line-height: 1.1;\n}\n\n@media (orientation: landscape) and (max-height: 430px) {\n  .lt-pv__table-center-logo .lt-club-logo {\n    width: clamp(28px, 6.5vh, 44px);\n    height: clamp(28px, 6.5vh, 44px);\n  }\n\n  .lt-pv--active-landscape .lt-pv__table-center--active .lt-pv__table-center-number,\n  .lt-pv--waiting-landscape .lt-pv__table-center-number {\n    font-size: clamp(1.15rem, 5.2vh, 1.7rem);\n  }\n\n  .lt-pv--active-landscape .lt-pv__timer-value--ls-seq {\n    font-size: clamp(1.05rem, 4.8vh, 1.45rem);\n  }\n\n  .lt-pv--active-landscape .lt-pv__timer-value--ls-ex {\n    font-size: clamp(0.95rem, 4.2vh, 1.25rem);\n  }\n}\n\n.lt-pv--paused .lt-pv__timer-value--seq,\n.lt-pv--paused .lt-pv__timer-value--portrait-seq {\n  opacity: 0.6;\n}\n\n.lt-pv__timer-value--transition {\n  color: #fbbf24 !important;\n  opacity: 1 !important;\n}\n\n.lt-pv__timer-block--transition .lt-pv__timer-label,\n.lt-pv__ls-timer--transition .lt-pv__timer-label {\n  color: #fbbf24;\n}\n\n/* HR zone panel (landscape) */\n.lt-pv__panel--hr {\n  background: var(--lt-zone, rgba(255, 255, 255, 0.06));\n  color: var(--lt-zone-fg, #f8fafc);\n  align-items: center;\n  justify-content: center;\n  transition: background 0.6s ease;\n}\n\n.lt-pv__hr-big {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.lt-pv__hr-icon-lg {\n  font-size: 28px !important;\n  color: currentColor;\n  opacity: 0.85;\n  align-self: center;\n}\n\n.lt-pv__hr-big-value {\n  font-size: clamp(3rem, 14vh, 5rem);\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.lt-pv__hr-big-unit {\n  font-size: 1rem;\n  font-weight: 700;\n  opacity: 0.75;\n}\n\n.lt-pv__hr-max {\n  font-size: 0.95rem;\n  font-weight: 700;\n  opacity: 0.8;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ─── LANDSCAPE WAITING — iOS 3-panel table view ─────────────────────────── */\n\n/* Remove default centering and let children fill the space */\n.lt-pv--waiting-landscape,\n.lt-pv--active-landscape {\n  overflow: hidden;\n}\n\n.lt-pv--waiting-landscape {\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: flex-start;\n  align-self: stretch;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  padding: 0;\n}\n\n/* Counteract parent padding so the view fills edge-to-edge */\n.lt-page__main:has(.lt-pv--waiting-landscape) {\n  padding: 0;\n}\n\n/* Exercise title strip at top */\n.lt-pv__ls-wait-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 96px 8px 52px;\n  background: rgba(0, 0, 0, 0.4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n  flex-shrink: 0;\n}\n\n.lt-pv__ls-wait-header .lt-pv__header-logo {\n  position: absolute;\n  left: max(10px, env(safe-area-inset-left));\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.lt-pv__ls-wait-header--exit-only {\n  justify-content: flex-end;\n  padding: 8px 16px;\n}\n\n.lt-pv__ls-wait-header-title {\n  font-size: clamp(0.8rem, 2.4vh, 1rem);\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Exit button positioned absolute inside the header */\n.lt-pv__ls-wait-exit {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* 3-column split filling the remaining vertical space */\n.lt-pv__table-split {\n  display: flex;\n  flex: 1;\n  align-items: stretch;\n  min-height: 0;\n}\n\n/* Player side panels (A and B) — same tint on both sides */\n.lt-pv__table-side {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  padding: clamp(10px, 2.5vh, 16px) clamp(8px, 2vw, 14px);\n  background: rgba(8, 119, 188, 0.07);\n  gap: 10px;\n  overflow: hidden;\n}\n\n.lt-pv__side-body {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.lt-pv__side-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.lt-pv__table-side--a {\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.lt-pv__table-side--b {\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Viewer's own side gets a subtle brand tint */\n.lt-pv__table-side--viewer {\n  background: rgba(8, 119, 188, 0.07);\n}\n\n/* Court-side A / B marker — pinned to the top, never covers the name */\n.lt-pv__side-letter {\n  position: absolute;\n  top: max(6px, env(safe-area-inset-top, 0px));\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 0;\n  font-size: clamp(1.2rem, 4.2vh, 1.85rem);\n  font-weight: 900;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1;\n  pointer-events: none;\n  letter-spacing: 0.04em;\n}\n\n/* Classement + ranking points under player name */\n.lt-pv__side-stats {\n  font-size: clamp(0.7rem, 2.2vh, 0.85rem);\n  font-weight: 700;\n  color: #7dd3fc;\n  text-align: center;\n  line-height: 1.3;\n  max-width: 100%;\n  word-break: break-word;\n}\n\n/* Player name */\n.lt-pv__side-name {\n  margin: 0;\n  width: 100%;\n  font-size: clamp(0.95rem, 3.5vh, 1.35rem);\n  font-weight: 800;\n  text-align: center;\n  line-height: 1.25;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  color: #f8fafc;\n}\n\n/* Role badge on landscape table sides — prominent, never overlaps name */\n.lt-pv__role--side {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: auto;\n  max-width: 100%;\n  padding: 8px 18px;\n  font-size: clamp(0.78rem, 2.6vh, 1rem);\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n}\n\n.lt-pv__table-side .lt-pv__hr-chip {\n  position: relative;\n  z-index: 1;\n  align-self: center;\n  flex-shrink: 0;\n}\n\n.lt-pv__table-side > .lt-pv__side-letter {\n  margin-bottom: 0;\n}\n\n/* Center column: table number + waiting message */\n.lt-pv__table-center {\n  flex: 0 0 auto;\n  width: clamp(110px, 22vw, 200px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  padding: 12px 8px;\n  gap: 4px;\n  border-left: 1px solid rgba(255, 255, 255, 0.07);\n  border-right: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.lt-pv--waiting-landscape .lt-pv__table-center {\n  justify-content: center;\n  gap: clamp(8px, 1.6vh, 12px);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.lt-pv--waiting-landscape .lt-pv__table-center-number {\n  font-size: clamp(1.5rem, 7vh, 2.6rem);\n}\n\n/* Waiting + active landscape: vertically center player info in A/B columns */\n.lt-pv--waiting-landscape .lt-pv__table-side,\n.lt-pv--active-landscape .lt-pv__table-side {\n  justify-content: center;\n  gap: clamp(8px, 2vh, 14px);\n}\n\n/* Landscape A/B marker stays a compact top label so names remain readable */\n.lt-pv--waiting-landscape .lt-pv__side-letter,\n.lt-pv--active-landscape .lt-pv__side-letter {\n  font-size: clamp(1.25rem, 4.6vh, 2rem);\n}\n\n.lt-pv--waiting-landscape .lt-pv__side-name,\n.lt-pv--active-landscape .lt-pv__side-name {\n  font-size: clamp(1.05rem, 5.5vh, 1.65rem);\n  line-height: 1.15;\n}\n\n.lt-pv--waiting-landscape .lt-pv__side-stats,\n.lt-pv--active-landscape .lt-pv__side-stats {\n  font-size: clamp(0.82rem, 4vh, 1.1rem);\n  line-height: 1.25;\n}\n\n.lt-pv--waiting-landscape .lt-pv__role--side,\n.lt-pv--active-landscape .lt-pv__role--side {\n  font-size: clamp(0.85rem, 3.5vh, 1.15rem);\n  padding: clamp(6px, 1.5vh, 10px) clamp(14px, 3vw, 20px);\n}\n\n.lt-pv--waiting-landscape .lt-pv__side-body,\n.lt-pv--active-landscape .lt-pv__side-body {\n  flex: 1 1 auto;\n  justify-content: center;\n  padding-top: clamp(1.6rem, 6.5vh, 2.6rem);\n  padding-bottom: clamp(0.4rem, 1.5vh, 0.8rem);\n}\n\n.lt-pv__table-center-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: rgba(255, 255, 255, 0.55);\n  line-height: 1;\n}\n\n.lt-pv__table-center-number {\n  font-size: clamp(2rem, 10vh, 3.5rem);\n  font-weight: 900;\n  color: #fff;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-pv__wait-message-ls {\n  margin: 6px 0 0;\n  font-size: clamp(0.6rem, 1.6vh, 0.75rem);\n  font-weight: 500;\n  color: rgba(248, 250, 252, 0.6);\n  text-align: center;\n  line-height: 1.35;\n}\n\n/* ─── Legacy lt-lsp aliases (kept so old CSS class references don't crash) ── */\n/* Landscape player replica (iOS parity, TE_SEQUENCES) */\n.lt-lsp {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.lt-page--landscape .lt-page__main:has(.lt-lsp) {\n  padding: 8px 12px 12px;\n  align-items: stretch;\n}\n\n/* Heart-rate chip (shared) */\n.lt-lsp__hr-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.lt-lsp__hr-icon {\n  display: block;\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  font-size: 18px !important;\n  color: #ef4444;\n}\n\n/* Waiting state */\n.lt-lsp--waiting {\n  align-items: center;\n}\n\n.lt-lsp__wait-card {\n  width: 100%;\n  max-width: 560px;\n  margin: auto;\n  padding: 20px 24px;\n  border-radius: 18px;\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-lsp__wait-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lt-lsp__player-name {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 800;\n  text-align: left;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-lsp__table-line {\n  margin: 0;\n  font-size: 0.95rem;\n  color: rgba(248, 250, 252, 0.75);\n  text-align: left;\n}\n\n.lt-lsp__wait-exercise {\n  margin: 8px 0 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.lt-lsp__wait-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-lsp__wait-type {\n  font-size: 0.95rem;\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.lt-lsp__wait-subtype {\n  font-size: 0.85rem;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.lt-lsp__wait-message {\n  margin: 12px 0 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--lt-brand, #0877bc);\n}\n\n/* Active state */\n.lt-lsp__split {\n  display: flex;\n  width: 100%;\n  gap: 12px;\n  align-items: stretch;\n}\n\n.lt-lsp__panel {\n  flex: 1;\n  min-width: 0;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n}\n\n.lt-lsp__panel--timers {\n  background: rgba(0, 0, 0, 0.3);\n  gap: 10px;\n}\n\n.lt-lsp__id-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lt-lsp__id-text {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lt-lsp__id-name {\n  font-size: 1.1rem;\n  font-weight: 700;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lt-lsp__role {\n  flex-shrink: 0;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.lt-lsp__role--active {\n  background: rgba(34, 179, 92, 0.25);\n  color: #4ade80;\n  border: 1px solid rgba(34, 179, 92, 0.5);\n}\n\n.lt-lsp__role--sparring {\n  background: rgba(243, 140, 41, 0.22);\n  color: #fb923c;\n  border: 1px solid rgba(243, 140, 41, 0.5);\n}\n\n.lt-lsp__id-hr {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 1rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-lsp__timer-block {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.lt-lsp__timer-block--seq {\n  margin-top: 4px;\n}\n\n.lt-lsp__timer-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.6);\n}\n\n.lt-lsp__timer-value {\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  line-height: 1.05;\n}\n\n.lt-lsp__timer-value--seq {\n  font-size: clamp(2.75rem, 12vh, 4rem);\n  color: #fff;\n}\n\n.lt-lsp__timer-value--ex {\n  font-size: clamp(1.75rem, 7vh, 2.5rem);\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-lsp--paused .lt-lsp__timer-value--seq {\n  opacity: 0.6;\n}\n\n.lt-lsp__paused-tag {\n  margin-top: auto;\n  align-self: flex-start;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  font-size: 0.75rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* HR zone panel */\n.lt-lsp__panel--hr {\n  background: var(--lt-zone, rgba(255, 255, 255, 0.06));\n  color: var(--lt-zone-fg, #f8fafc);\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background 0.6s ease;\n}\n\n.lt-lsp__hr-big {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.lt-lsp__hr-icon-lg {\n  font-size: 28px !important;\n  color: currentColor;\n  opacity: 0.85;\n  align-self: center;\n}\n\n.lt-lsp__hr-big-value {\n  font-size: clamp(3rem, 14vh, 5rem);\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.lt-lsp__hr-big-unit {\n  font-size: 1rem;\n  font-weight: 700;\n  opacity: 0.75;\n}\n\n.lt-lsp__hr-max {\n  font-size: 0.95rem;\n  font-weight: 700;\n  opacity: 0.8;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Live HR trend panel mode ───────────────────────────────────────────── */\n.lt-panel-mode-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.35);\n  color: #f8fafc;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.lt-panel-mode-toggle:hover:not(:disabled) {\n  background: rgba(8, 119, 188, 0.25);\n  border-color: rgba(125, 211, 252, 0.35);\n}\n\n.lt-panel-mode-toggle:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.lt-pv__side-toggle-row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.lt-pv__side--hr-trend {\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n.lt-pv__hr-trend-block {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0 clamp(8px, 2vw, 14px) clamp(10px, 2vh, 16px);\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(0, 0, 0, 0.28);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.lt-pv__hr-trend-block .lt-hr-trend-panel {\n  flex: none;\n  min-height: 0;\n}\n\n.lt-pv__hr-row--with-toggle {\n  display: grid;\n  grid-template-columns: auto 1fr auto auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.lt-pv__panel-mode-toggle--inline {\n  min-width: 40px;\n  min-height: 40px;\n  margin-left: auto;\n}\n\n.lt-hr-trend-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  min-height: 0;\n  flex: 1;\n}\n\n.lt-hr-trend-panel__top {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  overflow: visible;\n}\n\n.lt-hr-trend-panel__bpm-chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(0.9rem, 2.8vh, 1.1rem);\n  font-weight: 800;\n  color: #f8fafc;\n  font-variant-numeric: tabular-nums;\n}\n\n.lt-hr-trend-panel__bpm-icon {\n  color: #ef4444;\n  font-size: 1rem !important;\n}\n\n.lt-hr-trend-panel__meta {\n  margin: 0;\n  font-size: clamp(0.68rem, 2vh, 0.8rem);\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.55);\n  line-height: 1.3;\n  text-align: center;\n  word-break: break-word;\n}\n\n.lt-hr-trend-panel__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: clamp(0.65rem, 1.8vh, 0.75rem);\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.lt-hr-trend-panel__window {\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-weight: 700;\n}\n\n.lt-hr-trend-panel__trend {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-weight: 800;\n}\n\n.lt-hr-trend-panel__trend--rising {\n  color: #86efac;\n}\n\n.lt-hr-trend-panel__trend--steady {\n  color: #7dd3fc;\n}\n\n.lt-hr-trend-panel__trend--easing {\n  color: #fde047;\n}\n\n.lt-hr-trend-panel__status {\n  font-weight: 700;\n}\n\n.lt-hr-trend-panel__status--stale {\n  color: #94a3b8;\n}\n\n.lt-hr-trend-panel__zone {\n  margin: 0;\n  font-size: clamp(0.65rem, 1.8vh, 0.75rem);\n  font-weight: 700;\n  color: #7dd3fc;\n  text-align: center;\n}\n\n.lt-hr-trend-panel--panel .lt-hr-trend-chart {\n  flex: 0 0 auto;\n  min-height: 120px;\n}\n\n.lt-hr-trend-panel--compact {\n  gap: 4px;\n}\n\n.lt-hr-trend-panel--compact .lt-hr-trend-panel__meta {\n  font-size: 0.68rem;\n  text-align: left;\n}\n\n.lt-hr-trend-panel--compact .lt-hr-trend-panel__top {\n  justify-content: flex-start;\n}\n\n.lt-hr-trend-panel--compact .lt-hr-trend-panel__footer {\n  font-size: 0.62rem;\n}\n\n.lt-hr-trend-chart {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.lt-kot-arena__player-toggle {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.lt-kot-arena__player--hr-trend {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  padding: 4px 6px 6px;\n  gap: 0;\n  justify-content: stretch;\n  overflow: hidden;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player--hr-trend {\n  padding: 4px 6px;\n  justify-content: stretch;\n}\n\n.lt-hr-trend-panel--arena {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.lt-hr-trend-panel__arena-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  flex-shrink: 0;\n  min-height: 0;\n}\n\n.lt-hr-trend-panel__arena-meta {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: clamp(0.58rem, 1.8vh, 0.68rem);\n  font-weight: 600;\n  line-height: 1.2;\n  color: rgba(248, 250, 252, 0.52);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-hr-trend-panel__arena-tools {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.lt-hr-trend-panel__bpm-chip--arena {\n  font-size: clamp(0.72rem, 2.2vh, 0.85rem);\n  padding: 2px 6px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.28);\n}\n\n.lt-pv__panel-mode-toggle--arena {\n  min-width: 36px;\n  min-height: 36px;\n  padding: 6px;\n}\n\n.lt-hr-trend-panel__chart-grow {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: hidden;\n}\n\n.lt-hr-trend-chart--fill {\n  flex: 1;\n  min-height: 0;\n  height: 100% !important;\n  border-radius: 8px;\n}\n\n.lt-hr-trend-chart--arena {\n  background: rgba(0, 0, 0, 0.32);\n}\n\n.lt-hr-trend-panel__arena-foot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  font-size: clamp(0.56rem, 1.6vh, 0.64rem);\n  font-weight: 700;\n  color: rgba(248, 250, 252, 0.5);\n  line-height: 1.2;\n}\n\n.lt-hr-trend-panel__arena-foot .lt-hr-trend-panel__window {\n  font-size: inherit;\n}\n\n.lt-hr-trend-panel__arena-foot .lt-hr-trend-panel__trend {\n  font-size: inherit;\n}\n\n.lt-hr-trend-panel__arena-zone {\n  margin-left: auto;\n  color: #7dd3fc;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.lt-kot-arena--landscape .lt-kot-arena__player--hr-trend .lt-hr-trend-panel__chart-grow {\n  min-height: 0;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__player--hr-trend {\n  min-height: 0;\n}\n\n.lt-kot-arena--portrait .lt-kot-arena__player--hr-trend .lt-hr-trend-panel__chart-grow {\n  min-height: 120px;\n}\n\n.lt-kot-arena__player--hr-trend .lt-kot-arena__live-score {\n  display: none;\n}\n\n@media (max-height: 740px) {\n  .lt-header {\n    padding: 6px 12px;\n  }\n\n  .lt-progress {\n    padding: 0 12px 6px;\n  }\n\n  .lt-progress__segments {\n    margin-top: 4px;\n  }\n\n  .lt-page__main {\n    padding: 4px 12px 8px;\n  }\n\n  .lt-hero__ring-wrap {\n    width: 120px;\n    height: 120px;\n    margin-bottom: 8px;\n  }\n\n  .lt-hero__timer-value {\n    font-size: 1.5rem;\n  }\n\n  .lt-hero__name {\n    font-size: 1rem;\n    margin-bottom: 6px;\n  }\n\n  .lt-hero__sequences {\n    margin-bottom: 6px;\n    gap: 4px;\n  }\n\n  .lt-hero__seq-pill {\n    width: 22px;\n    height: 22px;\n    font-size: 0.68rem;\n  }\n\n  .lt-hero__exercise-remaining {\n    margin: 0 auto 8px;\n    padding: 3px 10px;\n  }\n\n  .lt-hero__seq-banner {\n    margin-bottom: 6px;\n    padding: 3px 10px;\n  }\n\n  .lt-coach-bar {\n    padding: 8px 10px;\n    gap: 6px;\n  }\n\n  .lt-page:not(.lt-page--landscape) .lt-coach-bar {\n    padding-bottom: max(8px, env(safe-area-inset-bottom));\n  }\n\n  .lt-coach-bar__btn {\n    padding: 8px 6px;\n    font-size: 0.74rem;\n    border-radius: 10px;\n  }\n\n  .lt-coach-bar__seq-nav {\n    padding: 5px 12px 5px;\n  }\n}\n\n@media (max-height: 620px) {\n  .lt-progress__meta {\n    margin-bottom: 3px;\n  }\n\n  .lt-progress__segments {\n    display: none;\n  }\n\n  .lt-hero__ring-wrap {\n    width: 96px;\n    height: 96px;\n    margin-bottom: 4px;\n  }\n\n  .lt-hero__timer-value {\n    font-size: 1.25rem;\n  }\n\n  .lt-hero__timer-state {\n    font-size: 0.58rem;\n  }\n\n  .lt-hero__name {\n    font-size: 0.9rem;\n    margin-bottom: 4px;\n  }\n\n  .lt-hero__seq-pill {\n    width: 18px;\n    height: 18px;\n    font-size: 0.6rem;\n  }\n\n  .lt-club-logo-wrap--bar {\n    max-height: 40px;\n  }\n}\n\n@media (min-width: 769px) {\n  .lt-return-fab {\n    display: none;\n  }\n}\n\n.lt-page__chrono-review {\n  display: flex;\n  justify-content: center;\n  padding: 8px 12px 16px;\n}\n\n.lt-player-chrono-review {\n  min-height: 40px;\n  padding: 8px 14px;\n}\n\n.lt-hero__pending {\n  margin: 6px 0 0;\n  font-size: 0.78rem;\n  font-weight: 650;\n  letter-spacing: 0.02em;\n  color: #fbbf24;\n}\n\n.lt-hero__listen {\n  margin-top: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: transparent;\n  color: rgba(248, 250, 252, 0.85);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font: inherit;\n  font-size: 0.78rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.lt-hero__listen.is-on {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 55%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n  color: #fff;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
